(function () {
  "use strict";
  function stripOseidParam() {
    try {
      const url = new URL(window.location.href);
      url.searchParams.has("oseid") &&
        (url.searchParams.delete("oseid"),
        window.history &&
          window.history.replaceState &&
          window.history.replaceState(
            null,
            "",
            url.pathname + url.search + url.hash,
          ));
    } catch {}
  }
  stripOseidParam();
  const EXPO_OUT = [0.22, 1, 0.36, 1];
  function debounce(fn, ms) {
    let t;
    return (...args) => {
      (clearTimeout(t), (t = setTimeout(() => fn(...args), ms)));
    };
  }
  // v46 20261018 (099 2f, ENGINE-CONTRACT §6.8) — every storefront request in this file goes through
  // window.dnRoute (defined once in dn-free-shipping-progress-v6.js, head, sync) so the market prefix
  // (/en-eu/...) is kept and /cart.js reads the cart of the market the visitor is on. If the helper is
  // missing the request goes to the shop root, i.e. exactly what v45 requested.
  function route(path) {
    return typeof window.dnRoute === "function" ? window.dnRoute(path) : "/" + path;
  }
  // Path segment used only to recognise product links in already-rendered markup (selectors / split),
  // not to build a request; product URLs keep this segment under every market prefix.
  const PRODUCT_PATH_SEG = "/products/";
  function formatMoneyFromSample(cents, sample) {
    sample = String(sample || "");
    var numeric = sample.match(/[\d.,]+/);
    if (!numeric) return "";
    var amount = Math.abs(Number(cents) || 0) / 100,
      decimalMatch = numeric[0].match(/([,.])\d{2}$/);
    if (!decimalMatch) return "";
    var decimalSep = decimalMatch[1],
      thousandsSep = decimalSep === "," ? "." : ",",
      parts = amount.toFixed(2).split("."),
      integer = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep),
      prefix = sample.slice(0, numeric.index),
      suffix = sample.slice(numeric.index + numeric[0].length);
    return (
      (Number(cents) < 0 ? "-" : "") +
      prefix +
      integer +
      decimalSep +
      parts[1] +
      suffix
    );
  }
  function formatThemeMoney(cents) {
    cents = Number(cents) || 0;
    var sample = window.theme && window.theme.moneySample,
      sampled = formatMoneyFromSample(cents, sample);
    if (sampled) return sampled;
    var amount = cents / 100,
      currencyCode = (window.theme && window.theme.currencyCode) || "USD";
    try {
      return new Intl.NumberFormat(void 0, {
        style: "currency",
        currency: currencyCode,
        currencyDisplay: "narrowSymbol",
      }).format(amount);
    } catch {
      var symbol = (window.theme && window.theme.currencySymbol) || "$";
      return symbol + amount.toFixed(2).replace(/\.00$/, "");
    }
  }
  window.themeFormatMoney = formatThemeMoney;
  function getBundleUnitPriceCents(container) {
    if (!container) return 0;
    var cents = parseInt(container.dataset.unitPriceCents || "", 10);
    if (Number.isFinite(cents) && cents > 0) return cents;
    var raw = String(container.dataset.unitPrice || "").trim();
    if (!raw) return 0;
    raw = raw.replace(/[^\d.,-]/g, "");
    var lastComma = raw.lastIndexOf(","),
      lastDot = raw.lastIndexOf(".");
    lastComma >= 0 && lastDot >= 0
      ? (raw =
          lastComma > lastDot
            ? raw.replace(/\./g, "").replace(",", ".")
            : raw.replace(/,/g, ""))
      : lastComma >= 0 && (raw = raw.replace(",", "."));
    var amount = parseFloat(raw);
    return Number.isFinite(amount) ? Math.round(amount * 100) : 0;
  }
  const canHover = window.matchMedia(
    "(hover: hover) and (pointer: fine)",
  ).matches;
  function initScrollReveal() {
    const els = document.querySelectorAll(".reveal");
    if (!els.length) return;
    const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.isIntersecting &&
              (entry.target.classList.add("is-visible"),
              setTimeout(
                () => entry.target.classList.remove("reveal-pending"),
                900,
              ),
              observer.unobserve(entry.target));
          });
        },
        { threshold: 0.1, rootMargin: "-40px" },
      ),
      vh = window.innerHeight || document.documentElement.clientHeight || 800;
    els.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < vh * 1.15 && rect.bottom > -80) {
        el.classList.add("is-visible");
        return;
      }
      (el.classList.add("reveal-pending"), observer.observe(el));
    });
  }
  function initScrollHoverGuard() {
    const root = document.documentElement;
    if (root.dataset.dnScrollHoverGuard === "1") return;
    root.dataset.dnScrollHoverGuard = "1";
    let scrollTimer;
    window.addEventListener(
      "scroll",
      function () {
        (root.classList.add("dn-scrolling"),
          clearTimeout(scrollTimer),
          (scrollTimer = setTimeout(function () {
            root.classList.remove("dn-scrolling");
          }, 180)));
      },
      { passive: !0 },
    );
  }
  function initStickyHeader() {
    const header = document.querySelector(".site-header");
    if (!header) return;
    const isHome =
      window.location.pathname === "/" ||
      document.body.dataset.template === "index";
    function update() {
      const scrolled = window.scrollY > 60;
      (header.classList.toggle("site-header--transparent", isHome && !scrolled),
        header.classList.toggle("site-header--scrolled", isHome && scrolled),
        header.classList.toggle("site-header--dark", !isHome));
    }
    (update(), window.addEventListener("scroll", update, { passive: !0 }));
  }
  function initNavOverlay() {
    const overlay = document.getElementById("nav-overlay"),
      openBtn = document.getElementById("nav-open"),
      closeBtn = document.getElementById("nav-close");
    if (!overlay || !openBtn) return;
    function open() {
      (overlay.classList.add("is-open"),
        document.body.classList.add("no-scroll"));
    }
    function close() {
      (overlay.classList.remove("is-open"),
        document.body.classList.remove("no-scroll"));
    }
    (openBtn.addEventListener("click", open),
      closeBtn && closeBtn.addEventListener("click", close),
      overlay
        .querySelectorAll("a")
        .forEach((a) => a.addEventListener("click", close)));
  }
  function initHeaderMenuFallback() {
    const skipTitles = new Set(["shop all", "our story", "journal"]),
      norm = (value) =>
        String(value || "")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();
    function titleFromNode(node) {
      if (!node) return "";
      const link =
        node.matches && node.matches("a, summary")
          ? node
          : node.querySelector("a, summary");
      return norm(link ? link.textContent : node.textContent);
    }
    function removeSkippedDirectItems(container) {
      Array.from(container.children).forEach((child) => {
        skipTitles.has(titleFromNode(child)) && child.remove();
      });
    }
    function normalizeDesktopNav() {
      const nav = document.querySelector(".site-header__nav");
      if (!nav || nav.dataset.dnMenuFallback === "1") return;
      const collectionItem = Array.from(nav.children).find(
        (child) => titleFromNode(child) === "collections",
      );
      if (!collectionItem) {
        (removeSkippedDirectItems(nav), (nav.dataset.dnMenuFallback = "1"));
        return;
      }
      const categoryLinks = Array.from(
          collectionItem.querySelectorAll(".site-header__dropdown-link"),
        )
          .filter(
            (link) => !/^all\s+collections?$/i.test(link.textContent.trim()),
          )
          .map((link) => {
            const clone = link.cloneNode(!0);
            return (
              (clone.className = "site-header__nav-link"),
              clone.removeAttribute("role"),
              clone
            );
          }),
        insertAfter = Array.from(nav.children).find(
          (child) => titleFromNode(child) === "new arrivals",
        );
      (collectionItem.remove(),
        removeSkippedDirectItems(nav),
        categoryLinks.reverse().forEach((link) => {
          insertAfter && insertAfter.parentNode === nav
            ? insertAfter.after(link)
            : nav.appendChild(link);
        }),
        (nav.dataset.dnMenuFallback = "1"));
    }
    function normalizeOverlayNav() {
      const nav = document.querySelector("#nav-overlay nav");
      if (!nav || nav.dataset.dnMenuFallback === "1") return;
      const collectionGroup = Array.from(nav.children).find(
        (child) => titleFromNode(child) === "collections",
      );
      if (!collectionGroup) {
        (removeSkippedDirectItems(nav), (nav.dataset.dnMenuFallback = "1"));
        return;
      }
      const categoryLinks = Array.from(
          collectionGroup.querySelectorAll(".nav-overlay__sublink"),
        )
          .filter(
            (link) => !/^all\s+collections?$/i.test(link.textContent.trim()),
          )
          .map((link) => {
            const clone = link.cloneNode(!0);
            return ((clone.className = "nav-overlay__link"), clone);
          }),
        insertAfter = Array.from(nav.children).find(
          (child) => titleFromNode(child) === "new arrivals",
        );
      (collectionGroup.remove(),
        removeSkippedDirectItems(nav),
        categoryLinks.reverse().forEach((link) => {
          insertAfter && insertAfter.parentNode === nav
            ? insertAfter.after(link)
            : nav.appendChild(link);
        }),
        (nav.dataset.dnMenuFallback = "1"));
    }
    (normalizeDesktopNav(), normalizeOverlayNav());
  }
  function initHeroCarousel() {
    const hero = document.querySelector(".hero");
    if (!hero) return;
    if (hero.__dnHeroLifecycle) {
      hero.__dnHeroLifecycle.refresh();
      return;
    }
    const slides = Array.from(hero.querySelectorAll(".hero__slide")),
      dots = Array.from(hero.querySelectorAll(".hero__counter-dot"));
    if (!slides.length) return;
    const motion = window.DNMotionLifecycle,
      textEls = {
        subtitle: hero.querySelector("[data-hero-subtitle]"),
        subtitleRow: hero.querySelector("[data-hero-subtitle-row]"),
        line1: hero.querySelector("[data-hero-line1]"),
        accent: hero.querySelector("[data-hero-accent]"),
        line2: hero.querySelector("[data-hero-line2]"),
        cta: hero.querySelector("[data-hero-cta]"),
      },
      HERO_EXPO = "cubic-bezier(0.22, 1, 0.36, 1)",
      debug = {
        timerStarts: 0,
        transitionCount: 0,
        pauseCount: 0,
        resumeCount: 0,
        listenerInstalls: 1,
        observerInstalls: 0,
      };
    let current = Math.max(
        0,
        slides.findIndex(function (slide) {
          return slide.classList.contains("is-active");
        }),
      ),
      timer = null,
      inView = !0,
      destroyed = !1,
      motionState = motion
        ? motion.snapshot()
        : { active: document.visibilityState === "visible", reduced: !1 };
    const animations = new Set();
    function runAnimation(target, keyframes, options) {
      const animation = target.animate(keyframes, options),
        forget = function () {
          animations.delete(animation);
        };
      (animations.add(animation),
        animation.addEventListener("finish", forget, { once: !0 }),
        animation.addEventListener("cancel", forget, { once: !0 }));
      return animation;
    }
    function cancelAnimations() {
      (animations.forEach(function (animation) {
        try {
          animation.cancel();
        } catch (e) {}
      }),
        animations.clear());
    }
    function active() {
      return !destroyed && motionState.active && inView && slides.length > 1;
    }
    function syncText(slide) {
      if (!slide) return;
      const vals = {
        subtitle: slide.getAttribute("data-subtitle") || "",
        line1: slide.getAttribute("data-line1") || "",
        accent: slide.getAttribute("data-accent") || "",
        line2: slide.getAttribute("data-line2") || "",
      };
      Object.keys(vals).forEach(function (key) {
        const el = textEls[key];
        if (!el) return;
        el.textContent = vals[key];
        if (key === "subtitle" && textEls.subtitleRow)
          textEls.subtitleRow.hidden = !vals[key];
        if (key === "accent") el.style.display = vals[key] ? "" : "none";
        el.style.opacity = "";
        el.style.transform = "";
      });
      if (textEls.cta)
        textEls.cta.setAttribute(
          "href",
          slide.getAttribute("data-cta-link") || "/collections",
        );
    }
    function settle() {
      slides.forEach(function (slide, index) {
        const selected = index === current;
        slide.classList.toggle("is-active", selected);
        slide.style.opacity = selected ? "1" : "0";
        slide.style.transform = "scale(1)";
        slide.style.filter = "";
        slide.style.zIndex = selected ? "1" : "0";
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle("is-active", index === current);
      });
      syncText(slides[current]);
    }
    function clearTimer() {
      if (timer !== null) {
        clearTimeout(timer);
        timer = null;
      }
    }
    function schedule() {
      clearTimer();
      if (!active()) return;
      debug.timerStarts += 1;
      timer = setTimeout(function () {
        timer = null;
        if (!active()) return;
        goTo(current + 1, !0);
        schedule();
      }, 4500);
    }
    function maskedLine(el, val, enterDelay, isAccent) {
      if (!el) return;
      val = val || "";
      if (el.textContent === val) return;
      runAnimation(
        el,
        [{ transform: "translateY(0)" }, { transform: "translateY(-120%)" }],
        { duration: 320, easing: HERO_EXPO, fill: "forwards" },
      ).onfinish = function () {
        if (destroyed) return;
        el.textContent = val;
        if (isAccent) el.style.display = val ? "" : "none";
        runAnimation(
          el,
          [{ transform: "translateY(105%)" }, { transform: "translateY(0)" }],
          {
            duration: 620,
            delay: enterDelay,
            easing: HERO_EXPO,
            fill: "forwards",
          },
        );
      };
    }
    function subtitleSwap(el, row, val) {
      if (!el) return;
      val = val || "";
      const wasHidden = !!(row && row.hidden);
      if (!val) {
        el.textContent = "";
        el.style.opacity = "";
        el.style.transform = "";
        if (row) row.hidden = !0;
        return;
      }
      if (row) row.hidden = !1;
      if (el.textContent === val) return;
      if (wasHidden || !el.textContent) {
        el.textContent = val;
        runAnimation(
          el,
          [
            { opacity: 0, transform: "translateX(-18px)" },
            { opacity: 1, transform: "translateX(0)" },
          ],
          { duration: 460, easing: HERO_EXPO, fill: "forwards" },
        );
        return;
      }
      runAnimation(
        el,
        [
          { opacity: 1, transform: "translateX(0)" },
          { opacity: 0, transform: "translateX(18px)" },
        ],
        { duration: 240, easing: HERO_EXPO, fill: "forwards" },
      ).onfinish = function () {
        if (destroyed) return;
        el.textContent = val;
        runAnimation(
          el,
          [
            { opacity: 0, transform: "translateX(-18px)" },
            { opacity: 1, transform: "translateX(0)" },
          ],
          { duration: 460, delay: 60, easing: HERO_EXPO, fill: "forwards" },
        );
      };
    }
    function swapText(slide) {
      (subtitleSwap(
        textEls.subtitle,
        textEls.subtitleRow,
        slide.getAttribute("data-subtitle"),
      ),
        maskedLine(textEls.line1, slide.getAttribute("data-line1"), 0, !1),
        maskedLine(textEls.accent, slide.getAttribute("data-accent"), 80, !0),
        maskedLine(textEls.line2, slide.getAttribute("data-line2"), 140, !1),
        textEls.cta &&
          textEls.cta.setAttribute(
            "href",
            slide.getAttribute("data-cta-link") || "/collections",
          ));
    }
    function goTo(index, animate) {
      index = ((index % slides.length) + slides.length) % slides.length;
      if (index === current) {
        if (!animate) settle();
        return;
      }
      const oldEl = slides[current],
        newEl = slides[index];
      cancelAnimations();
      current = index;
      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === current);
      });
      slides.forEach(function (slide, i) {
        slide.classList.toggle("is-active", i === current);
        slide.style.zIndex = i === current ? "1" : "0";
      });
      if (!animate || !active()) {
        settle();
        return;
      }
      debug.transitionCount += 1;
      swapText(newEl);
      oldEl.style.opacity = "1";
      oldEl.style.transform = "scale(1)";
      newEl.style.opacity = "0";
      newEl.style.transform = "scale(1.035)";
      let finished = 0;
      function finish() {
        finished += 1;
        if (finished === 2 && !destroyed) settle();
      }
      runAnimation(
        oldEl,
        [
          { opacity: 1, transform: "scale(1)" },
          { opacity: 0, transform: "scale(1.025)" },
        ],
        { duration: 650, easing: HERO_EXPO, fill: "forwards" },
      ).onfinish = finish;
      runAnimation(
        newEl,
        [
          { opacity: 0, transform: "scale(1.035)" },
          { opacity: 1, transform: "scale(1)" },
        ],
        { duration: 850, delay: 90, easing: HERO_EXPO, fill: "forwards" },
      ).onfinish = finish;
    }
    function pause() {
      const hadTimer = timer !== null;
      clearTimer();
      cancelAnimations();
      settle();
      if (hadTimer) debug.pauseCount += 1;
    }
    function refresh() {
      if (active()) {
        debug.resumeCount += 1;
        schedule();
      } else pause();
    }
    dots.forEach(function (dot, index) {
      dot.addEventListener("click", function () {
        goTo(index, active());
        schedule();
      });
    });
    let observer = null;
    if ("IntersectionObserver" in window) {
      debug.observerInstalls = 1;
      observer = new IntersectionObserver(
        function (entries) {
          const entry = entries[entries.length - 1];
          inView = !!(
            entry &&
            entry.isIntersecting &&
            entry.intersectionRatio > 0
          );
          refresh();
        },
        { threshold: [0, 0.05] },
      );
      observer.observe(hero);
    } else inView = !0;
    const rect = hero.getBoundingClientRect();
    inView =
      rect.bottom > 0 &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight);
    const unsubscribe = motion
      ? motion.subscribe(function (next) {
          motionState = next;
          refresh();
        })
      : function () {};
    function destroy() {
      if (destroyed) return;
      destroyed = !0;
      clearTimer();
      cancelAnimations();
      settle();
      if (observer) observer.disconnect();
      unsubscribe();
      delete hero.__dnHeroLifecycle;
    }
    hero.__dnHeroLifecycle = {
      refresh: refresh,
      destroy: destroy,
      isInView: function () {
        return inView;
      },
      debug: function () {
        return Object.assign({}, debug, {
          activeTimer: timer !== null,
          activeAnimations: animations.size,
          inView: inView,
          current: current,
          active: active(),
        });
      },
    };
    settle();
    refresh();
  }
  function initHeroParallax() {
    const hero = document.querySelector(".hero");
    if (!hero) return;
    if (hero.__dnHeroParallax) {
      hero.__dnHeroParallax.refresh();
      return;
    }
    const content = hero.querySelector(".hero__content");
    if (!content) return;
    const motion = window.DNMotionLifecycle;
    let motionState = motion
        ? motion.snapshot()
        : { active: document.visibilityState === "visible", reduced: !1 },
      inView = !0,
      running = !1,
      raf = null,
      destroyed = !1;
    function shouldRun() {
      return !destroyed && motionState.active && inView;
    }
    function update() {
      raf = null;
      if (!shouldRun()) return;
      const rect = hero.getBoundingClientRect(),
        h = rect.height || 1;
      let progress = -rect.top / h;
      progress = Math.max(0, Math.min(1, progress));
      content.style.transform = "translateY(" + progress * 35 + "%)";
    }
    function onScroll() {
      if (!shouldRun() || raf !== null) return;
      raf = requestAnimationFrame(update);
    }
    function start() {
      if (running || !shouldRun()) return;
      running = !0;
      content.style.willChange = "transform";
      window.addEventListener("scroll", onScroll, { passive: !0 });
      window.addEventListener("resize", onScroll, { passive: !0 });
      onScroll();
    }
    function stop() {
      if (running) {
        window.removeEventListener("scroll", onScroll);
        window.removeEventListener("resize", onScroll);
        running = !1;
      }
      if (raf !== null) {
        cancelAnimationFrame(raf);
        raf = null;
      }
      content.style.willChange = "";
      if (motionState.reduced) content.style.transform = "";
    }
    function refresh() {
      shouldRun() ? start() : stop();
    }
    let observer = null;
    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(
        function (entries) {
          const entry = entries[entries.length - 1];
          inView = !!(
            entry &&
            entry.isIntersecting &&
            entry.intersectionRatio > 0
          );
          refresh();
        },
        { threshold: [0, 0.05] },
      );
      observer.observe(hero);
    }
    const rect = hero.getBoundingClientRect();
    inView =
      rect.bottom > 0 &&
      rect.top < (window.innerHeight || document.documentElement.clientHeight);
    const unsubscribe = motion
      ? motion.subscribe(function (next) {
          motionState = next;
          refresh();
        })
      : function () {};
    function destroy() {
      if (destroyed) return;
      destroyed = !0;
      stop();
      if (observer) observer.disconnect();
      unsubscribe();
      delete hero.__dnHeroParallax;
    }
    hero.__dnHeroParallax = {
      refresh: refresh,
      destroy: destroy,
      debug: function () {
        return { running: running, inView: inView, rafActive: raf !== null };
      },
    };
    refresh();
  }
  function initMarquee() {
    document.querySelectorAll(".marquee__track").forEach(function (track) {
      if (track.__dnMarqueeLifecycle) {
        track.__dnMarqueeLifecycle.refresh();
        return;
      }
      Array.from(track.children)
        .filter(function (child) {
          return !child.hasAttribute("data-dn-marquee-clone");
        })
        .forEach(function (child) {
          const clone = child.cloneNode(!0);
          clone.setAttribute("data-dn-marquee-clone", "true");
          clone.setAttribute("aria-hidden", "true");
          track.appendChild(clone);
        });
      const motion = window.DNMotionLifecycle,
        host = track.closest(".marquee") || track;
      let motionState = motion
          ? motion.snapshot()
          : { active: document.visibilityState === "visible", reduced: !1 },
        inView = !0,
        destroyed = !1;
      function refresh() {
        const paused = destroyed || !motionState.active || !inView;
        track.classList.toggle("dn-motion-paused", paused);
        track.classList.toggle("dn-motion-static", !!motionState.reduced);
        track.setAttribute(
          "data-dn-motion",
          motionState.reduced ? "static" : paused ? "paused" : "running",
        );
      }
      let observer = null;
      if ("IntersectionObserver" in window) {
        observer = new IntersectionObserver(
          function (entries) {
            const entry = entries[entries.length - 1];
            inView = !!(
              entry &&
              entry.isIntersecting &&
              entry.intersectionRatio > 0
            );
            refresh();
          },
          { threshold: [0, 0.01] },
        );
        observer.observe(host);
      }
      const rect = host.getBoundingClientRect();
      inView =
        rect.bottom > 0 &&
        rect.top <
          (window.innerHeight || document.documentElement.clientHeight);
      const unsubscribe = motion
        ? motion.subscribe(function (next) {
            motionState = next;
            refresh();
          })
        : function () {};
      function destroy() {
        if (destroyed) return;
        destroyed = !0;
        if (observer) observer.disconnect();
        unsubscribe();
        track.classList.remove("dn-motion-paused", "dn-motion-static");
        delete track.__dnMarqueeLifecycle;
      }
      track.__dnMarqueeLifecycle = {
        refresh: refresh,
        destroy: destroy,
        debug: function () {
          return {
            inView: inView,
            paused: track.classList.contains("dn-motion-paused"),
            static: track.classList.contains("dn-motion-static"),
          };
        },
      };
      refresh();
    });
  }
  function initAccordions() {
    document
      .querySelectorAll(".accordion, .footer-accordion")
      .forEach((acc) => {
        const btn = acc.querySelector(
            ".accordion__header, .footer-accordion__btn",
          ),
          body = acc.querySelector(".accordion__body, .footer-accordion__body");
        if (
          !(!btn || !body) &&
          (btn.addEventListener("click", () => {
            if (acc.classList.contains("is-open"))
              ((body.style.maxHeight = body.scrollHeight + "px"),
                body.offsetHeight,
                (body.style.maxHeight = "0"),
                acc.classList.remove("is-open"));
            else {
              ((body.style.maxHeight = body.scrollHeight + "px"),
                acc.classList.add("is-open"));
              const onEnd = (e) => {
                e.propertyName === "max-height" &&
                  (acc.classList.contains("is-open") &&
                    (body.style.maxHeight = "none"),
                  body.removeEventListener("transitionend", onEnd));
              };
              body.addEventListener("transitionend", onEnd);
            }
          }),
          acc.dataset.defaultOpen === "true")
        ) {
          acc.classList.add("is-open");
          const prevTransition = body.style.transition;
          ((body.style.transition = "none"),
            (body.style.maxHeight = "none"),
            body.offsetHeight,
            (body.style.transition = prevTransition));
        }
      });
  }
  function initLookbookHotspots() {
    const section = document.querySelector(".lookbook");
    if (!section) return;
    const hotspots = section.querySelectorAll(".hotspot"),
      sheet = section.querySelector(".lookbook-sheet");
    if (!sheet) return;
    const els = {
      name: sheet.querySelector("[data-lookbook-name]"),
      price: sheet.querySelector("[data-lookbook-price]"),
      color: sheet.querySelector("[data-lookbook-color]"),
      link: sheet.querySelector("[data-lookbook-link]"),
      view: sheet.querySelector("[data-lookbook-view]"),
      status: sheet.querySelector("[data-lookbook-status]"),
      colorsWrap: sheet.querySelector("[data-lookbook-colors]"),
      swatches: sheet.querySelector("[data-lookbook-swatches]"),
      sizeWrap: sheet.querySelector("[data-lookbook-size-wrap]"),
      sizes: sheet.querySelector("[data-lookbook-sizes]"),
      add: sheet.querySelector("[data-lookbook-add]"),
      addText: sheet.querySelector("[data-lookbook-add-text]"),
      close: sheet.querySelector("[data-lookbook-close]"),
    };
    var CACHE = {},
      PENDING = {},
      state = null,
      selVariant = null;
    function money(c) {
      return formatMoney(c);
    }
    function handleFromUrl(u) {
      var m = (u || "").match(/\/products\/([^\/?#]+)/);
      return m ? m[1] : "";
    }
    function setStatus(m) {
      els.status &&
        ((els.status.textContent = m || ""),
        (els.status.style.display = m ? "block" : "none"));
    }
    function prefetch(handle) {
      !handle ||
        CACHE[handle] ||
        PENDING[handle] ||
        ((PENDING[handle] = 1),
        fetch(route("products/" + handle + ".js"), {
          headers: { Accept: "application/json" },
        })
          .then(function (r) {
            return r.ok ? r.json() : null;
          })
          .then(function (p) {
            (p && (CACHE[handle] = p), delete PENDING[handle]);
          })
          .catch(function () {
            delete PENDING[handle];
          }));
    }
    function avail(color, size) {
      return state.product.variants.some(function (v) {
        return (
          (state.colorIdx < 0 || v.options[state.colorIdx] === color) &&
          (state.sizeIdx < 0 || v.options[state.sizeIdx] === size) &&
          v.available
        );
      });
    }
    function findVariant() {
      return (
        (state &&
          state.product.variants.find(function (v) {
            return (
              (state.colorIdx < 0 ||
                v.options[state.colorIdx] === state.selColor) &&
              (state.sizeIdx < 0 || v.options[state.sizeIdx] === state.selSize)
            );
          })) ||
        null
      );
    }
    function sync() {
      if (
        state &&
        ((selVariant = findVariant()),
        els.price &&
          (els.price.textContent = money(
            selVariant ? selVariant.price : state.product.price,
          )),
        els.color &&
          state.colorIdx >= 0 &&
          (els.color.textContent = state.selColor || ""),
        els.swatches &&
          [].forEach.call(els.swatches.children, function (b) {
            b.style.outline =
              b.dataset.color === state.selColor
                ? "2px solid var(--color-primary)"
                : "none";
          }),
        state.sizeIdx >= 0 &&
          els.sizes &&
          [].forEach.call(els.sizes.children, function (b) {
            var sz = b.dataset.size,
              av = avail(state.selColor, sz),
              sel = sz === state.selSize;
            ((b.disabled = !av),
              (b.style.opacity = av ? "1" : "0.35"),
              (b.style.textDecoration = av ? "none" : "line-through"),
              (b.style.background = sel
                ? "var(--color-primary)"
                : "transparent"),
              (b.style.color = sel
                ? "var(--color-bg)"
                : "var(--color-primary)"),
              (b.style.borderColor = sel
                ? "var(--color-primary)"
                : "var(--color-border)"));
          }),
        els.add)
      ) {
        var needSize = state.sizeIdx >= 0 && !state.selSize,
          ok = selVariant && selVariant.available;
        ((els.add.style.display = "flex"),
          (els.add.disabled = !ok),
          els.addText &&
            (els.addText.textContent = needSize
              ? "Select a size"
              : ok
                ? "Add to Cart"
                : "Sold Out"));
      }
    }
    function render(p) {
      if (
        ((state = {
          product: p,
          colorIdx: -1,
          sizeIdx: -1,
          selColor: null,
          selSize: null,
        }),
        (p.options || []).forEach(function (n, i) {
          var nm = typeof n == "string" ? n : (n && n.name) || "";
          /colou?r/i.test(nm)
            ? (state.colorIdx = i)
            : /size/i.test(nm) && (state.sizeIdx = i);
        }),
        els.name && (els.name.textContent = p.title || ""),
        els.link && els.link.setAttribute("href", p.url || "#"),
        els.view &&
          (els.view.setAttribute("href", p.url || "#"),
          (els.view.style.display = p.url ? "block" : "none")),
        state.colorIdx >= 0 && els.swatches && els.colorsWrap)
      ) {
        var seen = {},
          colors = [];
        (p.variants.forEach(function (v) {
          var c = v.options[state.colorIdx];
          seen[c] ||
            ((seen[c] = 1),
            colors.push({
              name: c,
              img:
                (v.featured_image && v.featured_image.src) ||
                p.featured_image ||
                "",
            }));
        }),
          (state.selColor = (
            colors.find(function (c) {
              return p.variants.some(function (v) {
                return v.options[state.colorIdx] === c.name && v.available;
              });
            }) || colors[0]
          ).name),
          (els.swatches.innerHTML = colors
            .map(function (c) {
              var bg = c.img
                ? "center/cover url('" + c.img + "')"
                : "var(--color-surface)";
              return (
                '<button type="button" data-color="' +
                String(c.name).replace(/"/g, "&quot;") +
                '" title="' +
                String(c.name).replace(/"/g, "&quot;") +
                '" style="width:2rem;height:2rem;border-radius:50%;border:1px solid var(--color-border);background:' +
                bg +
                ';outline-offset:2px;cursor:pointer;flex-shrink:0;padding:0;"></button>'
              );
            })
            .join("")),
          [].forEach.call(els.swatches.children, function (b) {
            b.addEventListener("click", function () {
              ((state.selColor = b.dataset.color), sync());
            });
          }),
          (els.colorsWrap.style.display = ""));
      } else els.colorsWrap && (els.colorsWrap.style.display = "none");
      if (state.sizeIdx >= 0 && els.sizes && els.sizeWrap) {
        var seenS = {},
          sizes = [];
        (p.variants.forEach(function (v) {
          var s = v.options[state.sizeIdx];
          seenS[s] || ((seenS[s] = 1), sizes.push(s));
        }),
          (els.sizes.innerHTML = sizes
            .map(function (s) {
              return (
                '<button type="button" data-size="' +
                String(s).replace(/"/g, "&quot;") +
                '" style="min-width:2.5rem;padding:0.4rem 0.6rem;border:1px solid var(--color-border);background:transparent;font-family:var(--font-body);font-size:0.75rem;cursor:pointer;border-radius:2px;color:var(--color-primary);">' +
                s +
                "</button>"
              );
            })
            .join("")),
          [].forEach.call(els.sizes.children, function (b) {
            b.addEventListener("click", function () {
              b.disabled || ((state.selSize = b.dataset.size), sync());
            });
          }),
          (els.sizeWrap.style.display = ""));
      } else els.sizeWrap && (els.sizeWrap.style.display = "none");
      (setStatus(""), sync());
    }
    function openFor(hs) {
      (sheet.classList.add("is-open"),
        ["name", "color", "price"].forEach(function (k) {
          els[k] && (els[k].textContent = "");
        }),
        els.colorsWrap && (els.colorsWrap.style.display = "none"),
        els.sizeWrap && (els.sizeWrap.style.display = "none"),
        els.add && (els.add.style.display = "none"),
        els.view && (els.view.style.display = "none"),
        (state = null),
        (selVariant = null));
      var handle = handleFromUrl(hs.dataset.url);
      if (!handle) {
        setStatus("No product link set for this hotspot.");
        return;
      }
      if (CACHE[handle]) {
        render(CACHE[handle]);
        return;
      }
      (setStatus("Loading\u2026"),
        fetch(route("products/" + handle + ".js"), {
          headers: { Accept: "application/json" },
        })
          .then(function (r) {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then(function (p) {
            ((CACHE[handle] = p), render(p));
          })
          .catch(function () {
            setStatus("Product unavailable.");
          }));
    }
    (hotspots.forEach(function (hs) {
      (hs.addEventListener("click", function () {
        var isActive = hs.classList.contains("is-active");
        (hotspots.forEach(function (h) {
          h.classList.remove("is-active");
        }),
          isActive
            ? sheet.classList.remove("is-open")
            : (hs.classList.add("is-active"), openFor(hs)));
      }),
        hs.addEventListener("mouseenter", function () {
          prefetch(handleFromUrl(hs.dataset.url));
        }));
    }),
      (
        window.requestIdleCallback ||
        function (f) {
          return setTimeout(f, 1200);
        }
      )(function () {
        hotspots.forEach(function (hs) {
          prefetch(handleFromUrl(hs.dataset.url));
        });
      }),
      els.close &&
        els.close.addEventListener("click", function () {
          (hotspots.forEach(function (h) {
            h.classList.remove("is-active");
          }),
            sheet.classList.remove("is-open"));
        }),
      els.add &&
        els.add.addEventListener("click", function () {
          if (!(!selVariant || !selVariant.available)) {
            els.add.disabled = !0;
            var prev = els.addText ? els.addText.textContent : "Add to Cart";
            (els.addText && (els.addText.textContent = "Adding\u2026"),
              fetch(route("cart/add.js"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: selVariant.id, quantity: 1 }),
              })
                .then(function (r) {
                  return r.json();
                })
                .then(function (d) {
                  if (d && d.status) throw new Error("add");
                  els.addText && (els.addText.textContent = "Added \u2713");
                  try {
                    CartDrawer.open();
                  } catch {}
                  setTimeout(function () {
                    (els.addText &&
                      (els.addText.textContent = prev || "Add to Cart"),
                      (els.add.disabled = !1));
                  }, 1400);
                })
                .catch(function () {
                  (els.addText && (els.addText.textContent = "Try again"),
                    setTimeout(function () {
                      (els.addText &&
                        (els.addText.textContent = prev || "Add to Cart"),
                        (els.add.disabled = !1));
                    }, 1600));
                }));
          }
        }));
  }
  function initLookbookEditor() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    const section = document.querySelector(".lookbook");
    if (!section) return;
    const wrap = section.querySelector(".lookbook__image-wrap");
    if (!(!wrap || wrap.dataset.editorReady)) {
      ((wrap.dataset.editorReady = "1"),
        getComputedStyle(wrap).position === "static" &&
          (wrap.style.position = "relative"));
      var badge = document.createElement("div");
      ((badge.style.cssText =
        "position:absolute;z-index:40;background:#2D2D2D;color:#fff;font:11px/1.3 monospace;padding:4px 8px;border-radius:6px;pointer-events:none;white-space:nowrap;display:none;transform:translate(-50%,-150%);box-shadow:0 2px 8px rgba(0,0,0,.25);"),
        wrap.appendChild(badge));
      var hint = document.createElement("div");
      ((hint.textContent =
        "Drag a dot to read its X / Y, then type those numbers into the sliders (Shopify can\u2019t save a drag directly)."),
        (hint.style.cssText =
          "position:absolute;left:50%;bottom:10px;transform:translateX(-50%);z-index:40;background:rgba(45,45,45,0.9);color:#fff;font:11px/1.4 sans-serif;padding:5px 11px;border-radius:8px;pointer-events:none;max-width:90%;text-align:center;"),
        wrap.appendChild(hint),
        section.querySelectorAll(".hotspot").forEach(function (hs) {
          var dragging = !1,
            moved = !1;
          ((hs.style.cursor = "grab"),
            hs.addEventListener("pointerdown", function (e) {
              ((dragging = !0), (moved = !1), (hs.style.cursor = "grabbing"));
              try {
                hs.setPointerCapture(e.pointerId);
              } catch {}
            }),
            hs.addEventListener("pointermove", function (e) {
              if (dragging) {
                e.preventDefault();
                var r = wrap.getBoundingClientRect(),
                  x = Math.min(
                    100,
                    Math.max(0, ((e.clientX - r.left) / r.width) * 100),
                  ),
                  y = Math.min(
                    100,
                    Math.max(0, ((e.clientY - r.top) / r.height) * 100),
                  );
                ((hs.style.left = x.toFixed(1) + "%"),
                  (hs.style.top = y.toFixed(1) + "%"),
                  (badge.style.left = x + "%"),
                  (badge.style.top = y + "%"),
                  (badge.textContent =
                    "X " + Math.round(x) + "   Y " + Math.round(y)),
                  (badge.style.display = "block"),
                  (moved = !0));
              }
            }));
          function end(e) {
            if (dragging) {
              ((dragging = !1), (hs.style.cursor = "grab"));
              try {
                hs.releasePointerCapture(e.pointerId);
              } catch {}
            }
          }
          (hs.addEventListener("pointerup", end),
            hs.addEventListener("pointercancel", end),
            hs.addEventListener(
              "click",
              function (e) {
                moved &&
                  (e.stopImmediatePropagation(),
                  e.preventDefault(),
                  (moved = !1));
              },
              !0,
            ));
        }));
    }
  }
  // DUNIII cart price presentation contract:
  // Shopify's cart totals remain the source of truth. Shopify can expose an
  // automatic cart-level discount in line_price/total_discount while leaving
  // final_line_price unchanged; Bundle Functions can expose the inverse shape.
  // Normalize every cart row through one effective discounted-line helper so
  // the drawer supports both forms without duplicating discount calculations.
  // For the same product at the same original unit price, show one rounded
  // average unit price on every visible bundle row; any indivisible cent remains
  // represented by the exact Shopify subtotal/checkout total.
  function getItemEffectiveLineCents(item) {
    if (!item) return 0;
    const candidates = [],
      addCandidate = (value) => {
        if (value === void 0 || value === null || value === "") return;
        const cents = Number(value);
        Number.isFinite(cents) && candidates.push(Math.max(0, cents));
      };
    addCandidate(item.line_price);
    addCandidate(item.final_line_price);
    const originalLine = Number(item.original_line_price),
      totalDiscount = Number(item.total_discount);
    Number.isFinite(originalLine) &&
      Number.isFinite(totalDiscount) &&
      addCandidate(originalLine - Math.max(0, totalDiscount));
    return candidates.length ? Math.min(...candidates) : 0;
  }
  function getBundleDisplayGroupKey(item) {
    if (!item || !item.properties) return "";
    const label = String(item.properties.Bundle || "").trim();
    if (
      !label ||
      /^(free gift|gift wrap)$/i.test(label) ||
      /^upsell(?:\b|\s|\()/i.test(label)
    )
      return "";
    const dealId = String(item.properties._bundle_deal_id || "").trim(),
      barId = String(item.properties._bundle_bar_id || "").trim();
    if (dealId)
      return "deal:" + dealId + "|bar:" + (barId || label.toLowerCase());
    if (barId) return "bar:" + barId + "|label:" + label.toLowerCase();
    if (/^pair$/i.test(label)) return "legacy-pair:" + label.toLowerCase();
    return (
      "legacy-product:" +
      String(item.product_id || "unknown") +
      "|label:" +
      label.toLowerCase()
    );
  }
  // Shopify calculates a percentage discount against the whole eligible
  // bundle, then allocates indivisible cents across its lines. Use the same
  // largest-remainder allocation for PDP prices and cart-drawer prices.
  function allocateProportionalDiscountCents(originalLineCents, discountTotal) {
    const originals = (Array.isArray(originalLineCents)
        ? originalLineCents
        : []
      ).map((value) => Math.max(0, Math.round(Number(value) || 0))),
      originalTotal = originals.reduce((sum, value) => sum + value, 0),
      cappedDiscount = Math.min(
        originalTotal,
        Math.max(0, Math.round(Number(discountTotal) || 0)),
      );
    if (!originalTotal || !cappedDiscount)
      return originals.map(() => 0);
    const shares = originals.map((original, index) => {
      const numerator = cappedDiscount * original;
      return {
        index,
        discount: Math.floor(numerator / originalTotal),
        remainder: numerator % originalTotal,
      };
    });
    let remaining =
      cappedDiscount -
      shares.reduce((sum, share) => sum + share.discount, 0);
    shares
      .slice()
      .sort((a, b) => b.remainder - a.remainder || a.index - b.index)
      .forEach((share) => {
        if (remaining > 0) {
          shares[share.index].discount += 1;
          remaining -= 1;
        }
      });
    return shares.map((share) => share.discount);
  }
  // DUNIII_BUNDLE_PRICE_ALLOCATOR_START
  function allocateBundleDisplayLinePrices(items) {
    const displayPrices = new Map(),
      groups = new Map();
    (Array.isArray(items) ? items : []).forEach((item, index) => {
      displayPrices.set(item, getItemEffectiveLineCents(item));
      const groupKey = getBundleDisplayGroupKey(item);
      if (!groupKey) return;
      const explicitLineIndex = Number(
        item.properties && item.properties._bundle_line_index,
      );
      const entry = {
        item,
        index,
        allocationIndex: Number.isFinite(explicitLineIndex)
          ? explicitLineIndex
          : index,
        original: Math.max(0, Number(item.original_line_price) || 0),
        final: getItemEffectiveLineCents(item),
        quantity: Math.max(1, Number(item.quantity) || 1),
        productId: String(item.product_id || ""),
      };
      groups.has(groupKey)
        ? groups.get(groupKey).push(entry)
        : groups.set(groupKey, [entry]);
    });
    groups.forEach((entries) => {
      const originalTotal = entries.reduce(
          (sum, entry) => sum + entry.original,
          0,
        ),
        finalTotal = entries.reduce((sum, entry) => sum + entry.final, 0),
        discountTotal = Math.max(0, originalTotal - finalTotal);
      if (!originalTotal || !discountTotal) return;
      const productIds = new Set(entries.map((entry) => entry.productId)),
        hasWholeUnitOriginals = entries.every(
          (entry) => entry.original % entry.quantity === 0,
        ),
        unitOriginals = entries.map(
          (entry) => entry.original / entry.quantity,
        ),
        sameProduct = productIds.size === 1 && !productIds.has(""),
        sameOriginalUnit =
          hasWholeUnitOriginals &&
          unitOriginals.every((value) => value === unitOriginals[0]),
        totalQuantity = entries.reduce(
          (sum, entry) => sum + entry.quantity,
          0,
        );
      if (sameProduct && sameOriginalUnit && totalQuantity > 1) {
        const uniformUnitFinal = Math.round(finalTotal / totalQuantity);
        entries.forEach((entry) => {
          displayPrices.set(
            entry.item,
            Math.max(0, uniformUnitFinal * entry.quantity),
          );
        });
        return;
      }
      const allocationEntries = entries
          .slice()
          .sort(
            (a, b) =>
              a.allocationIndex - b.allocationIndex || a.index - b.index,
          ),
        allocatedDiscounts = allocateProportionalDiscountCents(
          allocationEntries.map((entry) => entry.original),
          discountTotal,
        );
      allocationEntries.forEach((entry, index) => {
        displayPrices.set(
          entry.item,
          Math.max(0, entry.original - allocatedDiscounts[index]),
        );
      });
    });
    return displayPrices;
  }
  // DUNIII_BUNDLE_PRICE_ALLOCATOR_END
  const CartDrawer = {
    drawer: null,
    backdrop: null,
    itemsContainer: null,
    countEls: null,
    subtotalEl: null,
    savingsEl: null,
    shippingFill: null,
    shippingText: null,
    emptyState: null,
    footerEl: null,
    comparePriceCache: Object.create(null),
    comparePriceLoading: Object.create(null),
    displayLinePrices: new Map(),
    // v45 (099 wave 2 m2e, hook 3) — state used only when the skin declares #cart-line-tpl
    // or [data-cart-sum] nodes (black declares neither).
    productJson: Object.create(null),
    lineErrors: Object.create(null),
    editOpen: Object.create(null),
    init() {
      ((this.drawer = document.getElementById("cart-drawer")),
        (this.backdrop = document.getElementById("cart-drawer-backdrop")),
        (this.itemsContainer = document.getElementById("cart-drawer-items")),
        (this.countEls = document.querySelectorAll("[data-cart-count]")),
        (this.subtotalEl = document.getElementById("cart-subtotal")),
        (this.savingsEl = document.getElementById("cart-savings")),
        (this.shippingFill = document.getElementById("shipping-fill")),
        (this.shippingText = document.getElementById("shipping-text")),
        (this.emptyState = document.getElementById("cart-empty")),
        (this.footerEl = document.getElementById("cart-drawer-footer")),
        this.drawer &&
          (document.querySelectorAll("[data-cart-open]").forEach((btn) => {
            btn.addEventListener("click", (e) => {
              (e.preventDefault(), this.open());
            });
          }),
          this.backdrop?.addEventListener("click", () => this.close()),
          document.querySelectorAll("[data-cart-close]").forEach((btn) => {
            btn.addEventListener("click", () => this.close());
          }),
          document.addEventListener("keydown", (e) => {
            e.key === "Escape" && this.close();
          }),
          this.itemsContainer?.addEventListener("click", (e) =>
            this.handleItemClick(e),
          ),
          this.refresh()));
    },
    // v46 (099 2f, ENGINE-CONTRACT §6.5) — empty-bag keep list declared by the skin on #cart-drawer
    // (data-cart-empty-keep="footer,recs,tier"). A declared part is not hidden on an empty bag; no
    // declaration (black) = the v45 behaviour. The engine itself only hides the footer; "recs" is read by
    // dn3-retained v4 and the skin, "tier" by the skin.
    emptyKeeps(part) {
      var v = this.drawer && this.drawer.getAttribute("data-cart-empty-keep");
      return !!v && ("," + v.replace(/\s+/g, "") + ",").indexOf("," + part + ",") > -1;
    },
    open() {
      (this.refresh && this.refresh(),
        this.drawer?.classList.add("is-open"),
        this.backdrop?.classList.add("is-open"),
        document.body.classList.add("no-scroll"),
        (this.animateOnOpen = !0),
        this.itemsContainer?.classList.add("cart-items-hidden"),
        this.refresh());
    },
    close() {
      (this.drawer?.classList.remove("is-open"),
        this.backdrop?.classList.remove("is-open"),
        document.body.classList.remove("no-scroll"),
        this.itemsContainer?.classList.remove(
          "cart-items-hidden",
          "cart-items-enter",
        ));
    },
    async refresh() {
      try {
        const cart = await (
          await fetch(route("cart.js"), { cache: "no-store" })
        ).json();
        this.render(cart);
      } catch (err) {
        console.error("Cart fetch error:", err);
      }
    },
    updateUrgency(count) {
      const el = document.getElementById("cart-urgency");
      if (!el) return;
      if (count === 0) {
        ((el.style.display = "none"),
          this._urgencyTick &&
            (clearInterval(this._urgencyTick), (this._urgencyTick = null)));
        try {
          sessionStorage.removeItem("duniii-cart-reserve");
        } catch {}
        return;
      }
      if (((el.style.display = ""), this._urgencyTick)) return;
      const RESERVE_MS = 600 * 1e3,
        timerEl = el.querySelector("[data-urgency-timer]"),
        getDeadline = () => {
          let d = 0;
          try {
            d = parseInt(
              sessionStorage.getItem("duniii-cart-reserve") || "0",
              10,
            );
          } catch {}
          if (!d || d - Date.now() <= 0 || d - Date.now() > RESERVE_MS) {
            d = Date.now() + RESERVE_MS;
            try {
              sessionStorage.setItem("duniii-cart-reserve", String(d));
            } catch {}
          }
          return d;
        },
        tick = () => {
          const left = Math.max(0, getDeadline() - Date.now()),
            m = Math.floor(left / 6e4),
            s = Math.floor((left % 6e4) / 1e3);
          if (
            (timerEl &&
              (timerEl.textContent = m + ":" + String(s).padStart(2, "0")),
            left <= 0)
          )
            try {
              sessionStorage.removeItem("duniii-cart-reserve");
            } catch {}
        };
      (tick(), (this._urgencyTick = setInterval(tick, 1e3)));
    },
    getItemCompareLineCents(item) {
      if (!item) return 0;
      const qty = Math.max(1, Number(item.quantity) || 1),
        finalLine = this.getItemDisplayFinalLineCents(item),
        originalLine = Number(item.original_line_price) || 0,
        originalUnit = Number(item.original_price || item.price || 0) || 0;
      let compareLine = originalLine;
      const variantCompare = Number(
        this.comparePriceCache[item.variant_id] || 0,
      );
      return (
        variantCompare > originalUnit &&
          (compareLine = Math.max(compareLine, variantCompare * qty)),
        compareLine > finalLine ? compareLine : 0
      );
    },
    getItemDisplayFinalLineCents(item) {
      return this.displayLinePrices.has(item)
        ? this.displayLinePrices.get(item)
        : getItemEffectiveLineCents(item);
    },
    getCartCompareTotalCents(cart) {
      return !cart || !cart.items
        ? 0
        : cart.items.reduce((sum, item) => {
            const finalLine = getItemEffectiveLineCents(item),
              originalLine = Number(item.original_line_price) || 0,
              compareLine = this.getItemCompareLineCents(item) || originalLine;
            return sum + Math.max(compareLine, finalLine);
          }, 0);
    },
    updateSavings(cart) {
      this.fillSummary(cart);
      if (!this.savingsEl) return;
      const compareTotal = this.getCartCompareTotalCents(cart),
        subtotal = Number(cart && cart.total_price) || 0,
        savings = Math.max(0, compareTotal - subtotal),
        amountEl = this.savingsEl.querySelector("[data-cart-savings-amount]");
      savings > 0
        ? (amountEl && (amountEl.textContent = formatMoney(savings)),
          (this.savingsEl.style.display = "flex"))
        : (this.savingsEl.style.display = "none");
    },
    renderItemPrice(item) {
      const compareLine = this.getItemCompareLineCents(item);
      return (
        '<span class="cart-item__prices">' +
        (compareLine > 0
          ? '<span class="cart-item__compare">' +
            formatMoney(compareLine) +
            "</span>"
          : "") +
        '<span class="cart-item__price">' +
        formatMoney(this.getItemDisplayFinalLineCents(item)) +
        "</span></span>"
      );
    },
    patchComparePrices(cart) {
      if (!this.itemsContainer || !cart || !cart.items) return;
      const rows = this.itemsContainer.querySelectorAll(".cart-item");
      (cart.items.forEach((item, i) => {
        const row = rows[i];
        if (!row) return;
        const prices = row.querySelector(".cart-item__prices");
        if (!prices) return;
        const cmp = this.getItemCompareLineCents(item);
        let el = prices.querySelector(".cart-item__compare");
        if (cmp > 0) {
          (el ||
            ((el = document.createElement("span")),
            (el.className = "cart-item__compare"),
            prices.insertBefore(el, prices.firstChild)),
            (el.textContent = formatMoney(cmp)));
        } else el && el.remove();
      }),
        this.updateSavings(cart));
    },
    hydrateComparePrices(cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      const handles = [];
      (cart.items.forEach((item) => {
        !item ||
          !item.handle ||
          !item.variant_id ||
          (this.comparePriceCache[item.variant_id] === void 0 &&
            (this.comparePriceLoading[item.handle] ||
              ((this.comparePriceLoading[item.handle] = !0),
              handles.push(item.handle))));
      }),
        handles.length &&
          Promise.all(
            handles.map((handle) =>
              fetch(route("products/" + encodeURIComponent(handle) + ".js"))
                .then((res) => (res.ok ? res.json() : null))
                .catch(() => null),
            ),
          )
            .then((products) => {
              let changed = !1;
              (products.forEach((product) => {
                product &&
                  product.handle &&
                  (this.productJson[product.handle] = product);
                !product ||
                  !Array.isArray(product.variants) ||
                  product.variants.forEach((variant) => {
                    if (!variant || !variant.id) return;
                    const compare = Number(variant.compare_at_price || 0) || 0;
                    this.comparePriceCache[variant.id] !== compare &&
                      ((this.comparePriceCache[variant.id] = compare),
                      (changed = !0));
                  });
              }),
                handles.forEach((handle) => {
                  delete this.comparePriceLoading[handle];
                }),
                changed && this.patchComparePrices(cart),
                this.fillLineEdits(cart));
            })
            .catch(() => {
              handles.forEach((handle) => {
                delete this.comparePriceLoading[handle];
              });
            }));
    },
    render(cart) {
      this.displayLinePrices = allocateBundleDisplayLinePrices(cart.items);
      // v43 20261018 (099 wave 1 m3) — the free-shipping gap is computed in ONE place:
      // dn-free-shipping-progress-v4.js → window.dnFsCompute(cart). Same
      // cart.total_price basis as v42; the comparison is done in USD cents
      // (cart converted back with the Shopify rate) and gapCents /
      // thresholdDisplayCents come back in the visitor's currency, so EU carts
      // no longer compare € cents against a $ threshold. null when the
      // threshold setting or the rate is missing (then the shipping line is
      // left untouched instead of inventing a number — v42 fell back to 150).
      const count = cart.item_count,
        subtotalCents = cart.total_price || 0,
        fs =
          typeof window.dnFsCompute === "function"
            ? window.dnFsCompute(cart)
            : null,
        thresholdCents = fs ? fs.thresholdDisplayCents : 0;
      (this.countEls.forEach((el) => {
        ((el.textContent = count),
          (el.style.display = count > 0 ? "flex" : "none"));
      }),
        this.subtotalEl &&
          (this.subtotalEl.textContent = formatMoney(subtotalCents)),
        this.updateSavings(cart));
      const shippingStatus = document.querySelector("#cart-drawer [data-cart-shipping-status]");
      if (shippingStatus) {
        const free = shippingStatus.querySelector("[data-cart-shipping-free]");
        const checkout = shippingStatus.querySelector("[data-cart-shipping-checkout]");
        if (free) free.hidden = !fs || !fs.met;
        if (checkout) checkout.hidden = !!fs && !!fs.met;
      }
      const remainingCents = fs ? fs.gapCents : 0,
        progress = fs ? fs.pct : 0;
      if (
        (fs && this.shippingFill && (this.shippingFill.style.width = progress + "%"),
        fs &&
          this.shippingText &&
          window.DuniiiCartShippingCopy.render(
            this.shippingText,
            remainingCents <= 0 ? "unlocked" : "remaining",
            remainingCents <= 0
              ? "You've unlocked free shipping!"
              : "{amount} away from free shipping",
            formatMoney(remainingCents),
            formatMoney(thresholdCents),
            remainingCents <= 0,
          ),
        this.emptyState &&
          (this.emptyState.style.display = count === 0 ? "flex" : "none"),
        this.footerEl &&
          (this.footerEl.style.display =
            count > 0 || this.emptyKeeps("footer") ? "block" : "none"),
        this.updateUrgency(count),
        this.itemsContainer && cart.items)
      ) {
        var ic = this.itemsContainer;
        (ic.classList.remove("cart-items-hidden"),
          this.animateOnOpen && ic.classList.add("cart-items-enter"),
          (ic.innerHTML = cart.items
            .map((item) => {
              var bundleProp =
                  (item.properties && item.properties.Bundle) || "",
                giftWrapProp =
                  (item.properties && item.properties["Gift Wrap"]) || "",
                labelHtml = "",
                _da = item.line_level_discount_allocations || [],
                _dt =
                  (_da.length &&
                    _da[0].discount_application &&
                    _da[0].discount_application.title) ||
                  "";
              if (!_dt)
                for (var _qi = 0; _qi < cart.items.length; _qi++) {
                  var _qo = cart.items[_qi];
                  if (_qo.product_id === item.product_id) {
                    var _qd = _qo.line_level_discount_allocations;
                    if (_qd && _qd.length) {
                      _dt =
                        (_qd[0].discount_application &&
                          _qd[0].discount_application.title) ||
                        "Offer applied";
                      break;
                    }
                  }
                }
              var _tl = [];
              (_dt && _tl.push(_dt),
                (cart.cart_level_discount_applications || []).forEach(
                  function (d) {
                    d &&
                      d.title &&
                      _tl.indexOf(d.title) < 0 &&
                      _tl.push(d.title);
                  },
                ));
              var discountHtml = _tl
                .map(function (t) {
                  return (
                    '<span style="display:inline-block;font-family:var(--font-body);font-size:0.6rem;font-weight:600;text-transform:uppercase;letter-spacing:0.05em;color:var(--color-primary);background:rgba(45,45,45,0.08);border:1px solid rgba(0,0,0,0.08);border-radius:2px;padding:2px 7px;margin-top:0.35rem;line-height:1.35;">' +
                    t +
                    "</span>"
                  );
                })
                .join("");
              return (
                bundleProp &&
                  (labelHtml =
                    '<span style="font-family:var(--font-body);font-size:0.68rem;font-weight:300;color:var(--color-accent,#C4B5A0);margin-top:0.25rem;display:block;">' +
                    bundleProp +
                    "</span>"),
                giftWrapProp &&
                  bundleProp !== "Gift Wrap" &&
                  (labelHtml +=
                    '<span style="font-family:var(--font-body);font-size:0.68rem;font-weight:300;font-style:italic;color:var(--color-accent,#C4B5A0);margin-top:0.125rem;display:block;">' +
                    giftWrapProp +
                    "</span>"),
                `          <div class="cart-item" data-key="${item.key}">            <a href="${item.url}" class="cart-item__image">              <img src="${item.image || item.featured_image.url}" alt="${item.title}" loading="lazy">            </a>            <div style="flex:1;display:flex;flex-direction:column;justify-content:space-between;min-width:0;">              <div>                <a href="${item.url}" class="cart-item__name">${item.product_title}</a>                <div class="cart-item__variant" style="margin-top:0.375rem;">${item.variant_title || ""}</div>                ${labelHtml}${discountHtml}              </div>              <div style="display:flex;align-items:flex-end;justify-content:space-between;margin-top:0.75rem;">                <div class="cart-item__qty">                  <button class="cart-item__qty-btn" data-action="decrease" data-key="${item.key}" aria-label="Decrease">                    ${item.quantity === 1 ? '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>' : '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><line x1="5" y1="12" x2="19" y2="12"/></svg>'}                  </button>                  <span class="cart-item__qty-value">${item.quantity}</span>                  <button class="cart-item__qty-btn" data-action="increase" data-key="${item.key}" aria-label="Increase">                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>                  </button>                </div>                ${this.renderItemPrice(item)}              </div>            </div>          </div>        `
              );
            })
            .join("")),
          this.applyLineTemplate(cart),
          this.hydrateComparePrices(cart),
          this.animateOnOpen &&
            ((this.animateOnOpen = !1),
            setTimeout(function () {
              ic.classList.remove("cart-items-enter");
            }, 1600)));
      }
    },
    async handleItemClick(e) {
      if (this.handleLineTplClick(e)) return;
      const btn = e.target.closest("[data-action]");
      if (!btn) return;
      if (this._cartBusy) return;
      const key = btn.dataset.key,
        action = btn.dataset.action,
        item = btn.closest(".cart-item"),
        qtyEl = item?.querySelector(".cart-item__qty-value");
      let qty = parseInt(qtyEl?.textContent || "0");
      action === "increase"
        ? qty++
        : action === "decrease"
          ? (qty = Math.max(0, qty - 1))
          : action === "remove" && (qty = 0); // v45: only skin templates put data-action="remove"
      ((this._cartBusy = !0), item && item.classList.add("cart-item--busy"));
      let ok = !1,
        lastErr = null;
      for (let a = 0; a < 3 && !ok; a++) {
        try {
          const r = await fetch(route("cart/change.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: qty }),
          });
          if (!r.ok) throw r;
          ok = !0;
        } catch (err) {
          ((lastErr = err),
            a < 2 &&
              (await new Promise((res) => setTimeout(res, 350 * (a + 1)))));
        }
      }
      ((this._cartBusy = !1),
        ok
          ? await this.refresh()
          : (console.error("Cart update error:", lastErr),
            item &&
              (item.classList.remove("cart-item--busy"),
              item.classList.add("cart-item--error"),
              setTimeout(
                () => item.classList.remove("cart-item--error"),
                2200,
              ))));
    },
    // ── v45 20261018 (099 wave 2 m2e, hook 3) — skin line template + window.dn.cart ──
    // A skin may put <template id="cart-line-tpl"> in the drawer. The default
    // rows above are still built first (same code as before); each one is then
    // rebuilt from a clone of the template: text tokens {title} {variant} {qty}
    // {price} {compare} ({price}/{compare} are the strings renderItemPrice
    // already formatted), slots data-cart-slot="image|qty|remove|edit|error",
    // [data-cart-href] gets the line URL, every [data-action] gets data-key.
    // If any clone lacks .cart-item[data-key], .cart-item__qty-value,
    // [data-action=decrease], [data-action=increase] or .cart-item__prices the
    // whole drawer keeps the default rows (one console.warn). No template on
    // the page = default rows, silently (black skin).
    // Contract: design/dn5-pdp/ENGINE-CONTRACT.md §6.3, SHELL-CONTRACT.md §1.
    // v46 (§6.3): option title wording declared on #cart-line-tpl as data-opt-labels (lower-case option name → text);
    // no declaration or no key = the product's own option name.
    optLabel(name) {
      const tpl = document.getElementById("cart-line-tpl");
      let map = null;
      try {
        map = tpl ? JSON.parse(tpl.getAttribute("data-opt-labels") || "null") : null;
      } catch (e) {
        map = null;
      }
      const k = String(name || "").toLowerCase();
      return map && map[k] ? String(map[k]) : name;
    },
    isGiftLine(item) {
      const p = (item && item.properties) || {};
      return !!p._dn4_gift || /^free gift$/i.test(String(p.Bundle || ""));
    },
    applyLineTemplate(cart) {
      const tpl = document.getElementById("cart-line-tpl");
      if (!tpl || !this.itemsContainer || !cart || !cart.items) return;
      const root = tpl.content ? tpl.content.firstElementChild : null,
        rows = Array.from(this.itemsContainer.children).filter((el) =>
          el.classList.contains("cart-item"),
        ),
        built = [];
      for (let i = 0; i < rows.length; i++) {
        const clone =
          root && cart.items[i]
            ? this.buildTplLine(root, rows[i], cart.items[i])
            : null;
        if (!clone) {
          bdTplWarn(
            "cart",
            "[cart] #cart-line-tpl is missing .cart-item[data-key], .cart-item__qty-value, [data-action=decrease], [data-action=increase] or .cart-item__prices; using the built-in rows",
          );
          return;
        }
        built.push(clone);
      }
      rows.forEach((row, i) => row.parentNode.replaceChild(built[i], row));
      this.fillLineEdits(cart);
    },
    buildTplLine(root, defaultRow, item) {
      // nodes are taken from a copy, so a failed check leaves the default row whole
      const row = defaultRow.cloneNode(!0),
        clone = root.cloneNode(!0),
        slot = (name) => clone.querySelector('[data-cart-slot="' + name + '"]'),
        priceEl = row.querySelector(".cart-item__price"),
        compareEl = row.querySelector(".cart-item__compare"),
        values = {
          title: item.product_title || "",
          variant:
            (item.options_with_values || [])
              .map((o) => o && o.value)
              .filter((v) => v && v !== "Default Title")
              .join(" · ") ||
            item.variant_title ||
            "",
          // v46 (099 2f, §6.3): tier label = the Bundle line property the engine stamps from the bars title at add time,
          // shown only on a discounted, non-gift line (dn4 cartVals rule); empty otherwise, and [data-cart-tier]
          // nodes are then removed.
          tier:
            (item.line_level_discount_allocations || []).length &&
            !this.isGiftLine(item) &&
            item.properties &&
            item.properties.Bundle
              ? String(item.properties.Bundle)
              : "",
          qty: String(item.quantity),
          price: priceEl ? priceEl.textContent : "",
          compare: compareEl ? compareEl.textContent : "",
        },
        walker = document.createTreeWalker(clone, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode()))
        /\{(title|variant|tier|qty|price|compare)\}/.test(node.data) &&
          (node.data = node.data.replace(
            /\{(title|variant|tier|qty|price|compare)\}/g,
            (m, k) => values[k],
          ));
      values.compare ||
        clone.querySelectorAll(".cart-item__compare").forEach((el) => el.remove());
      values.tier ||
        clone.querySelectorAll("[data-cart-tier]").forEach((el) => el.remove());
      const imageSlot = slot("image"),
        image = row.querySelector(".cart-item__image");
      imageSlot && image && imageSlot.appendChild(image);
      const qtySlot = slot("qty"),
        qtyBox = row.querySelector(".cart-item__qty");
      qtySlot && qtyBox && qtySlot.appendChild(qtyBox);
      const removeSlot = slot("remove");
      removeSlot && removeSlot.setAttribute("data-action", "remove");
      clone
        .querySelectorAll("[data-cart-href]")
        .forEach((a) => a.setAttribute("href", item.url));
      clone.matches(".cart-item") && clone.setAttribute("data-key", item.key);
      clone
        .querySelectorAll("[data-action]")
        .forEach((b) => b.setAttribute("data-key", item.key));
      const gift = this.isGiftLine(item);
      gift &&
        clone.setAttribute(
          "data-cart-gift",
          item.properties && item.properties._dn4_gift ? "spin" : "bundle",
        );
      const editSlot = slot("edit");
      editSlot &&
        (gift
          ? editSlot.remove()
          : ((editSlot.hidden = !0),
            this.editOpen[item.key] && editSlot.classList.add("is-open")));
      const err = this.lineErrors[item.key];
      if (err) {
        const p = document.createElement("p");
        ((p.className = "cart-item__error"),
          p.setAttribute("role", "alert"),
          (p.textContent = err),
          (slot("error") || clone).appendChild(p));
      }
      return clone.matches(".cart-item[data-key]") &&
        clone.querySelector(".cart-item__qty-value") &&
        clone.querySelector('[data-action="decrease"]') &&
        clone.querySelector('[data-action="increase"]') &&
        clone.querySelector(".cart-item__prices")
        ? clone
        : null;
    },
    // Fills each line's edit slot once /products/<handle>.js is known (the
    // same fetch hydrateComparePrices already makes). Options with one value
    // are not shown; a value whose variant is sold out is shown disabled.
    fillLineEdits(cart) {
      if (!this.itemsContainer || !cart || !cart.items) return;
      this.itemsContainer
        .querySelectorAll('.cart-item[data-key] [data-cart-slot="edit"]')
        .forEach((box) => {
          const key = box.closest(".cart-item[data-key]").getAttribute("data-key"),
            item = cart.items.find((it) => it.key === key),
            product = item && this.productJson[item.handle];
          if (!item || !product) return;
          const current = (product.variants || []).find(
              (v) => v.id === item.variant_id,
            ),
            options = product.options || [];
          if (
            !current ||
            !options.some((o) => (o.values || []).length > 1)
          ) {
            box.remove();
            return;
          }
          const host = box.querySelector("[data-cart-edit-options]") || box;
          host.innerHTML = "";
          options.forEach((opt, oi) => {
            if ((opt.values || []).length < 2) return;
            const group = document.createElement("div"),
              label = document.createElement("div"),
              list = document.createElement("div");
            ((group.className = "cart-edit__group"),
              (label.className = "cart-edit__label"),
              (label.textContent = this.optLabel(opt.name || "")),
              (list.className = "cart-edit__values"));
            opt.values.forEach((val) => {
              const want = current.options.slice();
              want[oi] = val;
              const cand = (product.variants || []).find(
                  (v) => v.options.join("\u0001") === want.join("\u0001"),
                ),
                sel = current.options[oi] === val;
              if (!cand && !sel) return;
              const ok = !!cand && cand.available,
                b = document.createElement("button");
              ((b.type = "button"),
                (b.className =
                  "cart-edit__value" +
                  (sel ? " is-selected" : ok ? "" : " is-out")),
                (b.textContent = val),
                b.setAttribute("aria-pressed", String(sel)),
                sel || !ok
                  ? (b.disabled = !0)
                  : b.setAttribute("data-cart-edit-variant", String(cand.id)),
                list.appendChild(b));
            });
            (group.appendChild(label), group.appendChild(list), host.appendChild(group));
          });
          box.hidden = !1;
        });
    },
    handleLineTplClick(e) {
      const toggle = e.target.closest("[data-cart-edit-toggle]");
      if (toggle) {
        const box = toggle.closest('[data-cart-slot="edit"]'),
          row = toggle.closest(".cart-item[data-key]");
        if (box) {
          const open = !box.classList.contains("is-open");
          (box.classList.toggle("is-open", open),
            toggle.setAttribute("aria-expanded", String(open)),
            row && (this.editOpen[row.getAttribute("data-key")] = open));
        }
        return !0;
      }
      const pick = e.target.closest("[data-cart-edit-variant]");
      if (pick) {
        const row = pick.closest(".cart-item[data-key]");
        row &&
          this.editLine(
            row.getAttribute("data-key"),
            Number(pick.getAttribute("data-cart-edit-variant")),
          ).catch(() => {});
        return !0;
      }
      return !1;
    },
    async cartPost(url, body) {
      const r = await fetch(url, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body),
        }),
        j = await r.json().catch(() => null);
      if (!r.ok) throw { status: r.status, body: j };
      return j;
    },
    async readCart() {
      const r = await fetch(route("cart.js"), { cache: "no-store" });
      if (!r.ok) throw { status: r.status };
      return r.json();
    },
    async getProduct(handle) {
      if (this.productJson[handle]) return this.productJson[handle];
      const r = await fetch(route("products/" + encodeURIComponent(handle) + ".js"));
      if (!r.ok) throw { status: r.status };
      const p = await r.json();
      return (this.productJson[handle] = p);
    },
    lineErrorText(code) {
      // Wording copied from dn4 (_attic/assets/dn4-app-v13-20261011.js:322-326);
      // a skin can override each one on #cart-line-tpl.
      const tpl = document.getElementById("cart-line-tpl"),
        attr =
          code === "sold-out"
            ? "data-err-sold-out"
            : code === "rollback-failed"
              ? "data-err-rollback"
              : "data-err-generic",
        dflt =
          code === "sold-out"
            ? "Sorry, that option just sold out. Please choose another one."
            : code === "rollback-failed"
              ? "Sorry, something went wrong. Please check your bag before checkout."
              : "Sorry, we couldn’t change this item. Your bag hasn’t changed — please try again.";
      return (tpl && tpl.getAttribute(attr)) || dflt;
    },
    // Change one line to another variant of the same product (port of dn4
    // swapVariant): add the new variant with the line's properties (option
    // names retagged), then lower the old line by the same quantity. If the
    // second step fails the add is undone. Two writes, not idempotent, so it
    // is never retried; the result is read back from /cart.js and the drawer
    // re-rendered either way.
    async editLine(key, variantId, opts) {
      if (this._cartBusy) throw { code: "busy" };
      this._cartBusy = !0;
      const row = this.itemsContainer
        ? Array.from(this.itemsContainer.querySelectorAll(".cart-item[data-key]")).find(
            (el) => el.getAttribute("data-key") === key,
          )
        : null;
      row && row.classList.add("cart-item--busy");
      delete this.lineErrors[key];
      let failure = null;
      try {
        const cart = await this.readCart(),
          item = (cart.items || []).find((it) => it.key === key);
        if (!item) throw { code: "not-found" };
        if (this.isGiftLine(item)) throw { code: "gift" };
        if (Number(variantId) === item.variant_id) return cart;
        const product = await this.getProduct(item.handle),
          variant = (product.variants || []).find((v) => v.id === Number(variantId));
        if (!variant) throw { code: "not-found" };
        const plan =
            item.selling_plan_allocation && item.selling_plan_allocation.selling_plan
              ? item.selling_plan_allocation.selling_plan.id
              : null,
          oldProps = item.properties || {},
          newProps = Object.assign({}, oldProps);
        (product.options || []).forEach((opt, i) => {
          const name = String((opt && opt.name) || opt || "").toLowerCase();
          name &&
            variant.options[i] != null &&
            Object.keys(newProps).forEach((k) => {
              k.charAt(0) !== "_" &&
                k.toLowerCase() === name &&
                (newProps[k] = variant.options[i]);
            });
        });
        opts && opts.properties && Object.assign(newProps, opts.properties);
        const add = { id: variant.id, quantity: item.quantity, properties: newProps };
        plan && (add.selling_plan = plan);
        try {
          await this.cartPost(route("cart/add.js"), { items: [add] });
        } catch (err) {
          throw { code: err && err.status === 422 ? "sold-out" : "add-failed", status: err && err.status };
        }
        // Line keys can change once the cart changes, so the old line is found
        // again by variant + properties + selling plan (as dn4 did).
        const planOf = (it) =>
            it.selling_plan_allocation && it.selling_plan_allocation.selling_plan
              ? it.selling_plan_allocation.selling_plan.id
              : null,
          propsKey = (o) =>
            Object.keys(o || {})
              .filter((k) => o[k] != null && o[k] !== "")
              .sort()
              .map((k) => k + "\u0001" + String(o[k]))
              .join("\u0002"),
          findLine = (c, vid, props, qty) =>
            (c.items || []).find(
              (it) =>
                it.variant_id === vid &&
                planOf(it) === plan &&
                it.quantity >= qty &&
                propsKey(it.properties) === propsKey(props),
            );
        try {
          const after = await this.readCart(),
            old = findLine(after, item.variant_id, oldProps, item.quantity);
          if (!old) throw { code: "locate" };
          await this.cartPost(route("cart/change.js"), {
            id: old.key,
            quantity: Math.max(0, old.quantity - item.quantity),
          });
        } catch (err) {
          let undone = !1;
          try {
            const c2 = await this.readCart(),
              added = findLine(c2, variant.id, newProps, item.quantity);
            added &&
              (await this.cartPost(route("cart/change.js"), {
                id: added.key,
                quantity: added.quantity - item.quantity,
              }),
              (undone = !0));
          } catch {}
          throw { code: undone ? "rolled-back" : "rollback-failed" };
        }
        return await this.readCart();
      } catch (err) {
        failure = err || { code: "error" };
        this.lineErrors[key] = this.lineErrorText(failure.code);
        throw failure;
      } finally {
        this._cartBusy = !1;
        await this.refresh();
      }
    },
    // Adds a code to the ones already on the cart (port of dn4 applyDiscount):
    // POST /cart/update.js {discount:"A,B"}; no retry.
    async applyDiscount(code) {
      code = String(code || "").trim();
      if (!code) throw { code: "empty" };
      if (this._cartBusy) throw { code: "busy" };
      this._cartBusy = !0;
      try {
        const cart = await this.readCart(),
          codes = (cart.discount_codes || [])
            .map((d) => d && d.code)
            .filter((c) => c && c.toUpperCase() !== code.toUpperCase());
        return (
          codes.push(code),
          await this.cartPost(route("cart/update.js"), { discount: codes.join(",") })
        );
      } finally {
        this._cartBusy = !1;
        await this.refresh();
      }
    },
    // Price breakdown for a cart. was = getCartCompareTotalCents (the same
    // compare basis as the SAVE chip); discount = what discount codes took
    // (cart-level + line-level allocations of type discount_code); youPay =
    // cart.total_price; savings = was - discount - youPay (bundle + sale).
    breakdown(cart) {
      cart = cart || this._lastCart;
      if (!cart) return null;
      const was = this.getCartCompareTotalCents(cart),
        youPay = Number(cart.total_price) || 0;
      let discount = 0;
      ((cart.cart_level_discount_applications || []).forEach((a) => {
        a && a.type === "discount_code" && (discount += Number(a.total_allocated_amount) || 0);
      }),
        (cart.items || []).forEach((it) =>
          (it.line_level_discount_allocations || []).forEach((a) => {
            a &&
              a.discount_application &&
              a.discount_application.type === "discount_code" &&
              (discount += Number(a.amount) || 0);
          }),
        ));
      const savings = was - discount - youPay,
        saveAll = was - youPay,
        pctApp = (cart.cart_level_discount_applications || []).find(
          (a) => a && a.type === "discount_code" && a.value_type === "percentage",
        );
      return {
        cents: { was: was, savings: savings, discount: discount, youPay: youPay, saveAll: saveAll },
        was: formatMoney(was),
        savings: formatMoney(savings),
        discount: formatMoney(discount),
        youPay: formatMoney(youPay),
        saveAll: formatMoney(saveAll),
        saveAllPct: was > 0 && saveAll > 0 ? Math.round((saveAll / was) * 100) + "%" : "",
        codes: (cart.discount_codes || [])
          .filter((d) => d && d.applicable)
          .map((d) => d.code)
          .join(", "),
        codePct: pctApp ? Math.round(Number(pctApp.value)) + "%" : "",
      };
    },
    // Writes the breakdown into [data-cart-sum="was|savings|discount|youPay|
    // saveAll|saveAllPct|codes|codePct"] and hides [data-cart-sum-if=...]
    // when that value is zero / empty. Nothing to do when the drawer has none.
    fillSummary(cart) {
      if (!this.drawer || !cart) return;
      const outs = this.drawer.querySelectorAll("[data-cart-sum]"),
        ifs = this.drawer.querySelectorAll("[data-cart-sum-if]");
      if (!outs.length && !ifs.length) return;
      this._lastCart = cart;
      const b = this.breakdown(cart);
      (outs.forEach((el) => {
        const k = el.getAttribute("data-cart-sum");
        typeof b[k] === "string" && (el.textContent = b[k]);
      }),
        ifs.forEach((el) => {
          const k = el.getAttribute("data-cart-sum-if");
          el.hidden = !(k in b.cents ? b.cents[k] > 0 : b[k]);
        }));
    },
  };
  window.dn = window.dn || {};
  window.dn.cart = {
    editLine: (key, variantId, opts) => CartDrawer.editLine(key, variantId, opts),
    applyDiscount: (code) => CartDrawer.applyDiscount(code),
    breakdown: (cart) => CartDrawer.breakdown(cart),
  };
  function initAddToCart() {
    const form = document.getElementById("product-form");
    form &&
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const btn = form.querySelector(".btn-atc"),
          activeTier = document.querySelector(".bundle-tier.is-active");
        if (!activeTier) {
          const id = document.querySelector('#product-form [name="id"]')?.value;
          if (!id) return;
          const items2 = [{ id: parseInt(id), quantity: 1 }];
          btn?.classList.add("is-loading");
          try {
            (await fetch(route("cart/add.js"), {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: items2 }),
            }),
              btn?.classList.add("is-added"));
            const atcText = document.getElementById("atc-text");
            (atcText && (atcText.textContent = "ADDED TO CART"),
              setTimeout(() => {
                (btn?.classList.remove("is-added"),
                  atcText && (atcText.textContent = "ADD TO BAG"));
              }, 2e3),
              CartDrawer.open());
          } catch (err) {
            console.error("Cart error:", err);
          }
          btn?.classList.remove("is-loading");
          return;
        }
        const qty = parseInt(activeTier.dataset.qty || "1"),
          sizeRows = activeTier.querySelectorAll(".tier-size-row"),
          items = [],
          variantsEl = document.getElementById("bd-variants"),
          bdVariants = variantsEl ? JSON.parse(variantsEl.textContent) : [],
          globalColor = document.querySelector(".color-swatch.is-active")
            ?.dataset.colorName,
          freeCount = parseInt(activeTier.dataset.free || "0"),
          activeBarForPair = (bundleState.bars || [])[
            bundleState.activeTierIndex
          ],
          isPairCheckout = isPairBar(activeBarForPair),
          stampBundleProperties = (properties) => {
            const stamped = properties || {};
            bundleState.dealId &&
              (stamped._bundle_deal_id = bundleState.dealId);
            activeBarForPair?.id &&
              (stamped._bundle_bar_id = String(activeBarForPair.id));
            return stamped;
          };
        if (
          isPairCheckout &&
          (!pairState.available || !pairState.variantId)
        ) {
          pairState.fetched || ensurePairCompanion();
          updateATCButton();
          return;
        }
        if (isPairCheckout) {
          const targetRows = Array.from(
              activeTier.querySelectorAll(".tier-size-row:not(.tier-free-gift)"),
            ),
            targetItems = {};
          targetRows.forEach((trow, rowIndex) => {
            const tSizeBtn = trow.querySelector(
                ".size-btn[data-size].is-selected",
              ),
              tSize = tSizeBtn ? tSizeBtn.dataset.size : null,
              tColorBtn = trow.querySelector(".tier-color-btn.is-active"),
              tColor = tColorBtn ? tColorBtn.dataset.color : globalColor;
            // v28 20260920: same resolver the price readouts use.
            let tVar = resolveBundleRowVariant(trow, bdVariants, globalColor);
            if (!tVar) return;
            const key = String(tVar.id);
            if (!targetItems[key]) {
              const tprops = stampBundleProperties({
                Bundle: "Pair",
                _bundle_line_index: String(rowIndex),
              });
              (tSize && (tprops.Size = tSize),
                tColor && (tprops.Color = tColor),
                (targetItems[key] = {
                  id: tVar.id,
                  quantity: 0,
                  properties: tprops,
                }));
            }
            targetItems[key].quantity += 1;
          });
          Object.keys(targetItems).forEach((key) => items.push(targetItems[key]));
          if (pairState.available && pairState.variantId) {
            const cvid = parseInt(pairState.variantId);
            cvid > 0 &&
              items.push({
                id: cvid,
                quantity: pairCompanionQuantity(activeBarForPair),
                properties: stampBundleProperties({
                  Bundle: "Pair",
                  _bundle_line_index: "1",
                }),
              });
          }
        }
        const pairItemQuantity = items.reduce(
          (total, item) => total + (parseInt(item.quantity) || 0),
          0,
        );
        if (
          isPairCheckout &&
          pairItemQuantity !== pairTotalQuantity(activeBarForPair)
        ) {
          console.warn(
            "[DUNIII Bundle] Pair quantity mismatch; add blocked.",
          );
          updateATCButton();
          return;
        }
        (isPairCheckout ||
          sizeRows.forEach((row, i) => {
            const selected = row.querySelector(
              ".size-btn[data-size].is-selected",
            );
            if (!selected) return;
            const size = selected.dataset.size,
              itemColorBtn = row.querySelector(".tier-color-btn.is-active"),
              itemColor = itemColorBtn
                ? itemColorBtn.dataset.color
                : globalColor;
            // v28 20260920: same resolver the price readouts use.
            let variant = resolveBundleRowVariant(row, bdVariants, globalColor);
            if (!variant) return;
            const tierTitle =
                activeTier
                  .querySelector(".bundle-tier__total")
                  ?.closest(".bundle-tier")
                  ?.querySelector('span[style*="font-weight:500"]')
                  ?.textContent || qty + " Pack",
              props = stampBundleProperties({ Size: size, Bundle: tierTitle });
            (itemColor && (props.Color = itemColor),
              items.push({ id: variant.id, quantity: 1, properties: props }));
          }),
          document.querySelectorAll(".upsell-card.is-added").forEach((card) => {
            const upsellData = card._upsellData;
            if (!upsellData || !upsellData.variants) return;
            const selColor = card.querySelector(".upsell-color-btn.is-active")
                ?.dataset.color,
              selSize = card.querySelector(".upsell-size-btn.is-selected")
                ?.dataset.size;
            let uVariant = upsellData.variants.find((v) => {
              if (v.available === !1) return !1;
              const optVals = (v.options || []).map((o) => o.value);
              return !(
                (selColor && !optVals.includes(selColor)) ||
                (selSize && !optVals.includes(selSize))
              );
            });
            if (
              (!uVariant &&
                upsellData.variants.length > 0 &&
                (uVariant = upsellData.variants[0]),
              uVariant)
            ) {
              const vid = gidToId(uVariant.id),
                uDiscInfo = formatBundleDiscountLabel(
                  upsellData.discountType,
                  upsellData.discountValue,
                );
              vid &&
                items.push({
                  id: vid,
                  quantity: 1,
                  properties: { Bundle: "Upsell (" + uDiscInfo + ")" },
                });
            }
          }));
        const activeTierEl = document.querySelector(".bundle-tier.is-active");
        if (activeTierEl) {
          const tierUpsellCard = activeTierEl.querySelector(
            '.tier-upsell-card[data-tier-upsell-active="1"]',
          );
          if (tierUpsellCard) {
            const tierIdx = bundleState.activeTierIndex || 0,
              barData = (bundleState.bars || [])[tierIdx];
            if (barData && barData.upsell && barData.upsell.variants) {
              const tuColor = tierUpsellCard.querySelector(
                  ".tier-upsell-color-btn.is-active",
                )?.dataset?.color,
                tuSize = tierUpsellCard.querySelector(
                  ".tier-upsell-size-btn.is-selected",
                )?.dataset?.size;
              let tuVariant = barData.upsell.variants.find((v) => {
                if (v.available === !1) return !1;
                const opts = (v.options || []).map((o) => o.value);
                return !(
                  (tuColor && !opts.includes(tuColor)) ||
                  (tuSize && !opts.includes(tuSize))
                );
              });
              if (
                (!tuVariant &&
                  barData.upsell.variants.length > 0 &&
                  (tuVariant = barData.upsell.variants[0]),
                tuVariant)
              ) {
                const tuVid = gidToId(tuVariant.id),
                  tuDiscInfo = formatBundleDiscountLabel(
                    barData.upsell.discountType,
                    barData.upsell.discountValue,
                  );
                tuVid &&
                  items.push({
                    id: tuVid,
                    quantity: 1,
                    properties: { Bundle: "Upsell (" + tuDiscInfo + ")" },
                  });
              }
            }
          }
        }
        const activeBarData = bundleState.bars[bundleState.activeTierIndex];
        if (activeBarData?.gift?.enabled) {
          const giftVid = gidToId(
            activeBarData.gift.variantId ||
              (activeBarData.gift.variants &&
                activeBarData.gift.variants[0]?.id),
          );
          giftVid &&
            items.push({
              id: giftVid,
              quantity: 1,
              properties: { Bundle: "Free Gift" },
            });
        }
        const giftToggle = document.getElementById("gift-switch"),
          giftMessage = document.getElementById("gift-message");
        let giftPersonalNote = "";
        if (giftToggle?.classList.contains("is-on")) {
          const selectedGift = document.querySelector(
            ".gift-option-card.is-selected",
          );
          if (selectedGift) {
            const giftMsg = giftMessage?.value?.trim(),
              giftWrapName =
                selectedGift.querySelector("p")?.textContent || "Gift Wrap",
              giftVariantId = selectedGift.dataset.giftVariant,
              giftPrice = parseInt(selectedGift.dataset.giftPrice || "0");
            (giftMsg && (giftPersonalNote = giftMsg),
              giftVariantId &&
                giftPrice > 0 &&
                items.push({
                  id: parseInt(giftVariantId),
                  quantity: 1,
                  properties: { Bundle: "Gift Wrap" },
                }),
              items.forEach((item) => {
                (item.properties || (item.properties = {}),
                  (item.properties["Gift Wrap"] = giftWrapName));
              }));
          }
        }
        if (items.length === 0) {
          const id = document.querySelector('#product-form [name="id"]')?.value;
          if (!id) return;
          items.push({ id: parseInt(id), quantity: 1 });
        }
        btn?.classList.add("is-loading");
        try {
          (await fetch(route("cart/add.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items }),
          }),
            giftPersonalNote &&
              (await fetch(route("cart/update.js"), {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  note: "Gift personal note: " + giftPersonalNote,
                }),
              })),
            btn?.classList.add("is-added"));
          const atcText = document.getElementById("atc-text");
          (atcText && (atcText.textContent = "ADDED TO CART"),
            setTimeout(() => {
              (btn?.classList.remove("is-added"), updateATCButton());
            }, 2e3),
            CartDrawer.open());
        } catch (err) {
          console.error("Add to cart error:", err);
        } finally {
          btn?.classList.remove("is-loading");
        }
      });
  }
  function initPremiumScrollbar(viewport) {
    if (
      !viewport ||
      (viewport.parentNode &&
        viewport.parentNode.classList &&
        viewport.parentNode.classList.contains("dn-scrollwrap"))
    )
      return null;
    const wrap = document.createElement("div");
    ((wrap.className = "dn-scrollwrap"),
      viewport.parentNode.insertBefore(wrap, viewport),
      wrap.appendChild(viewport));
    const bar = document.createElement("div");
    ((bar.className = "dn-scrollbar"), wrap.appendChild(bar));
    let hideTimer = null;
    function update() {
      const sh = viewport.scrollHeight,
        ch = viewport.clientHeight;
      if (sh <= ch + 1) {
        ((bar.style.height = "0px"), (bar.style.opacity = "0"));
        return;
      }
      bar.style.opacity = "";
      const thumbH = Math.max(28, (ch / sh) * ch),
        top = (viewport.scrollTop / (sh - ch)) * (ch - thumbH);
      ((bar.style.height = thumbH + "px"),
        (bar.style.transform = "translateY(" + top + "px)"));
    }
    function flash() {
      (wrap.classList.add("is-scrolling"),
        hideTimer && clearTimeout(hideTimer),
        (hideTimer = setTimeout(function () {
          wrap.classList.remove("is-scrolling");
        }, 900)));
    }
    (viewport.addEventListener(
      "scroll",
      function () {
        (update(), flash());
      },
      { passive: !0 },
    ),
      window.addEventListener("resize", update, { passive: !0 }));
    let dragStartY = 0,
      dragStartScroll = 0;
    (bar.addEventListener("pointerdown", function (e) {
      (e.preventDefault(),
        wrap.classList.add("is-dragging"),
        (dragStartY = e.clientY),
        (dragStartScroll = viewport.scrollTop));
      try {
        bar.setPointerCapture(e.pointerId);
      } catch {}
    }),
      bar.addEventListener("pointermove", function (e) {
        if (!wrap.classList.contains("is-dragging")) return;
        const sh = viewport.scrollHeight,
          ch = viewport.clientHeight,
          thumbH = Math.max(28, (ch / sh) * ch),
          trackRange = ch - thumbH,
          scrollRange = sh - ch;
        trackRange > 0 &&
          (viewport.scrollTop =
            dragStartScroll +
            ((e.clientY - dragStartY) / trackRange) * scrollRange);
      }));
    function endDrag(e) {
      wrap.classList.remove("is-dragging");
      try {
        bar.releasePointerCapture(e.pointerId);
      } catch {}
    }
    return (
      bar.addEventListener("pointerup", endDrag),
      bar.addEventListener("pointercancel", endDrag),
      update(),
      requestAnimationFrame(update),
      setTimeout(update, 300),
      update
    );
  }
  function initPageScrollbar() {
    if (document.querySelector(".dn-page-scrollbar")) return;
    const bar = document.createElement("div");
    bar.className = "dn-page-scrollbar";
    const thumb = document.createElement("div");
    ((thumb.className = "dn-page-scrollbar__thumb"),
      bar.appendChild(thumb),
      document.body.appendChild(bar));
    const de = document.documentElement;
    function docH() {
      return Math.max(de.scrollHeight, document.body.scrollHeight);
    }
    function update() {
      const vh = window.innerHeight,
        sh = docH();
      if (sh <= vh + 2) {
        thumb.style.height = "0px";
        return;
      }
      const thumbH = Math.max(40, (vh / sh) * vh),
        top =
          ((window.scrollY || window.pageYOffset || 0) / (sh - vh)) *
          (vh - thumbH);
      ((thumb.style.height = thumbH + "px"),
        (thumb.style.transform = "translateY(" + top + "px)"));
    }
    if (
      (window.addEventListener("scroll", update, { passive: !0 }),
      window.addEventListener("resize", update, { passive: !0 }),
      window.ResizeObserver)
    )
      try {
        new ResizeObserver(update).observe(document.body);
      } catch {}
    let dragY = 0,
      dragS = 0;
    (thumb.addEventListener("pointerdown", function (e) {
      (e.preventDefault(),
        bar.classList.add("is-dragging"),
        (dragY = e.clientY),
        (dragS = window.scrollY || 0));
      try {
        thumb.setPointerCapture(e.pointerId);
      } catch {}
    }),
      thumb.addEventListener("pointermove", function (e) {
        if (!bar.classList.contains("is-dragging")) return;
        const vh = window.innerHeight,
          sh = docH(),
          thumbH = Math.max(40, (vh / sh) * vh),
          maxTop = vh - thumbH;
        maxTop > 0 &&
          window.scrollTo(
            0,
            dragS + ((e.clientY - dragY) / maxTop) * (sh - vh),
          );
      }));
    function end(e) {
      bar.classList.remove("is-dragging");
      try {
        thumb.releasePointerCapture(e.pointerId);
      } catch {}
    }
    (thumb.addEventListener("pointerup", end),
      thumb.addEventListener("pointercancel", end),
      update(),
      requestAnimationFrame(update),
      setTimeout(update, 300),
      setTimeout(update, 1200));
  }
  function canonicalProductImageFile(url) {
    if (!url) return "";
    try {
      return new URL(url, window.location.href).pathname.split("/").pop() || "";
    } catch {
      return String(url).split("?")[0].split("/").pop() || "";
    }
  }
  function activateProductGalleryMedia(mediaId, imageUrl) {
    const gallery = document.querySelector(".pdp-gallery");
    if (!gallery) return !1;
    const wantedMediaId = mediaId == null ? "" : String(mediaId),
      wantedFile = canonicalProductImageFile(imageUrl),
      thumbs = gallery.querySelectorAll(".pdp-gallery__thumb");
    let match = null;
    if (wantedMediaId)
      thumbs.forEach(function (thumb) {
        !match &&
          String(thumb.dataset.mediaId || "") === wantedMediaId &&
          (match = thumb);
      });
    if (!match && wantedFile)
      thumbs.forEach(function (thumb) {
        const thumbImg = thumb.querySelector("img");
        !match &&
          thumbImg &&
          canonicalProductImageFile(thumbImg.currentSrc || thumbImg.src) ===
            wantedFile &&
          (match = thumb);
      });
    if (match) {
      match.click();
      return !0;
    }
    if (!imageUrl) return !1;
    const mainImg =
      gallery.querySelector(".pdp-gallery__slide.is-active img") ||
      gallery.querySelector(".pdp-gallery__main img");
    if (!mainImg) return !1;
    mainImg.srcset = "";
    mainImg.src = imageUrl;
    return !0;
  }
  function getBundleColorGalleryMedia(color) {
    const variants = readBundleVariants(),
      match = variants.find(function (variant) {
        return (
          Array.isArray(variant.options) &&
          variant.options.indexOf(color) !== -1 &&
          (variant.media_id || variant.image)
        );
      });
    return match
      ? { mediaId: match.media_id || null, image: match.image || "" }
      : { mediaId: null, image: "" };
  }
  function initProductGallery() {
    const gallery = document.querySelector(".pdp-gallery");
    if (!gallery) return;
    const main = gallery.querySelector(".pdp-gallery__main"),
      thumbs = gallery.querySelectorAll(".pdp-gallery__thumb"),
      thumbsWrap = gallery.querySelector(".pdp-gallery__thumbs"),
      slides = gallery.querySelectorAll(".pdp-gallery__slide");
    if (
      !main ||
      !thumbs.length ||
      !slides.length ||
      gallery.dataset.galleryInitialized === "true"
    )
      return;
    gallery.dataset.galleryInitialized = "true";
    const counterEl = gallery.querySelector(".pdp-gallery__counter"),
      prevArrow = gallery.querySelector(".pdp-gallery__arrow--prev"),
      nextArrow = gallery.querySelector(".pdp-gallery__arrow--next"),
      totalSlides = slides.length;
    let activeIndex = 0;
    var _thumbBarUpdate = null;
    function syncThumbsHeight() {
      !thumbsWrap ||
        !main ||
        (window.matchMedia("(min-width: 768px)").matches
          ? (thumbsWrap.style.maxHeight = main.offsetHeight + "px")
          : (thumbsWrap.style.maxHeight = ""),
        _thumbBarUpdate && _thumbBarUpdate());
    }
    (syncThumbsHeight(), requestAnimationFrame(syncThumbsHeight));
    var _mainImg0 = main.querySelector("img");
    (_mainImg0 &&
      !_mainImg0.complete &&
      _mainImg0.addEventListener("load", syncThumbsHeight),
      window.addEventListener("resize", syncThumbsHeight, { passive: !0 }));
    function updateArrows() {
      (prevArrow && (prevArrow.style.display = activeIndex > 0 ? "" : "none"),
        nextArrow &&
          (nextArrow.style.display =
            activeIndex < totalSlides - 1 ? "" : "none"));
    }
    function pauseAllVideos() {
      slides.forEach(function (s) {
        const v = s.querySelector("video");
        if (v)
          try {
            (v.pause(), (v.currentTime = 0));
          } catch {}
      });
    }
    function setActive(index) {
      if (
        index < 0 ||
        index >= totalSlides ||
        (index === activeIndex && index !== 0)
      )
        return;
      ((activeIndex = index),
        thumbs.forEach(function (t) {
          var on = parseInt(t.dataset.index, 10) === index;
          if ((t.classList.toggle("is-active", on), on && thumbsWrap)) {
            var cRect = thumbsWrap.getBoundingClientRect(),
              tRect = t.getBoundingClientRect();
            thumbsWrap.scrollWidth > thumbsWrap.clientWidth + 1
              ? thumbsWrap.scrollBy({
                  left:
                    tRect.left -
                    cRect.left -
                    (thumbsWrap.clientWidth - tRect.width) / 2,
                  behavior: "smooth",
                })
              : thumbsWrap.scrollHeight > thumbsWrap.clientHeight + 1 &&
                thumbsWrap.scrollBy({
                  top:
                    tRect.top -
                    cRect.top -
                    (thumbsWrap.clientHeight - tRect.height) / 2,
                  behavior: "smooth",
                });
          }
        }),
        pauseAllVideos(),
        main.classList.remove("is-zoomed"));
      let activeIsVideo = !1;
      (slides.forEach(function (s) {
        const isActive = parseInt(s.dataset.index, 10) === index;
        if (
          (s.classList.toggle("is-active", isActive),
          isActive && s.dataset.type === "video")
        ) {
          activeIsVideo = !0;
          const v = s.querySelector("video");
          if (v)
            try {
              ((v.currentTime = 0), v.play().catch(function () {}));
            } catch {}
        }
      }),
        main.classList.toggle("is-video", activeIsVideo),
        (main.style.cursor = activeIsVideo ? "pointer" : ""),
        counterEl && (counterEl.textContent = index + 1 + " / " + totalSlides),
        updateArrows());
    }
    if (
      (thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          setActive(parseInt(thumb.dataset.index, 10));
        });
      }),
      slides.forEach(function (s) {
        s.dataset.type === "video" &&
          s.addEventListener("click", function () {
            const v = s.querySelector("video");
            v && (v.paused ? v.play().catch(function () {}) : v.pause());
          });
      }),
      prevArrow &&
        prevArrow.addEventListener("click", function (e) {
          (e.stopPropagation(), activeIndex > 0 && setActive(activeIndex - 1));
        }),
      nextArrow &&
        nextArrow.addEventListener("click", function (e) {
          (e.stopPropagation(),
            activeIndex < totalSlides - 1 && setActive(activeIndex + 1));
        }),
      canHover && main)
    ) {
      let activeImg = function () {
        const act = gallery.querySelector(".pdp-gallery__slide.is-active");
        return !act || act.dataset.type !== "image"
          ? null
          : act.querySelector("img");
      };
      (main.addEventListener("mouseenter", function () {
        main.classList.contains("is-video") || main.classList.add("is-zoomed");
      }),
        main.addEventListener("mouseleave", function () {
          main.classList.remove("is-zoomed");
          const img = activeImg();
          img && (img.style.transformOrigin = "");
        }),
        main.addEventListener("mousemove", function (e) {
          if (main.classList.contains("is-video")) return;
          const img = activeImg();
          if (!img) return;
          const rect = main.getBoundingClientRect(),
            x = ((e.clientX - rect.left) / rect.width) * 100,
            y = ((e.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + "% " + y + "%";
        }));
    }
    let touchStartX = 0,
      touchMoved = !1;
    (main?.addEventListener(
      "touchstart",
      function (e) {
        ((touchStartX = e.touches[0].clientX), (touchMoved = !1));
      },
      { passive: !0 },
    ),
      main?.addEventListener(
        "touchmove",
        function (e) {
          Math.abs(e.touches[0].clientX - touchStartX) > 10 &&
            (touchMoved = !0);
        },
        { passive: !0 },
      ),
      main?.addEventListener(
        "touchend",
        function (e) {
          const diff = touchStartX - e.changedTouches[0].clientX;
          if (Math.abs(diff) > 50) {
            (diff > 0 &&
              activeIndex < totalSlides - 1 &&
              setActive(activeIndex + 1),
              diff < 0 && activeIndex > 0 && setActive(activeIndex - 1));
            return;
          }
          if (!touchMoved && main.classList.contains("is-video")) {
            const v = gallery
              .querySelector(".pdp-gallery__slide.is-active")
              ?.querySelector("video");
            v && (v.paused ? v.play().catch(function () {}) : v.pause());
          }
        },
        { passive: !0 },
      ),
      setActive(0));
  }
  function openImageLightbox(images, startIndex) {
    const lightbox = document.getElementById("image-lightbox");
    if (!lightbox) return;
    let current = startIndex;
    const mainImg = lightbox.querySelector(".image-lightbox__main img"),
      counterEl = lightbox.querySelector(".image-lightbox__counter"),
      closeBtn = lightbox.querySelector("[data-lightbox-close]");
    function show(idx) {
      ((current = Math.max(0, Math.min(images.length - 1, idx))),
        mainImg && (mainImg.src = images[current]),
        counterEl &&
          (counterEl.textContent = `${current + 1} / ${images.length}`));
    }
    (show(current),
      lightbox.classList.add("is-open"),
      document.body.classList.add("no-scroll"));
    const closeFn = () => {
      (lightbox.classList.remove("is-open"),
        document.body.classList.remove("no-scroll"));
    };
    closeBtn?.addEventListener("click", closeFn);
    let swipeStartX = 0;
    (lightbox.addEventListener(
      "touchstart",
      (e) => {
        swipeStartX = e.touches[0].clientX;
      },
      { passive: !0 },
    ),
      lightbox.addEventListener(
        "touchend",
        (e) => {
          const diff = swipeStartX - e.changedTouches[0].clientX;
          Math.abs(diff) > 60 &&
            (diff > 0 ? show(current + 1) : show(current - 1));
        },
        { passive: !0 },
      ));
  }
  function initDayNightSlider() {
    const slider = document.querySelector(".day-night");
    if (!slider) return;
    const dayClip = slider.querySelector(".day-night__day"),
      lineEl = slider.querySelector(".day-night__line");
    let pos = 50,
      hasInteracted = !1;
    function setPos(pct) {
      ((pos = Math.max(2, Math.min(98, pct))),
        dayClip && (dayClip.style.clipPath = `inset(0 ${100 - pos}% 0 0)`),
        lineEl && (lineEl.style.left = pos + "%"));
    }
    function onPointer(e) {
      (e.preventDefault(), (hasInteracted = !0));
      const rect = slider.getBoundingClientRect(),
        pct = ((e.clientX - rect.left) / rect.width) * 100;
      setPos(pct);
    }
    (slider.addEventListener("pointerdown", (e) => {
      (onPointer(e), e.target.setPointerCapture?.(e.pointerId));
    }),
      slider.addEventListener("pointermove", (e) => {
        e.buttons > 0 && onPointer(e);
      }),
      setPos(50));
  }
  let bundleState = {
    activeTier: null,
    unitPrice: 0,
    bars: [],
    variants: [],
    activeTierIndex: 0,
    showPricesPerItem: !0,
    showPerPieceSuffix: !0,
    perPieceSuffixText: "/ea",
    compareAtPrice: 0,
    useCompareAtPrice: !1,
    calculateBarPrice: null,
    dealId: "",
  };
  var pairState = { fetched: !1, data: null, variantId: "", available: !1 };
  function isPairBar(bar) {
    return !!(bar && bar.priceType === "pair");
  }
  function pairBarPct(bar) {
    return (bar && parseFloat(bar.priceValue)) || 0;
  }
  function pairTargetQuantity(bar) {
    return Math.max(
      1,
      parseInt(bar && bar.pair && bar.pair.targetQuantity) ||
        parseInt(bar && bar.quantity) ||
        1,
    );
  }
  function pairCompanionQuantity(bar) {
    return Math.max(
      1,
      parseInt(bar && bar.pair && bar.pair.companionQuantity) || 1,
    );
  }
  function pairTotalQuantity(bar) {
    return pairTargetQuantity(bar) + pairCompanionQuantity(bar);
  }
  function pairOptNames(p) {
    var n = [];
    return (
      p &&
        Array.isArray(p.options) &&
        p.options.forEach(function (o) {
          n.push(typeof o == "string" ? o : (o && o.name) || "");
        }),
      n
    );
  }
  function pairVarVal(v, idx) {
    return v && Array.isArray(v.options) && v.options[idx] != null
      ? v.options[idx]
      : v && v["option" + (idx + 1)] != null
        ? v["option" + (idx + 1)]
        : "";
  }
  var PAIR_COLOR_HEX = {
    Beige: "#D2B48C",
    Black: "#222",
    White: "#FFF",
    Blue: "#3B82F6",
    Navy: "#1E3A5F",
    Pink: "#EC4899",
    Red: "#EF4444",
    Green: "#22C55E",
    Purple: "#A855F7",
    Gray: "#9CA3AF",
    Grey: "#9CA3AF",
    Brown: "#92400E",
    Cream: "#FFFDD0",
    Ivory: "#FFFFF0",
    Nude: "#E3BC9A",
    Wine: "#722F37",
    Burgundy: "#800020",
    Coral: "#FF7F50",
    Lavender: "#E6E6FA",
    Mint: "#98FF98",
    Teal: "#008080",
    Gold: "#D4AF37",
    Silver: "#C0C0C0",
    Khaki: "#C3B091",
    Olive: "#808000",
    Orange: "#F97316",
    Yellow: "#EAB308",
    Champagne: "#F7E7CE",
  };
  function getPairProductId() {
    var c = document.querySelector(".bundle-tiers");
    if (c && c.dataset && c.dataset.productId)
      return String(c.dataset.productId);
    try {
      if (
        window.ShopifyAnalytics &&
        ShopifyAnalytics.meta &&
        ShopifyAnalytics.meta.product
      )
        return String(ShopifyAnalytics.meta.product.id);
    } catch {}
    try {
      if (window.meta && window.meta.product)
        return String(window.meta.product.id);
    } catch {}
    return "";
  }
  var pairUX = {
    ready: !1,
    lb: null,
    lbImg: null,
    modal: null,
    modalBody: null,
    lastFocus: null,
  };
  function pairBigImg(url) {
    return (
      url &&
      ((url = String(url)),
      url.indexOf("//") === 0 && (url = "https:" + url),
      /[?&]width=/.test(url)
        ? url.replace(/([?&]width=)\d+/, "$11400")
        : url + (url.indexOf("?") === -1 ? "?" : "&") + "width=1400")
    );
  }
  function pairPriceColHtml(fullCents, discCents) {
    return discCents < fullCents
      ? '<span class="pairux-price" style="display:block;font-family:var(--font-heading);font-size:0.85rem;color:var(--color-primary);line-height:1.2;">' +
          formatMoney(discCents) +
          '</span><span class="pairux-compare" style="display:block;font-family:var(--font-body);font-size:9px;color:var(--color-accent);text-decoration:line-through;line-height:1.2;">' +
          formatMoney(fullCents) +
          "</span>"
      : '<span class="pairux-price" style="display:block;font-family:var(--font-heading);font-size:0.85rem;color:var(--color-primary);line-height:1.2;">' +
          formatMoney(fullCents) +
          "</span>";
  }
  function pairTargetMeta() {
    var c = document.querySelector(".bundle-tiers"),
      ds = (c && c.dataset) || {},
      title = ds.productTitle || "";
    if (!title) {
      var h1 = document.querySelector(".pdp-info__name");
      h1 && (title = (h1.textContent || "").trim());
    }
    return { handle: ds.productHandle || "", title };
  }
  function pairUXClose() {
    if (
      (pairUX.lb && (pairUX.lb.style.display = "none"),
      pairUX.modal && (pairUX.modal.style.display = "none"),
      (document.documentElement.style.overflow = ""),
      pairUX.lastFocus && pairUX.lastFocus.focus)
    )
      try {
        pairUX.lastFocus.focus();
      } catch {}
  }
  function ensurePairUX() {
    if (!pairUX.ready) {
      pairUX.ready = !0;
      var lb = document.createElement("div");
      ((lb.className = "pairux-lb"),
        (lb.style.cssText =
          "display:none;position:fixed;inset:0;z-index:100000;background:rgba(20,16,12,0.86);align-items:center;justify-content:center;padding:1.5rem;"),
        (lb.innerHTML =
          '<button type="button" class="pairux-x" aria-label="Close" style="position:absolute;top:1rem;right:1rem;width:2.5rem;height:2.5rem;display:flex;align-items:center;justify-content:center;color:#fff;background:rgba(0,0,0,0.3);border:none;border-radius:50%;cursor:pointer;"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button><img alt="" style="max-width:92vw;max-height:88vh;object-fit:contain;border-radius:4px;box-shadow:0 10px 40px rgba(0,0,0,0.4);">'),
        document.body.appendChild(lb),
        (pairUX.lb = lb),
        (pairUX.lbImg = lb.querySelector("img")),
        lb.addEventListener("click", function (e) {
          (e.target === lb || e.target.closest(".pairux-x")) && pairUXClose();
        }));
      var modal = document.createElement("div");
      ((modal.className = "pairux-modal"),
        (modal.style.cssText =
          "display:none;position:fixed;inset:0;z-index:100001;background:rgba(20,16,12,0.6);align-items:center;justify-content:center;padding:1.25rem;"),
        (modal.innerHTML =
          '<div class="pairux-modal__panel" role="dialog" aria-modal="true" style="position:relative;width:100%;max-width:560px;max-height:88vh;overflow:auto;background:var(--color-bg,#fff);border-radius:6px;box-shadow:0 20px 60px rgba(0,0,0,0.35);"><button type="button" class="pairux-x" aria-label="Close" style="position:absolute;top:0.625rem;right:0.625rem;z-index:2;width:2.25rem;height:2.25rem;display:flex;align-items:center;justify-content:center;color:var(--color-primary,#2b2b2b);background:rgba(255,255,255,0.88);border:none;border-radius:50%;cursor:pointer;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button><div class="pairux-modal__body"></div></div>'),
        document.body.appendChild(modal),
        (pairUX.modal = modal),
        (pairUX.modalBody = modal.querySelector(".pairux-modal__body")),
        modal.addEventListener("click", function (e) {
          (e.target === modal || e.target.closest(".pairux-x")) &&
            pairUXClose();
        }),
        document.addEventListener("keydown", function (e) {
          (e.key === "Escape" || e.keyCode === 27) &&
            ((pairUX.lb && pairUX.lb.style.display !== "none") ||
              (pairUX.modal && pairUX.modal.style.display !== "none")) &&
            pairUXClose();
        }),
        document.addEventListener(
          "click",
          function (e) {
            var zoom = e.target.closest("[data-pairux-zoom]");
            if (zoom) {
              var src =
                zoom.getAttribute("data-pairux-img") ||
                (zoom.querySelector("img") && zoom.querySelector("img").src) ||
                "";
              src &&
                (e.preventDefault(),
                e.stopPropagation(),
                pairUXOpenLightbox(pairBigImg(src)));
              return;
            }
            var qv = e.target.closest("[data-pairux-qv]");
            if (qv) {
              var handle = qv.getAttribute("data-pairux-handle") || "";
              handle &&
                (e.preventDefault(),
                e.stopPropagation(),
                pairUXOpenModal(handle));
            }
          },
          !0,
        ));
    }
  }
  function pairUXOpenLightbox(src) {
    (ensurePairUX(),
      (pairUX.lastFocus = document.activeElement),
      (pairUX.lbImg.src = src),
      (pairUX.lb.style.display = "flex"),
      (document.documentElement.style.overflow = "hidden"));
  }
  function pairUXOpenModal(handle) {
    (ensurePairUX(),
      (pairUX.lastFocus = document.activeElement),
      (pairUX.modalBody.innerHTML =
        '<div style="padding:3rem 1.5rem;text-align:center;font-family:var(--font-body);font-size:12px;color:var(--color-accent);">Loading\u2026</div>'),
      (pairUX.modal.style.display = "flex"),
      (document.documentElement.style.overflow = "hidden"),
      fetch(route("products/" + encodeURIComponent(handle) + ".js"))
        .then(function (r) {
          return r.json();
        })
        .then(function (p) {
          ((pairUX.modalBody.innerHTML = pairUXModalHtml(p)),
            pairUXBindGallery());
        })
        .catch(function () {
          pairUX.modalBody.innerHTML =
            '<div style="padding:3rem 1.5rem;text-align:center;font-family:var(--font-body);font-size:12px;color:var(--color-accent);">Could not load product.</div>';
        }));
  }
  function pairUXOpenModalData(prod) {
    (ensurePairUX(),
      (pairUX.lastFocus = document.activeElement),
      (pairUX.modalBody.innerHTML = pairUXModalHtml(prod || {})),
      pairUXBindGallery(),
      (pairUX.modal.style.display = "flex"),
      (document.documentElement.style.overflow = "hidden"));
  }
  function pairUXModalHtml(p) {
    var imgs = (
        p.images && p.images.length
          ? p.images
          : p.featured_image
            ? [p.featured_image]
            : []
      ).slice(0, 8),
      main = imgs.length ? pairBigImg(imgs[0]) : "",
      price = formatMoney(parseInt(p.price) || 0),
      cmp =
        p.compare_at_price && p.compare_at_price > p.price
          ? formatMoney(parseInt(p.compare_at_price))
          : "",
      h = "";
    return (
      (h +=
        '<div style="width:100%;aspect-ratio:3/4;background:var(--color-surface,#F0EBE3);overflow:hidden;border-radius:6px 6px 0 0;">' +
        (main
          ? '<img class="pairux-modal__main" src="' +
            escHtml(main) +
            '" alt="' +
            escHtml(p.title || "") +
            '" style="width:100%;height:100%;object-fit:cover;display:block;">'
          : "") +
        "</div>"),
      imgs.length > 1 &&
        ((h +=
          '<div class="pairux-modal__thumbs" style="display:flex;gap:0.5rem;overflow-x:auto;padding:0.625rem 1.25rem 0;">'),
        imgs.forEach(function (im, i) {
          h +=
            '<button type="button" class="pairux-modal__thumb" data-pairux-thumb="' +
            escHtml(pairBigImg(im)) +
            '" style="flex:0 0 auto;width:3rem;height:3.75rem;border-radius:3px;overflow:hidden;border:1px solid ' +
            (i === 0
              ? "var(--color-primary,#2b2b2b)"
              : "rgba(232,226,217,0.6)") +
            ';padding:0;cursor:pointer;background:none;"><img src="' +
            escHtml(im) +
            '" alt="" style="width:100%;height:100%;object-fit:cover;"></button>';
        }),
        (h += "</div>")),
      (h += '<div style="padding:1rem 1.25rem 1.5rem;">'),
      (h +=
        '<h3 style="font-family:var(--font-heading);font-size:1.05rem;font-weight:400;color:var(--color-primary);margin:0 0 0.375rem;">' +
        escHtml(p.title || "") +
        "</h3>"),
      (h +=
        '<div style="display:flex;align-items:baseline;gap:0.5rem;margin-bottom:0.875rem;"><span style="font-family:var(--font-heading);font-size:1rem;color:var(--color-primary);">' +
        price +
        "</span>" +
        (cmp
          ? '<span style="font-family:var(--font-body);font-size:11px;color:var(--color-accent);text-decoration:line-through;">' +
            cmp +
            "</span>"
          : "") +
        "</div>"),
      (h +=
        '<div class="pairux-modal__desc" style="font-family:var(--font-body);font-size:12px;line-height:1.6;color:var(--color-accent);">' +
        (p.description || "") +
        "</div>"),
      (h += "</div>"),
      h
    );
  }
  function pairUXBindGallery() {
    var body = pairUX.modalBody,
      main = body.querySelector(".pairux-modal__main");
    body.querySelectorAll("[data-pairux-thumb]").forEach(function (b) {
      b.addEventListener("click", function (e) {
        (e.stopPropagation(),
          main && (main.src = b.getAttribute("data-pairux-thumb")),
          body.querySelectorAll(".pairux-modal__thumb").forEach(function (t) {
            t.style.borderColor = "rgba(232,226,217,0.6)";
          }),
          (b.style.borderColor = "var(--color-primary,#2b2b2b)"));
      });
    });
  }
  function activePairBar() {
    for (var bars = bundleState.bars || [], i = 0; i < bars.length; i++)
      if (isPairBar(bars[i])) return bars[i];
    return null;
  }
  function pairCompanionCents() {
    if (!pairState.available || !pairState.data) return 0;
    for (var vs = pairState.data.variants || [], i = 0; i < vs.length; i++)
      if (String(vs[i].id) === String(pairState.variantId))
        return parseInt(vs[i].price) || 0;
    return (vs[0] && parseInt(vs[0].price)) || 0;
  }
  // v29 20260920 — line-for-line mirror of what actually charges the customer:
  // extensions/product-discount/src/run.js:167-213 (Pair branch). Read-only
  // source of truth; this copy exists only so the PDP shows the same cent.
  //   pairFinalCents  = round(fullTotal * (1 - pct/100))   ← round, NOT floor
  //   per line        = floor(lineFull * pct / 100), then the residual is
  //                     handed out one cent at a time, largest fractional
  //                     remainder first (stable sort ⇒ ties keep line order).
  // The old body used floor(total*pct/100) + proportional allocation, which
  // under-counted the discount by a cent whenever the aggregate fraction was
  // ≥ 0.5 (measured: display $81.59 vs cart $81.58 on 39.99 + 55.99 @15%).
  function allocateShopifyPairBundleLinesCents(fullLineCents, pct) {
    var originals = (Array.isArray(fullLineCents) ? fullLineCents : []).map(
        function (value) {
          return Math.max(0, Math.round(Number(value) || 0));
        },
      ),
      normalizedPct = Math.min(100, Math.max(0, parseFloat(pct) || 0)),
      entries = [];
    originals.forEach(function (full, index) {
      if (!(full > 0)) return;
      var raw = (full * normalizedPct) / 100,
        floored = Math.floor(raw);
      entries.push({
        index: index,
        full: full,
        discount: floored,
        remainder: raw - floored,
      });
    });
    var fullTotal = entries.reduce(function (sum, entry) {
        return sum + entry.full;
      }, 0),
      finalTotal = Math.round(fullTotal * (1 - normalizedPct / 100)),
      residual =
        fullTotal -
        finalTotal -
        entries.reduce(function (sum, entry) {
          return sum + entry.discount;
        }, 0);
    entries
      .slice()
      .sort(function (a, b) {
        return b.remainder - a.remainder;
      })
      .forEach(function (entry) {
        if (residual > 0) {
          ((entry.discount += 1), (residual -= 1));
        }
      });
    var discounts = originals.map(function () {
      return 0;
    });
    entries.forEach(function (entry) {
      discounts[entry.index] = entry.discount;
    });
    var finals = originals.map(function (original, index) {
        return Math.max(0, original - discounts[index]);
      }),
      originalTotal = originals.reduce(function (sum, value) {
        return sum + value;
      }, 0),
      total = finals.reduce(function (sum, value) {
        return sum + value;
      }, 0);
    return {
      originals: originals,
      finals: finals,
      originalTotal: originalTotal,
      discountTotal: originalTotal - total,
      total: total,
    };
  }
  // Ordinary percentage tiers follow Shopify's native percentage semantics:
  // discount each unit, truncate that unit's discount to a cent, then sum.
  function allocateShopifyPercentageBundleLinesCents(fullLineCents, pct) {
    var originals = (Array.isArray(fullLineCents) ? fullLineCents : []).map(
        function (value) {
          return Math.max(0, Math.round(Number(value) || 0));
        },
      ),
      normalizedPct = Math.min(100, Math.max(0, parseFloat(pct) || 0)),
      discounts = originals.map(function (original) {
        return Math.floor((original * normalizedPct) / 100);
      }),
      finals = originals.map(function (original, index) {
        return Math.max(0, original - discounts[index]);
      }),
      originalTotal = originals.reduce(function (sum, value) {
        return sum + value;
      }, 0),
      discountTotal = discounts.reduce(function (sum, value) {
        return sum + value;
      }, 0);
    return {
      originals: originals,
      finals: finals,
      originalTotal: originalTotal,
      discountTotal: discountTotal,
      total: originalTotal - discountTotal,
    };
  }
  // v42 20261010 — takes the tier's bundleTierSaveSummary(), so the card's
  // Save is the very number the floating bar and the line under the button
  // quote. v41 signature (kept for rollback):
  //   function updateBundleTierSummary(tier, total, original, itemCount)
  function updateBundleTierSummary(tier, save) {
    if (!tier || !save) return;
    var total = Math.max(0, parseInt(save.total) || 0),
      original = Math.max(total, parseInt(save.strike) || total),
      itemCount = Math.max(1, parseInt(save.itemCount) || 1);
    // v41 20261010 — Edward 2026-10-10 15:32 EDT: tier prices no longer add
    // shipping below the free-shipping threshold (v32-v40 showed the delivered
    // price + "Includes $X shipping"). At/above it the tier still says FREE
    // shipping.
    var savings = Math.max(0, parseInt(save.savings) || 0),
      perItem = Math.round(total / itemCount),
      totalEl = tier.querySelector(".bundle-tier__total"),
      metaEl = tier.querySelector(".bundle-tier__meta");
    var subtitleEl = tier.querySelector(":scope > .px-4 .flex-1 > p");
    subtitleEl &&
      (subtitleEl.textContent =
        savings > 0 ? "Save " + formatMoney(savings) : "Standard price");
    var compactList =
      tier.closest(".bundle-tiers")?.dataset.dn2BundleStyle === "list";
    totalEl &&
      (totalEl.textContent = formatMoney(total) + (compactList ? "" : " total"));
    renderBundleTierShippingNote(tier, total);
    var panelHeadSave = tier.querySelector(".bundle-panel-head span");
    panelHeadSave &&
      (panelHeadSave.textContent =
        savings > 0 && original > 0
          ? "Save " + Math.round((savings / original) * 100) + "%"
          : "Standard price");
    if (metaEl && metaEl.hasAttribute("data-r2-tier-meta")) {
      var labelTemplate = tier.dataset.labelTpl || "",
        savePct = original > 0 ? Math.round((savings / original) * 100) : 0,
        perItemBadge = formatBundleBarLabel(
          labelTemplate,
          perItem,
          savings,
          savePct,
        ),
        onlyEachEl = metaEl.querySelector(".bundle-tier__only-each"),
        savingEl = metaEl.querySelector(".bundle-tier__saving");
      perItemBadge
        ? (onlyEachEl ||
            ((onlyEachEl = document.createElement("span")),
              (onlyEachEl.className = "bundle-tier__only-each"),
              metaEl.insertBefore(onlyEachEl, metaEl.firstChild)),
          (onlyEachEl.textContent = perItemBadge))
        : onlyEachEl && onlyEachEl.remove();
      savings > 0
        ? (savingEl ||
            ((savingEl = document.createElement("span")),
              (savingEl.className = "bundle-tier__saving"),
              metaEl.appendChild(savingEl)),
          (savingEl.textContent = "Save " + formatMoney(savings)))
        : savingEl && savingEl.remove();
    } else
      metaEl &&
        (metaEl.textContent =
          shouldShowTierPerItem(itemCount)
            ? formatMoney(perItem) +
              " per item" +
              (savings > 0 ? " · Save " + formatMoney(savings) : " · Standard price")
            : savings > 0
              ? "Save " + formatMoney(savings)
              : "Standard price");
    var beforeEl = tier.querySelector("[data-bundle-before]");
    beforeEl && (beforeEl.textContent = formatMoney(original));
    var perEl = tier.querySelector("[data-bundle-per-item]");
    perEl && (perEl.textContent = formatMoney(perItem));
    var savingsEl = tier.querySelector("[data-bundle-savings]");
    savingsEl && (savingsEl.textContent = formatMoney(savings));
    var packTotalEl = tier.querySelector("[data-bundle-pack-total]");
    packTotalEl && (packTotalEl.textContent = formatMoney(total));
  }
  function fallbackFromUnavailablePair() {
    window.setTimeout(function () {
      var activePair = document.querySelector(
        '.bundle-tier[data-pair="1"].is-active',
      );
      if (!activePair || pairState.available) return;
      var tiers = Array.prototype.slice.call(
          document.querySelectorAll(".bundle-tier"),
        ),
        fallback = tiers.find(function (tier) {
          return tier.dataset.pair !== "1" && parseInt(tier.dataset.qty) === 3;
        });
      fallback ||
        (fallback = tiers.find(function (tier) {
          return tier.dataset.pair !== "1" && parseInt(tier.dataset.qty) > 1;
        }));
      fallback && fallback.click();
    }, 0);
  }
  function updatePairTierDisplay(tier) {
    if (tier) {
      // v42 20261010 — prices, strike and Save come from bundleTierSaveSummary
      // (the same call the floating bar and the line under the button make).
      var save = bundleTierSaveSummary(tier),
        targetStrikes = save.targetStrikes,
        pairAllocation = save.allocation;
      tier
        .querySelectorAll(".tier-pair-target-price")
        .forEach(function (tgtPriceEl, index) {
          tgtPriceEl.innerHTML = pairPriceColHtml(
            targetStrikes[index] != null
              ? targetStrikes[index]
              : bundleState.unitPrice || 0,
            pairAllocation.finals[index] || 0,
          );
        });
      var combinedFull = pairAllocation.originalTotal,
        combinedDisc = save.total,
        // v32 20261010 — Save/strike measured against the strike price.
        pairStrike = save.strike;
      ((tier.dataset.totalCents = combinedDisc),
        (tier.dataset.pairFullCents = combinedFull));
      var totalEl = tier.querySelector(".bundle-tier__total");
      updateBundleTierSummary(tier, save);
      var compareEl = ensureTierCompareEl(tier, totalEl);
      compareEl &&
        (pairStrike > combinedDisc
          ? ((compareEl.textContent = formatMoney(pairStrike)),
            (compareEl.style.display = ""))
          : ((compareEl.textContent = ""), (compareEl.style.display = "none")));
      var saveBadge = tier.querySelector(".bundle-tier__save-badge");
      if (saveBadge) {
        saveBadge.style.display = "none";
      }
    }
  }
  function reexpandActivePairBody() {
    var t = document.querySelector('.bundle-tier[data-pair="1"].is-active');
    if (t) {
      var body = t.querySelector(".bundle-tier__body");
      body && (body.style.maxHeight = body.scrollHeight + "px");
    }
  }
  function fillPairCompanionCard(card) {
    if (card) {
      var wrap = card.closest(".tier-pair-companion-wrap");
      if (!pairState.available || !pairState.data) {
        wrap && (wrap.style.display = "none");
        return;
      }
      var p = pairState.data.product,
        variants = pairState.data.variants;
      (!pairState.variantId ||
        !variants.some(function (v) {
          return String(v.id) === String(pairState.variantId);
        })) &&
        (pairState.variantId = String(variants[0].id));
      for (
        var pct = pairBarPct(activePairBar()), sel = null, i = 0;
        i < variants.length;
        i++
      )
        if (String(variants[i].id) === String(pairState.variantId)) {
          sel = variants[i];
          break;
        }
      sel || (sel = variants[0]);
      // v28 20260920 — the companion's discounted price is allocated against the
      // target slots' real prices, not one shared unitPrice.
      var pairTierEl = card.closest('.bundle-tier[data-pair="1"]'),
        pairTargetPrices = getBundleTierRowPrices(
          pairTierEl,
          parseInt(
            (pairTierEl && pairTierEl.dataset.pairTargetQuantity) || "1",
            10,
          ) || 1,
        );
      var cFull = parseInt(sel.price) || 0,
        cDisc = allocateShopifyPairBundleLinesCents(
          pairTargetPrices.concat([cFull]),
          pct,
        ).finals[pairTargetPrices.length],
        img = p.featured_image || (p.images && p.images[0]) || "",
        html = "";
      if (
        (img &&
          (html +=
            '<div class="bundle-line-item__image" data-pairux-zoom data-pairux-img="' +
            escHtml(img) +
            '" title="Tap to enlarge"><img src="' +
            escHtml(img) +
            '" alt="" loading="lazy"></div>'),
        (html += '<div class="bundle-line-item__content">'),
        (html +=
          '<div class="bundle-line-item__top"><div><span class="bundle-line-item__label">Smart match</span>'),
        (html +=
          '<p class="bundle-line-item__title" data-pairux-qv data-pairux-handle="' +
          escHtml(p.handle || "") +
          '" role="button" tabindex="0" title="Quick view">' +
          escHtml(p.title || "") +
          (pairCompanionQuantity(activePairBar()) > 1
            ? " × " + pairCompanionQuantity(activePairBar())
            : "") +
          "</p></div>"),
        (html +=
          '<div class="tier-pair-companion-price bundle-line-item__price">' +
          pairPriceColHtml(bundleLineStrikeCents(sel, cFull), cDisc) +
          "</div>"),
        (html += "</div>"),
        variants.length > 1)
      ) {
        for (
          var optNames = pairOptNames(p),
            selVals = optNames.map(function (_, idx) {
              return pairVarVal(sel, idx);
            }),
            optVals = optNames.map(function (_, idx) {
              var vals = [];
              return (
                variants.forEach(function (v) {
                  var val = pairVarVal(v, idx);
                  val !== "" && vals.indexOf(val) === -1 && vals.push(val);
                }),
                vals
              );
            }),
            colorIdx = -1,
            ci = 0;
          ci < optNames.length;
          ci++
        ) {
          var dn = String(optNames[ci]).toLowerCase();
          if (dn === "color" || dn === "colour") {
            colorIdx = ci;
            break;
          }
        }
        var compColorImg = {};
        colorIdx >= 0 &&
          variants.forEach(function (v) {
            var cv = pairVarVal(v, colorIdx);
            if (cv && !compColorImg[cv]) {
              var fi = v.featured_image,
                src = fi && (typeof fi == "string" ? fi : fi.src);
              src && (compColorImg[cv] = src);
            }
          });
        var picker = "";
        (html +=
          '<div class="bundle-variant-types-label bundle-variant-types-label--pair">' +
          optNames
            .map(function (name) {
              return escHtml(name || "Option");
            })
            .join(", ") +
          "</div>",
        optNames.forEach(function (name, idx) {
          var values = optVals[idx];
          if (!(!values || !values.length)) {
            var isColor = idx === colorIdx,
              selVal = selVals[idx];
            picker +=
              '<div class="pc-opt-group bundle-variant-field' +
              (isColor ? " is-color" : " is-size") +
              '" data-pc-opt-idx="' +
              idx +
              '" data-opt-name="' +
              escHtml(name) +
              '"><div class="bundle-variant-select"><button type="button" class="bundle-variant-select__trigger" aria-haspopup="listbox" aria-expanded="false"><span data-bundle-selected-label>' +
              escHtml(selVal) +
              '</span><svg aria-hidden="true" width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg></button><div class="bundle-variant-select__menu" role="listbox" hidden>';
            values.forEach(function (val) {
              var on = String(val) === String(selVal),
                thumb = isColor ? compColorImg[val] : "";
              picker +=
                '<button type="button" role="option" class="bundle-variant-select__option pc-opt-btn ' +
                (isColor ? "pc-color-btn" : "pc-size-btn") +
                (on ? (isColor ? " is-active" : " is-selected") : "") +
                '" data-pc-opt-idx="' +
                idx +
                '" data-pc-val="' +
                escHtml(val) +
                '" aria-selected="' +
                (on ? "true" : "false") +
                '">' +
                (isColor
                  ? thumb
                    ? '<img src="' + escHtml(thumb) + '" alt="" loading="lazy">'
                    : '<span class="bundle-variant-select__swatch" style="background:' +
                      escHtml(PAIR_COLOR_HEX[val] || "#999") +
                      ';"></span>'
                  : "") +
                '<span>' +
                escHtml(val) +
                "</span></button>";
            });
            picker += "</div></div></div>";
          }
        }),
          picker
            ? (html += '<div class="pc-opt-picker">' + picker + "</div>")
            : ((html +=
                '<select class="tier-pair-select" data-pair-select style="margin-top:0.375rem;max-width:100%;border:1px solid var(--color-border,#E8E2D9);border-radius:3px;padding:0.25rem 0.5rem;font-family:var(--font-body);font-size:10px;color:var(--color-primary);background:#fff;">'),
              variants.forEach(function (v) {
                html +=
                  '<option value="' +
                  escHtml(String(v.id)) +
                  '"' +
                  (String(v.id) === String(pairState.variantId)
                    ? " selected"
                    : "") +
                  ">" +
                  escHtml(v.title) +
                  "</option>";
              }),
              (html += "</select>")));
      }
      ((html += "</div>"),
        (card.innerHTML = html),
        (card.style.display = "flex"),
        wrap && (wrap.style.display = ""));
      var pickerEl = card.querySelector(".pc-opt-picker");
      if (pickerEl) {
        pickerEl.addEventListener("keydown", function (e) {
          handleBundleVariantKeyboard(pickerEl, e);
        });
        pickerEl.addEventListener("click", function (e) {
          var trigger = e.target.closest(".bundle-variant-select__trigger");
          if (trigger) {
            e.stopPropagation();
            var select = trigger.closest(".bundle-variant-select"),
              menu = select && select.querySelector(".bundle-variant-select__menu"),
              willOpen = !!(menu && menu.hidden);
            pickerEl
              .querySelectorAll(".bundle-variant-select__menu")
              .forEach(function (other) {
                other.hidden = !0;
                var otherTrigger = other.parentElement.querySelector(
                  ".bundle-variant-select__trigger",
                );
                otherTrigger && otherTrigger.setAttribute("aria-expanded", "false");
              });
            if (menu) {
              menu.hidden = !willOpen;
              trigger.setAttribute("aria-expanded", String(willOpen));
            }
            return;
          }
          var btn = e.target.closest(".pc-opt-btn");
          if (btn && (e.stopPropagation(), !btn.disabled)) {
            var oNames = pairOptNames(pairState.data && pairState.data.product),
              desired = oNames.map(function (_, i3) {
                var grp = pickerEl.querySelector(
                    '.pc-opt-group[data-pc-opt-idx="' + i3 + '"]',
                  ),
                  s = grp
                    ? grp.querySelector(
                        ".pc-opt-btn.is-selected, .pc-opt-btn.is-active",
                      )
                    : null;
                return s ? s.getAttribute("data-pc-val") : "";
              }),
              ci2 = parseInt(btn.getAttribute("data-pc-opt-idx"));
            desired[ci2] = btn.getAttribute("data-pc-val");
            for (
              var vs = (pairState.data && pairState.data.variants) || [],
                match = null,
                i2 = 0;
              i2 < vs.length;
              i2++
            ) {
              for (var ok = !0, k = 0; k < oNames.length; k++)
                if (
                  desired[k] !== "" &&
                  String(pairVarVal(vs[i2], k)) !== String(desired[k])
                ) {
                  ok = !1;
                  break;
                }
              if (ok) {
                match = vs[i2];
                break;
              }
            }
            if (!match) {
              for (var j = 0; j < vs.length; j++)
                if (String(pairVarVal(vs[j], ci2)) === String(desired[ci2])) {
                  match = vs[j];
                  break;
                }
            }
            (match || (match = vs[0]),
              match && (pairState.variantId = String(match.id)),
              document
                .querySelectorAll('.bundle-tier[data-pair="1"]')
                .forEach(function (t) {
                  updatePairTierDisplay(t);
                }),
              fillPairCompanionCard(card),
              reexpandActivePairBody(),
              updateGrandTotal(),
              updateATCButton());
          }
        });
      } else {
        var selEl = card.querySelector("[data-pair-select]");
        selEl &&
          (selEl.addEventListener("click", function (e) {
            e.stopPropagation();
          }),
          selEl.addEventListener("change", function (e) {
            (e.stopPropagation(),
              (pairState.variantId = this.value),
              document
                .querySelectorAll('.bundle-tier[data-pair="1"]')
                .forEach(function (t) {
                  updatePairTierDisplay(t);
                }),
              fillPairCompanionCard(card),
              reexpandActivePairBody(),
              updateGrandTotal(),
              updateATCButton());
          }));
      }
    }
  }
  function applyPairCompanion() {
    (document
      .querySelectorAll('.bundle-tier[data-pair="1"]')
      .forEach(function (t) {
        var card = t.querySelector("[data-pair-companion]");
        (card && fillPairCompanionCard(card), updatePairTierDisplay(t));
      }),
      reexpandActivePairBody(),
      updateGrandTotal(),
      updateATCButton());
  }
  // v28 20260920 — milestone 1: the merchant pins the Perfect Pair companion on the
  // product page with the product metafield bundle-deal.pair_product. Empty
  // metafield / deleted product / no sellable variant ⇒ fall through to the
  // existing /recommendations auto-match, untouched.
  function getConfiguredPairHandle() {
    var el = document.getElementById("bd-pair-product");
    if (!el) return "";
    try {
      var raw = JSON.parse(el.textContent || "null");
      if (typeof raw == "string") return raw;
      return raw && raw.handle ? String(raw.handle) : "";
    } catch {
      return "";
    }
  }
  function pairCompanionFromProduct(p) {
    if (!p) return null;
    var avail = (p.variants || []).filter(function (v) {
      return v && v.available;
    });
    return avail.length ? { product: p, variants: avail } : null;
  }
  function applyPairResult(comp, source) {
    ((pairState.data = comp),
      comp
        ? ((pairState.variantId = String(comp.variants[0].id)),
          (pairState.available = !0),
          (pairState.source = source))
        : ((pairState.available = !1), (pairState.source = "none")),
      applyPairCompanion(),
      pairState.available || fallbackFromUnavailablePair());
  }
  function ensurePairCompanion() {
    if (pairState.fetched) {
      applyPairCompanion();
      return;
    }
    pairState.fetched = !0;
    var configuredHandle = getConfiguredPairHandle(),
      pid = getPairProductId();
    if (!configuredHandle && !pid) {
      applyPairResult(null);
      return;
    }
    function autoMatch() {
      if (!pid) {
        applyPairResult(null);
        return;
      }
      fetch(
        route("recommendations/products.json?product_id=") +
          encodeURIComponent(pid) +
          "&intent=related&limit=10",
      )
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          for (
            var products = (data && data.products) || [], comp = null, i = 0;
            i < products.length;
            i++
          ) {
            comp = pairCompanionFromProduct(products[i]);
            if (comp) break;
          }
          applyPairResult(comp, "auto");
        })
        .catch(function () {
          applyPairResult(null);
        });
    }
    if (!configuredHandle) {
      autoMatch();
      return;
    }
    fetch(route("products/" + encodeURIComponent(configuredHandle) + ".js"))
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (p) {
        var comp = pairCompanionFromProduct(p);
        comp ? applyPairResult(comp, "metafield") : autoMatch();
      })
      .catch(function () {
        autoMatch();
      });
  }
  function settingEnabled(value, fallback) {
    return value === !1 || value === "false"
      ? !1
      : value === !0 || value === "true"
        ? !0
        : fallback;
  }
  function readBundleDisplayConfig() {
    var configEl = document.getElementById("bd-config");
    if (!configEl) return null;
    try {
      var raw = JSON.parse(configEl.textContent);
      return (
        typeof raw == "string" && (raw = JSON.parse(raw)),
        Array.isArray(raw) ? null : raw || null
      );
    } catch {
      return null;
    }
  }
  function syncBundleDisplaySettings() {
    var displayConfig = readBundleDisplayConfig();
    displayConfig &&
      ((bundleState.showPricesPerItem = settingEnabled(
        displayConfig.showPricesPerItem,
        bundleState.showPricesPerItem,
      )),
      (bundleState.showPerPieceSuffix = settingEnabled(
        displayConfig.showPerPieceSuffix,
        bundleState.showPerPieceSuffix,
      )),
      displayConfig.perPieceSuffixText != null &&
        (bundleState.perPieceSuffixText = String(
          displayConfig.perPieceSuffixText || "",
        )),
      displayConfig.dealId != null &&
        (bundleState.dealId = String(displayConfig.dealId || "")),
      (bundleState.useCompareAtPrice = settingEnabled(
        displayConfig.useCompareAtPrice,
        bundleState.useCompareAtPrice,
      )));
  }
  function getBundlePerItemSuffix() {
    return (
      (bundleState.showPerPieceSuffix && bundleState.perPieceSuffixText) || ""
    );
  }
  // ── DUNIII v32 20261010 ────────────────────────────────────────────────
  // ONE place that decides the strike-through (compare-at) price and the "Save $X" of
  // every Bundle tier (1 Pack, N Pack, Perfect Pair), plus the FREE shipping
  // label.
  // Edward 2026-10-10: every tier's Save is measured against the strike price:
  //   strike = Σ per piece (variant compare-at, or its price when it has none)
  //   save   = strike − what the tier really charges
  // The free-shipping threshold and which visitors see the label are NOT in
  // this file: they come from theme settings (Theme settings → Cart) via
  // <body data-free-shipping-threshold / data-bundle-free-shipping-market>.
  // v36 20261010 — gated by the Avalonae Bundle setting useCompareAtPrice
  // (the "use the product compare-at price" switch, top level of bundle-deal.bars → bundleState). Off or
  // missing ⇒ the pre-v32 behaviour (line strike = regular price, only 1 Pack
  // shows compare-at). The FREE shipping label is NOT gated by it.
  function bundleStrikeSaveEnabled() {
    return bundleState.useCompareAtPrice === !0;
  }
  function bundleLineStrikeCents(variant, fallbackPriceCents) {
    var price = normalizeCents(variant ? variant.price : 0) ||
        normalizeCents(fallbackPriceCents);
    if (!bundleStrikeSaveEnabled()) return price;
    var compareAt = normalizeCents(variant ? variant.compare_at_price : 0);
    return compareAt > price ? compareAt : price;
  }
  function bundleTierStrikeSavings(strikeLineCents, paidTotalCents) {
    var strike = sumCents(strikeLineCents),
      paid = Math.max(0, parseInt(paidTotalCents, 10) || 0);
    strike = Math.max(strike, paid);
    return { strike: strike, savings: strike - paid };
  }
  // v42 20261010 — Edward 2026-10-10 17:10 EDT asked that the floating bar and the two places under the button also compare against the strike-through price.
  // ONE answer to "what does this tier charge, what is its strike, what does
  // it save". Callers: the tier card (updateBundleTierComparePrices /
  // updatePairTierDisplay → updateBundleTierSummary), the floating add-to-cart
  // bar (#floating-tier-info) and the line under the button (#savings-nudge),
  // both in updateGrandTotal. No other place computes a tier's Save.
  // Strike per piece = bundleLineStrikeCents (Bundle setting useCompareAtPrice
  // on ⇒ compare-at; off ⇒ regular price, 1 Pack keeps its compare-at as
  // before v32 — see getTierOriginalCents), so turning the setting off moves
  // all three places together.
  function bundleTierSaveSummary(tier) {
    if (!tier) return { total: 0, original: 0, strike: 0, savings: 0, itemCount: 1 };
    if (tier.dataset.pair === "1") {
      var targetQuantity =
          parseInt(tier.dataset.pairTargetQuantity || "1", 10) || 1,
        companionQuantity =
          parseInt(tier.dataset.pairCompanionQuantity || "1", 10) || 1,
        // v28 20260920 — per-slot price instead of one shared unitPrice.
        targetPrices = getBundleTierRowPrices(tier, targetQuantity),
        targetStrikes = getBundleTierRowStrikeCents(tier, targetQuantity),
        allocation = allocateShopifyPairBundleLinesCents(
          targetPrices.concat(
            Array(companionQuantity).fill(pairCompanionCents()),
          ),
          parseFloat(tier.dataset.pairPct) || 0,
        ),
        pairSave = bundleTierStrikeSavings(
          targetStrikes.concat(
            Array(companionQuantity).fill(pairCompanionStrikeCents()),
          ),
          allocation.total,
        );
      return {
        total: allocation.total,
        original: pairSave.strike,
        strike: pairSave.strike,
        savings: pairSave.savings,
        itemCount: targetQuantity + companionQuantity,
        targetStrikes: targetStrikes,
        allocation: allocation,
      };
    }
    var qty = parseInt(tier.dataset.qty || "1", 10) || 1,
      rowPrices = getBundleTierRowPrices(tier, qty),
      rowTotal = sumCents(rowPrices),
      total = normalizeCents(tier.dataset.totalCents);
    if (!total) {
      var discountPct = parseInt(tier.dataset.discount || "0", 10) || 0,
        free = parseInt(tier.dataset.free || "0", 10) || 0;
      total =
        free > 0
          ? // Free lines are the cheapest ones, matching Shopify's BXGY.
            sumCents(
              rowPrices
                .slice()
                .sort(function (a, b) {
                  return b - a;
                })
                .slice(0, Math.max(0, qty - free)),
            )
          : allocateShopifyPercentageBundleLinesCents(rowPrices, discountPct)
              .total;
    }
    var original = getTierOriginalCents(qty, rowTotal - total, tier),
      tierSave = bundleTierStrikeSavings([original], total);
    return {
      total: total,
      original: original,
      strike: tierSave.strike,
      savings: tierSave.savings,
      itemCount: qty,
      rowPrices: rowPrices,
      rowTotal: rowTotal,
      rowStrikes: getBundleTierRowStrikeCents(tier, qty),
    };
  }
  // v41 20261010 — threshold in cents for this visitor, or 0 when the label
  // must not show (visitor outside the listed countries / not paying in the
  // store currency; theme.liquid leaves data-bundle-free-shipping-market empty).
  function bundleFreeShippingThresholdCents() {
    var body = document.body;
    if (!body || body.getAttribute("data-bundle-free-shipping-market") !== "1")
      return 0;
    var threshold = parseFloat(
      body.getAttribute("data-free-shipping-threshold") || "",
    );
    return threshold > 0 ? Math.round(threshold * 100) : 0;
  }
  function bundleTierFreeShipping(paidTotalCents) {
    var threshold = bundleFreeShippingThresholdCents(),
      paid = Math.max(0, parseInt(paidTotalCents, 10) || 0);
    return threshold > 0 && paid >= threshold;
  }
  function renderBundleTierShippingNote(tier, paidTotalCents) {
    if (!tier) return;
    // Left text column, under "Save $X": the price column is vertically
    // centred in the card grid, so growing it would push the price under the
    // corner badge.
    var column = tier.querySelector(":scope > .px-4 .flex-1");
    if (!column) return;
    var note = column.querySelector(".bundle-tier__ship");
    if (!bundleTierFreeShipping(paidTotalCents)) {
      note && note.remove();
      return;
    }
    note ||
      ((note = document.createElement("span")),
      (note.className = "bundle-tier__ship is-free"));
    column.lastElementChild !== note && column.appendChild(note);
    note.textContent = "Free shipping";
  }
  function getBundleTierRowStrikeCents(tier, qty) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var rows = getBundleTierRowElements(tier),
      selected = null,
      strikes = [];
    for (var i = 0; i < qty; i++) {
      var variant = rows[i]
        ? resolveBundleRowVariant(rows[i])
        : selected || (selected = getSelectedBundleVariant());
      strikes.push(bundleLineStrikeCents(variant, bundleState.unitPrice));
    }
    return strikes;
  }
  function pairCompanionSelectedVariant() {
    if (!pairState.available || !pairState.data) return null;
    for (var vs = pairState.data.variants || [], i = 0; i < vs.length; i++)
      if (String(vs[i].id) === String(pairState.variantId)) return vs[i];
    return vs[0] || null;
  }
  function pairCompanionStrikeCents() {
    return bundleLineStrikeCents(
      pairCompanionSelectedVariant(),
      pairCompanionCents(),
    );
  }
  function formatBundleBarLabel(
    template,
    perItemCents,
    savingsCents,
    savedPercentage,
  ) {
    return String(template || "")
      .split("{{price_per_item}}")
      .join(formatMoney(perItemCents))
      .split("{{saved_percentage}}")
      .join(savedPercentage > 0 ? savedPercentage + "%" : "")
      .split("{{saved_amount}}")
      .join(savingsCents > 0 ? formatMoney(savingsCents) : "")
      .split("{{saved_total}}")
      .join(savingsCents > 0 ? formatMoney(savingsCents) : "")
      .trim();
  }
  function normalizeCents(value) {
    var cents = parseInt(value || 0, 10);
    return Number.isFinite(cents) && cents > 0 ? cents : 0;
  }
  function getProductCompareAtCents() {
    var totalEl = document.getElementById("pdp-grand-total");
    return normalizeCents(totalEl ? totalEl.dataset.compareAtPrice : 0);
  }
  function getSelectedBundleVariant(variantList) {
    var variants = variantList || bundleState.variants || [];
    if (!variants.length) return null;
    var variantInput = document.querySelector('#product-form [name="id"]'),
      selectedId = variantInput ? String(variantInput.value || "") : "",
      formVariant = selectedId
        ? variants.find(function (v) {
            return String(v.id) === selectedId;
          })
        : null,
      tier = bundleState.activeTier,
      row = tier
        ? tier.querySelector(
            ".tier-size-row:not(.tier-upsell-row):not(.tier-free-gift)",
          )
        : null;
    if (!row) return formVariant || null;
    var colorBtn = row.querySelector(".tier-color-btn.is-active"),
      sizeBtn = row.querySelector(".size-btn[data-size].is-selected"),
      globalColor =
        document.querySelector(".color-swatch.is-active")?.dataset?.colorName ||
        "",
      color = colorBtn ? colorBtn.dataset.color : globalColor,
      size = sizeBtn ? sizeBtn.dataset.size : "";
    return (
      variants.find(function (v) {
        var opts = v.options || [];
        return !(
          (color && opts.indexOf(color) === -1) ||
          (size && opts.indexOf(size) === -1)
        );
      }) ||
      formVariant ||
      null
    );
  }
  // ── DUNIII v28 20260920 ────────────────────────────────────────────────
  // Single source of truth for "which variant is this bundle slot pointing at".
  // Add-to-cart, the tier header, the ATC button and the per-line prices all
  // call this, so they can no longer disagree when two slots hold variants at
  // different prices (Edward 20260920 points 5 & 7).
  function resolveBundleRowVariant(row, variantList, globalColorOverride) {
    var variants =
      Array.isArray(variantList) && variantList.length
        ? variantList
        : bundleState.variants && bundleState.variants.length
          ? bundleState.variants
          : readBundleVariants();
    if (!row || !variants.length) return null;
    var sizeBtn = row.querySelector(".size-btn[data-size].is-selected"),
      size = sizeBtn ? sizeBtn.dataset.size : "",
      colorBtn = row.querySelector(".tier-color-btn.is-active"),
      globalColor =
        globalColorOverride != null
          ? globalColorOverride
          : document.querySelector(".color-swatch.is-active")?.dataset
              ?.colorName || "",
      color = colorBtn ? colorBtn.dataset.color : globalColor,
      match = variants.find(function (v) {
        var opts = v.options || [];
        return (
          v.available &&
          (!size || opts.indexOf(size) !== -1) &&
          (!color || opts.indexOf(color) !== -1)
        );
      });
    // v39 20261010 — the sold-out fallback keeps the slot's colour; it used to
    // take the first variant of that size in ANY colour (silent colour swap).
    return (
      match ||
      (size
        ? variants.find(function (v) {
            var opts = v.options || [];
            return (
              opts.indexOf(size) !== -1 &&
              (!color || opts.indexOf(color) !== -1)
            );
          })
        : null) ||
      null
    );
  }
  function getBundleTierRowElements(tier) {
    return tier
      ? Array.prototype.slice.call(
          tier.querySelectorAll(
            ".tier-size-row:not(.tier-upsell-row):not(.tier-free-gift)",
          ),
        )
      : [];
  }
  function sumCents(list) {
    return (Array.isArray(list) ? list : []).reduce(function (sum, value) {
      return sum + (parseInt(value, 10) || 0);
    }, 0);
  }
  // One entry per slot. Slots whose row is not rendered/selected yet fall back
  // to bundleState.unitPrice, so first paint keeps the previous numbers.
  function getBundleTierRowPrices(tier, qty) {
    qty =
      Math.max(
        1,
        parseInt(qty != null ? qty : tier && tier.dataset.qty, 10) || 1,
      ) || 1;
    var rows = getBundleTierRowElements(tier),
      prices = [];
    for (var i = 0; i < qty; i++) {
      var variant = rows[i] ? resolveBundleRowVariant(rows[i]) : null,
        cents = normalizeCents(variant ? variant.price : 0);
      prices.push(cents || bundleState.unitPrice || 0);
    }
    return prices;
  }
  var bundlePriceRecalcBusy = !1;
  // Both updateGrandTotal() and updateATCButton() call this first, so whichever
  // order a click handler uses, the tier header and the button read the same
  // freshly recomputed dataset.totalCents.
  function recalcBundleTierPrices() {
    if (bundlePriceRecalcBusy) return;
    bundlePriceRecalcBusy = !0;
    try {
      (syncBundleUnitPrice(), refreshDynamicBundleTierPrices());
    } finally {
      bundlePriceRecalcBusy = !1;
    }
  }
  function syncBundleUnitPrice(variantList) {
    var selected = getSelectedBundleVariant(variantList),
      selectedPrice = normalizeCents(selected ? selected.price : 0);
    if (!selectedPrice) return !1;
    var changed = bundleState.unitPrice !== selectedPrice;
    return ((bundleState.unitPrice = selectedPrice), changed);
  }
  function getBundleCompareAtCents() {
    var selected = getSelectedBundleVariant();
    if (
      selected &&
      Object.prototype.hasOwnProperty.call(selected, "compare_at_price")
    ) {
      var sc = normalizeCents(selected.compare_at_price);
      if (sc > 0) return sc;
    }
    return (
      normalizeCents(bundleState.compareAtPrice) || getProductCompareAtCents()
    );
  }
  // v28 20260920 — `tier` is optional; when given, the strike-through original
  // is the sum of the slots' real variant prices instead of unitPrice × qty.
  function getTierOriginalCents(qty, savings, tier) {
    ((qty = parseInt(qty || 1, 10) || 1),
      (savings = Math.max(0, normalizeCents(savings))));
    var rowPrices = tier ? getBundleTierRowPrices(tier, qty) : null,
      regularTotal = rowPrices
        ? sumCents(rowPrices)
        : bundleState.unitPrice * qty,
      unitForCompare = rowPrices ? rowPrices[0] : bundleState.unitPrice,
      rowVariant = tier
        ? resolveBundleRowVariant(getBundleTierRowElements(tier)[0])
        : null,
      rowCompareAt = rowVariant
        ? normalizeCents(rowVariant.compare_at_price)
        : 0,
      compareAt = rowCompareAt || getBundleCompareAtCents(),
      compareTotal = compareAt > unitForCompare ? compareAt * qty : 0;
    // v31 and earlier: compare-at for 1 Pack only, regular price for N Pack.
    // return qty === 1 ? Math.max(regularTotal, compareTotal) : regularTotal;
    // v32 20261010 — every tier uses the per-piece strike price (one truth),
    // only when the Bundle setting useCompareAtPrice is on (v36).
    if (!bundleStrikeSaveEnabled())
      return qty === 1 ? Math.max(regularTotal, compareTotal) : regularTotal;
    return Math.max(
      regularTotal,
      sumCents(getBundleTierRowStrikeCents(tier, qty)),
    );
  }
  function shouldShowTierPerItem(qty) {
    return (parseInt(qty || 1, 10) || 1) > 1 && bundleState.showPricesPerItem;
  }
  function getTierDisplayPriceCents(total, qty) {
    return shouldShowTierPerItem(qty) ? Math.round(total / qty) : total;
  }
  function getTierDisplayOriginalCents(originalTotal, qty) {
    return shouldShowTierPerItem(qty)
      ? Math.round(originalTotal / qty)
      : originalTotal;
  }
  function getTierDisplaySuffix(qty) {
    return shouldShowTierPerItem(qty) ? getBundlePerItemSuffix() : "";
  }
  function ensureTierCompareEl(tier, totalEl) {
    var compareEl = tier ? tier.querySelector(".bundle-tier__compare") : null;
    return (
      !compareEl &&
        totalEl &&
        ((compareEl = document.createElement("p")),
        (compareEl.className = "bundle-tier__compare"),
        (compareEl.style.cssText =
          "font-family:var(--font-body);font-size:9px;font-weight:300;color:var(--color-accent);text-decoration:line-through;"),
        totalEl.insertAdjacentElement("afterend", compareEl)),
      compareEl
    );
  }
  function escHtml(s) {
    var d = document.createElement("div");
    return ((d.textContent = s || ""), d.innerHTML);
  }
  function colorToHex(name) {
    var map = {
      oat: "#F5EFE7",
      charcoal: "#2D2D2D",
      taupe: "#C4B5A0",
      cloud: "#FAFAFA",
      sand: "#D4C5B2",
      ivory: "#FFFFF0",
      cream: "#FFFDD0",
      black: "#1a1a1a",
      white: "#ffffff",
      nude: "#E8C4A2",
      blush: "#F2D7D5",
      rose: "#C48B9F",
      navy: "#1B2A4A",
      wine: "#722F37",
      sage: "#9CAF88",
      lavender: "#B4A7D6",
      mocha: "#8B7355",
      espresso: "#3C2415",
      "dusty-rose": "#DCAE96",
      mauve: "#E0B0D5",
    };
    return map[(name || "").toLowerCase().replace(/\s+/g, "-")] || "#ccc";
  }
  function gidToId(gid) {
    if (!gid) return null;
    if (typeof gid == "number") return gid;
    var parts = String(gid).split("/");
    return parseInt(parts[parts.length - 1]) || null;
  }
  function formatBundleDiscountLabel(type, value) {
    return type === "percentage"
      ? value + "% off"
      : formatMoney(Math.round((parseFloat(value) || 0) * 100)) + " off";
  }
  // v44 20261018 (099 wave 2 m2e, hook 1) — skin-provided per-item row template.
  // A skin may put <template id="bd-tier-item-tpl"> on the page; its first
  // element is cloned once per item row of a quantity tier. The template only
  // carries layout and static text: "{n}" in a text node becomes the row
  // number. The engine-built nodes are moved into data-bd-slot="thumb"
  // (thumbnail, optional; no slot = no thumbnail), "options" (the
  // .tier-opt-group subtrees, unchanged) and "price" (the .tier-item-price
  // node; money is never written by the skin). An optional
  // data-bd-slot="caret" element replaces the svg arrow in each dropdown
  // trigger of that row. No template on the page = the built-in string rows,
  // silently (black skin). Template without the options or price slot = the
  // built-in rows plus one console.warn. Pair rows and the gift row never use
  // the template. Contract: design/dn5-pdp/ENGINE-CONTRACT.md §6.
  function bdTplWarn(key, msg) {
    var seen = bdTplWarn.seen || (bdTplWarn.seen = {});
    seen[key] || ((seen[key] = 1), console.warn(msg));
  }
  function bdTierItemTemplate() {
    var tpl = document.getElementById("bd-tier-item-tpl");
    if (!tpl) return null;
    var root = tpl.content ? tpl.content.firstElementChild : null;
    if (
      !root ||
      !root.querySelector('[data-bd-slot="options"]') ||
      !root.querySelector('[data-bd-slot="price"]')
    ) {
      bdTplWarn(
        "tier",
        '[bundle] #bd-tier-item-tpl needs data-bd-slot="options" and data-bd-slot="price"; using the built-in rows',
      );
      return null;
    }
    return root;
  }
  function bdReplaceTextToken(root, token, value) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT),
      node;
    while ((node = walker.nextNode()))
      node.data.indexOf(token) !== -1 &&
        (node.data = node.data.split(token).join(value));
  }
  function bdFillTierItemRows(tierEl, tplRoot, rowsHtml) {
    tierEl.querySelectorAll("[data-bd-tpl-row]").forEach(function (ph) {
      var r = ph.getAttribute("data-bd-tpl-row"),
        src = document.createElement("div");
      src.innerHTML = rowsHtml[r] || "";
      var built = src.firstElementChild,
        row = tplRoot.cloneNode(true),
        slot = function (name) {
          return row.querySelector('[data-bd-slot="' + name + '"]');
        },
        thumb = built && built.querySelector(".tier-item-thumb"),
        price = built && built.querySelector(".tier-item-price"),
        caret = slot("caret");
      row.classList.add("tier-size-row");
      row.setAttribute("data-item-index", r);
      bdReplaceTextToken(row, "{n}", String(Number(r) + 1));
      if (thumb && slot("thumb")) {
        thumb.removeAttribute("style");
        var thumbImg = thumb.querySelector("img");
        thumbImg && thumbImg.removeAttribute("style");
        slot("thumb").appendChild(thumb);
      }
      built &&
        built.querySelectorAll(".tier-opt-group").forEach(function (group) {
          slot("options").appendChild(group);
        });
      price && slot("price").appendChild(price);
      if (caret) {
        caret.parentNode.removeChild(caret);
        caret.removeAttribute("data-bd-slot");
        row
          .querySelectorAll(".bundle-variant-select__trigger > svg")
          .forEach(function (svg) {
            svg.parentNode.replaceChild(caret.cloneNode(!0), svg);
          });
      }
      ph.parentNode.replaceChild(row, ph);
    });
  }
  // v46 20261018 (099 2f, ENGINE-CONTRACT §6.7) — the non-pair tier price (and its savePct) lifted out of
  // buildDynamicBundleTiers' calcBarPrice unchanged, so the PDP cards and window.dn.bundle.pcts() read the
  // percentage from ONE function. rowPrices = the price of each slot (uniform unitPrice on first paint).
  function bdBarPriceCore(bar, qty, rowPrices, unitPrice) {
    var rowTotal = sumCents(rowPrices),
      originals = rowPrices.slice(),
      lineFinals = null,
      pv = parseFloat(bar.priceValue) || 0,
      each,
      savePct,
      total;
    if (bar.priceType === "fixed_price")
      pv > 0
        ? ((each = pv * 100),
          (lineFinals = rowPrices.map(function () {
            return Math.max(0, Math.round(pv * 100));
          })),
          (total = sumCents(lineFinals)),
          (savePct = rowTotal > 0 ? ((rowTotal - total) / rowTotal) * 100 : 0))
        : parseFloat(bar.percentOff) > 0
          ? ((savePct = parseFloat(bar.percentOff)),
            (lineFinals = allocateShopifyPercentageBundleLinesCents(
              rowPrices,
              savePct,
            ).finals),
            (total = sumCents(lineFinals)),
            (each = qty > 0 ? Math.round(total / qty) : unitPrice))
          : ((lineFinals = rowPrices.slice()),
            (total = rowTotal),
            (each = qty > 0 ? Math.round(total / qty) : unitPrice),
            (savePct = 0));
    else if (bar.priceType === "flat_discount" && pv > 0)
      ((lineFinals = rowPrices.map(function (price) {
        return Math.max(0, price - Math.round(pv * 100));
      })),
        (total = sumCents(lineFinals)),
        (each = qty > 0 ? Math.round(total / qty) : unitPrice),
        (savePct = rowTotal > 0 ? ((rowTotal - total) / rowTotal) * 100 : 0));
    // buy_x_get_y still prices off the uniform unitPrice — this deal type is
    // not configured on duniii today and generalising it was out of scope.
    else if (bar.priceType === "buy_x_get_y" && bar.bxgy && unitPrice > 0) {
      originals = Array(qty).fill(unitPrice);
      var bx = bar.bxgy,
        buyQ = parseInt(bx.buyQuantity) || 0,
        getQ = parseInt(bx.getQuantity) || 0,
        groupQ = buyQ + getQ,
        perUnit = function (type, val, q) {
          return (
            (val = parseFloat(val) || 0),
            type === "percentage"
              ? unitPrice * (1 - val / 100)
              : type === "flat_discount"
                ? unitPrice - val * 100
                : type === "fixed_price"
                  ? q > 0
                    ? (val * 100) / q
                    : 0
                  : unitPrice
          );
        },
        buyEach = Math.max(
          0,
          perUnit(bx.buyPriceType, bx.buyPriceValue, buyQ),
        ),
        getEach = Math.max(
          0,
          perUnit(bx.getPriceType, bx.getPriceValue, getQ),
        ),
        groupPaid = buyQ * buyEach + getQ * getEach;
      (groupQ > 0 && qty > groupQ && qty % groupQ === 0
        ? (total = Math.round(groupPaid * (qty / groupQ)))
        : (total = Math.round(
            groupPaid + Math.max(0, qty - groupQ) * unitPrice,
          )),
        (each = qty > 0 ? Math.round(total / qty) : unitPrice),
        (savePct =
          unitPrice * qty > 0
            ? ((unitPrice * qty - total) / (unitPrice * qty)) * 100
            : 0));
    } else {
      savePct =
        parseFloat(bar.priceType === "percentage" ? pv : bar.percentOff) ||
        0;
      var percentageAllocation = allocateShopifyPercentageBundleLinesCents(
        rowPrices,
        savePct,
      );
      total = percentageAllocation.total;
      lineFinals = percentageAllocation.finals;
      each = qty > 0 ? Math.round(total / qty) : unitPrice;
    }
    var originalTotal = sumCents(originals);
    return (
      (savePct < 0 || savePct > 100) &&
        ((savePct = 0),
        (lineFinals = originals.slice()),
        (each = qty > 0 ? Math.round(originalTotal / qty) : unitPrice),
        (total = originalTotal)),
      (each = Math.max(0, Math.round(each))),
      total == null && (total = each * qty),
      (total = Math.max(0, Math.round(total))),
      (Array.isArray(lineFinals) && lineFinals.length === originals.length) ||
        (lineFinals = (function () {
          var cut = allocateProportionalDiscountCents(
            originals,
            Math.max(0, originalTotal - total),
          );
          return originals.map(function (price, index) {
            return Math.max(0, price - cut[index]);
          });
        })()),
      {
        each,
        total,
        savings: originalTotal - total,
        savePct: Math.round(savePct),
        originalTotal: originalTotal,
        lineOriginals: originals,
        lineFinals: lineFinals,
      }
    );
  }
  // v46 20261018 (099 2f, ENGINE-CONTRACT §6.7) — bundle percentages for skins. The only source is
  // bundle-deal.bars run through bdBarPriceCore (the same function the PDP cards use); a skin never
  // computes or types a percentage. Sources, in order:
  //   · the PDP: #bd-config + the .bundle-tiers[data-dynamic] container (unit price = selected variant);
  //   · <script type="application/json" data-bd-bars data-handle data-unit-cents> emitted by
  //     snippets/dn-bd-bars.liquid for a product the skin picked (home, collection, announcement).
  // Map = { quantity: percent } for every non-pair bar (quantity 1 included, usually 0).
  // Text tokens: {pct_N} = percent of the quantity-N bar; {pct} = percent of the element's data-bd-qty;
  // {pct_max} = the largest one. Elements marked [data-bd-pct-tpl] are filled in place and get
  // data-bd-pct-done; a token that cannot be resolved hides the element (hidden) instead of showing a
  // made-up number. The product comes from the nearest [data-bd-handle] (else the PDP, else the first
  // data-bd-bars script on the page). The black skin declares none of this.
  var bdPctWarned = !1;
  function bdPctWarn(msg) {
    if (bdPctWarned) return;
    bdPctWarned = !0;
    try {
      console.warn("[dn.bundle] " + msg);
    } catch (e) {}
  }
  function bdBarsList(raw) {
    if (typeof raw == "string")
      try {
        raw = JSON.parse(raw);
      } catch (e) {
        return [];
      }
    return Array.isArray(raw) ? raw : raw && Array.isArray(raw.bars) ? raw.bars : [];
  }
  function bdPctMap(bars, unitCents) {
    var out = {},
      any = !1;
    (bars || []).forEach(function (bar) {
      if (!bar || isPairBar(bar)) return;
      var q = parseInt(bar.quantity) || 1,
        info = bdBarPriceCore(bar, q, Array(q).fill(unitCents), unitCents);
      ((out[q] = info.savePct), (any = !0));
    });
    return any ? out : null;
  }
  function bdPdpSource() {
    var cfg = document.getElementById("bd-config"),
      box = document.querySelector('.bundle-tiers[data-product-handle]');
    if (!cfg || !box) return null;
    var bars;
    try {
      bars = bdBarsList(JSON.parse(cfg.textContent));
    } catch (e) {
      return null;
    }
    var unit = bundleState.unitPrice || normalizeCents(box.dataset.unitPriceCents);
    return { handle: box.dataset.productHandle || "", bars: bars, unit: unit };
  }
  function bdScriptSource(handle) {
    var list = document.querySelectorAll("script[data-bd-bars]");
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (handle && el.getAttribute("data-handle") !== handle) continue;
      var bars;
      try {
        bars = bdBarsList(JSON.parse(el.textContent));
      } catch (e) {
        continue;
      }
      return {
        handle: el.getAttribute("data-handle") || "",
        bars: bars,
        unit: normalizeCents(el.getAttribute("data-unit-cents")),
      };
    }
    return null;
  }
  function bdPcts(handle) {
    var pdp = bdPdpSource(),
      src = handle
        ? pdp && pdp.handle === handle
          ? pdp
          : bdScriptSource(handle)
        : pdp || bdScriptSource("");
    return src ? bdPctMap(src.bars, src.unit) : null;
  }
  function bdPctText(str, handle, qty) {
    str = String(str == null ? "" : str);
    if (!/\{pct(?:_\d+|_max)?\}/.test(str)) return str;
    var map = bdPcts(handle || ""),
      bad = !1,
      out = str.replace(/\{pct(?:_(\d+|max))?\}/g, function (m, n) {
        var v;
        if (map && n === "max")
          Object.keys(map).forEach(function (k) {
            (v == null || map[k] > v) && (v = map[k]);
          });
        else {
          var q = parseInt(n || qty, 10);
          v = map && q > 0 ? map[q] : void 0;
        }
        return v == null ? ((bad = !0), m) : String(v);
      });
    return bad ? null : out;
  }
  // Tokens are replaced inside the element's text nodes only, so child nodes the skin or another engine
  // script owns (e.g. the free-shipping amount span) stay in place. An element is filled once
  // (data-bd-pct-done); an element with a token that cannot be resolved is hidden.
  function bdPctFill(root) {
    root = root || document;
    var els = [];
    (root.matches && root.matches("[data-bd-pct-tpl]") && els.push(root),
      root.querySelectorAll &&
        root.querySelectorAll("[data-bd-pct-tpl]").forEach(function (el) {
          els.push(el);
        }));
    els.forEach(function (el) {
      if (el.hasAttribute("data-bd-pct-done")) return;
      var host = el.closest("[data-bd-handle]"),
        handle = host ? host.getAttribute("data-bd-handle") : "",
        qty = el.getAttribute("data-bd-qty"),
        nodes = [],
        ok = !0,
        walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) nodes.push(walker.currentNode);
      var texts = nodes.map(function (n) {
        var t = bdPctText(n.nodeValue, handle, qty);
        return (t == null && (ok = !1), t);
      });
      if (!ok) {
        ((el.hidden = !0),
          bdPctWarn("no bundle-deal.bars percentage for \"" + el.textContent.trim() + "\" (element hidden)"));
        return;
      }
      (nodes.forEach(function (n, k) {
        n.nodeValue !== texts[k] && (n.nodeValue = texts[k]);
      }),
        el.setAttribute("data-bd-pct-done", ""));
    });
  }
  window.dn = window.dn || {};
  window.dn.bundle = { pcts: bdPcts, text: bdPctText, fill: bdPctFill };
  function buildDynamicBundleTiers() {
    const container = document.querySelector(
      '.bundle-tiers[data-dynamic="true"]',
    );
    if (!container) return !1;
    if (container.dataset.bundleBuilt === "true") return !0;
    const configEl = document.getElementById("bd-config");
    if (!configEl) return !1;
    let rawConfig;
    try {
      rawConfig = JSON.parse(configEl.textContent);
    } catch {
      return !1;
    }
    if (typeof rawConfig == "string")
      try {
        rawConfig = JSON.parse(rawConfig);
      } catch {
        return !1;
      }
    const displayConfig = Array.isArray(rawConfig) ? {} : rawConfig || {},
      bars = Array.isArray(rawConfig)
        ? rawConfig
        : rawConfig && rawConfig.bars
          ? rawConfig.bars
          : [];
    if (!bars.length) return !1;
    const showPricesPerItem = settingEnabled(
        displayConfig.showPricesPerItem,
        !0,
      ),
      showPerPieceSuffix = settingEnabled(displayConfig.showPerPieceSuffix, !0),
      perPieceSuffixText = String(displayConfig.perPieceSuffixText || "/ea");
    ((bundleState.showPricesPerItem = showPricesPerItem),
      (bundleState.showPerPieceSuffix = showPerPieceSuffix),
      (bundleState.perPieceSuffixText = perPieceSuffixText),
      (bundleState.dealId = String(displayConfig.dealId || "")));
    const variantsEl = document.getElementById("bd-variants"),
      optionsEl = document.getElementById("bd-options"),
      variants = variantsEl ? JSON.parse(variantsEl.textContent) : [],
      options = optionsEl ? JSON.parse(optionsEl.textContent) : [],
      selectedVariant = getSelectedBundleVariant(variants),
      unitPrice =
        normalizeCents(selectedVariant ? selectedVariant.price : 0) ||
        getBundleUnitPriceCents(container),
      firstCompareAt = variants.length
        ? normalizeCents(variants[0].compare_at_price)
        : 0,
      anyCompareAt = variants.reduce(function (max, v) {
        var cents = normalizeCents(v.compare_at_price);
        return cents > max ? cents : max;
      }, 0);
    ((bundleState.unitPrice = unitPrice),
      (bundleState.compareAtPrice =
        firstCompareAt || getProductCompareAtCents() || anyCompareAt),
      (bundleState.useCompareAtPrice = settingEnabled(
        displayConfig.useCompareAtPrice,
        !1,
      )));
    const sizeOpt = options.find(function (o) {
        return String(o.name || "").toLowerCase() === "size";
      }),
      sizes = sizeOpt ? sizeOpt.values : [];
    function isSizeAvailable(size) {
      var activeColor = document.querySelector(".color-swatch.is-active"),
        color = activeColor ? activeColor.dataset.colorName : null;
      return variants.some(function (v) {
        return (
          v.options.indexOf(size) !== -1 &&
          v.available &&
          (!color || v.options.indexOf(color) !== -1)
        );
      });
    }
    // v28 20260920 — `tierEl` is optional. Passing it prices every slot from the
    // variant that slot really has selected; without it the old uniform
    // unitPrice behaviour is used (first paint, before the rows exist).
    function calcBarPrice(bar, tierEl) {
      var unitPrice = bundleState.unitPrice;
      if (isPairBar(bar)) {
        var targetQty = pairTargetQuantity(bar),
          targetPrices = tierEl
            ? getBundleTierRowPrices(tierEl, targetQty)
            : Array(targetQty).fill(unitPrice),
          pvp = pairBarPct(bar),
          companionFull = pairCompanionCents(),
          pairAllocation = allocateShopifyPairBundleLinesCents(
            targetPrices.concat(
              Array(pairCompanionQuantity(bar)).fill(companionFull),
            ),
            pvp,
          ),
          combinedFull = pairAllocation.originalTotal,
          combinedDisc = pairAllocation.total;
        return {
          each: combinedDisc,
          total: combinedDisc,
          savings: combinedFull - combinedDisc,
          savePct: Math.round(pvp),
          pairFull: combinedFull,
          originalTotal: combinedFull,
          lineOriginals: pairAllocation.originals,
          lineFinals: pairAllocation.finals,
        };
      }
      var qty = parseInt(bar.quantity) || 1,
        rowPrices = tierEl
          ? getBundleTierRowPrices(tierEl, qty)
          : Array(qty).fill(unitPrice);
      return bdBarPriceCore(bar, qty, rowPrices, unitPrice);
    }
    bundleState.calculateBarPrice = calcBarPrice;
    function esc(s) {
      var d = document.createElement("div");
      return ((d.textContent = s || ""), d.innerHTML);
    }
    var icons = [
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" stroke-width="1.5"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" stroke-width="1.5"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.07-2.14-2-3.5-2-5.5 0-1.5.5-3 2-4"/><path d="M15.5 14.5A2.5 2.5 0 0 0 18 12c0-1.38-.5-2-1-3-1.07-2.14-2-3.5-2-5.5 0-1.5.5-3 2-4"/><path d="M2 22h20"/></svg>',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" stroke-width="1.5"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
      ],
      defaultIdx = bars.findIndex(function (bar) {
        return bar && bar.isDefault && !bar.soldOut;
      }),
      tiersWrap = container.querySelector('div[style*="flex-direction"]');
    defaultIdx < 0 && (defaultIdx = 0);
    if (tiersWrap) tiersWrap.innerHTML = "";
    else return !1;
    var bdItemTpl = bdTierItemTemplate(),
      bdPctsDeclared = container.hasAttribute("data-bd-pcts");
    return (
      bars.forEach(function (bar, i) {
        var isPair = isPairBar(bar),
          qty = isPair ? pairTargetQuantity(bar) : parseInt(bar.quantity) || 1,
          itemCount = isPair ? pairTotalQuantity(bar) : qty,
          info = calcBarPrice(bar),
          originalTotal = isPair
            ? bundleTierStrikeSavings(
                Array(qty)
                  .fill(bundleLineStrikeCents(getSelectedBundleVariant(variants), unitPrice))
                  .concat(
                    Array(pairCompanionQuantity(bar)).fill(
                      pairCompanionStrikeCents(),
                    ),
                  ),
                info.total,
              ).strike
            : getTierOriginalCents(qty, info.savings),
          firstPaintSavings = Math.max(0, originalTotal - info.total),
          isListLayout =
            container.dataset.dn2BundleStyle === "list",
          displayPrice = isListLayout
            ? info.total
            : isPair
            ? info.total
            : getTierDisplayPriceCents(info.total, qty),
          displayOriginal = isListLayout
            ? originalTotal
            : isPair
            ? info.pairFull
            : getTierDisplayOriginalCents(originalTotal, qty),
          displaySuffix = isPair ? "" : getTierDisplaySuffix(qty),
          perItemBadge = formatBundleBarLabel(
            bar.label,
            Math.round(info.total / itemCount),
            firstPaintSavings,
            info.savePct,
          ),
          showVariantTypesLabel = !isPair,
          isActive = i === defaultIdx,
          bdRowsHtml = {},
          html = "";
        (bar.badgeText &&
          (html +=
            '<div class="bundle-tier__badge" style="background:' +
            (isActive ? "var(--color-primary)" : "var(--color-warm)") +
            ';">' +
            esc(bar.badgeText) +
            "</div>"),
          (html +=
            '<div class="px-4 py-3" style="padding:0.875rem 1rem;"><div class="flex items-start gap-3"><div class="bundle-tier__radio"><div class="bundle-tier__radio-inner"></div></div><div class="flex-1" style="min-width:0;"><div class="flex items-center gap-2">' +
            icons[Math.min(i, icons.length - 1)] +
            '<span style="font-family:var(--font-body);font-size:0.82rem;font-weight:500;color:var(--color-primary);">' +
            esc(bar.title || qty + " Piece" + (qty > 1 ? "s" : "")) +
            '</span><p class="bundle-tier__meta" data-r2-tier-meta="1" style="font-family:var(--font-body);font-size:9px;font-weight:400;color:var(--color-accent);">' +
            (perItemBadge
              ? '<span class="bundle-tier__only-each">' +
                esc(perItemBadge) +
                "</span>"
              : "") +
            (firstPaintSavings > 0
              ? '<span class="bundle-tier__saving">Save ' + formatMoney(firstPaintSavings) + "</span>"
              : "") +
            "</p></div>"),
          (html +=
            '<p style="font-family:var(--font-body);font-size:10px;font-weight:300;color:var(--color-accent);margin-top:0.125rem;">' +
            esc(
              (bar.subtitle || (qty === 1 ? "Standard price" : ""))
                .replace(
                  "{{saved_percentage}}",
                  info.savePct > 0 ? info.savePct + "%" : "",
                )
                .replace(
                  "{{saved_amount}}",
                  firstPaintSavings > 0 ? formatMoney(firstPaintSavings) : "",
                ),
            ) +
            "</p>" +
            '</div><div class="bundle-tier__price-column" style="text-align:left;flex-shrink:0;"><p class="bundle-tier__total" style="font-family:var(--font-heading);font-size:0.95rem;font-weight:400;color:var(--color-primary);">' +
            formatMoney(info.total) +
            '</p><p class="bundle-tier__compare" style="font-family:var(--font-body);font-size:9px;font-weight:300;color:var(--color-accent);text-decoration:line-through;' +
            (displayOriginal > displayPrice ? "" : "display:none;") +
            '">' +
            (displayOriginal > displayPrice
              ? formatMoney(displayOriginal)
              : "") +
            "</p>"),
          (html += "</div></div></div>"),
          (html +=
            '<div class="bundle-tier__body" style="' +
            (isActive ? "" : "max-height:0;") +
            'overflow:hidden;transition:max-height 0.35s cubic-bezier(0.22,1,0.36,1);"><div><div class="bundle-panel-head"><strong>' +
            itemCount +
            " item" +
            (itemCount === 1 ? "" : "s") +
            " in this " +
            (isPair ? "pair" : "pack") +
            "</strong><span>" +
            (firstPaintSavings > 0 && originalTotal > 0
              ? "Save " + Math.round((firstPaintSavings / originalTotal) * 100) + "%"
              : "Standard price") +
            '</span></div><div class="bundle-line-items">' +
            (showVariantTypesLabel
              ? '<div class="bundle-variant-types-label">' +
                options
                  .map(function (option) {
                    return esc(option.name || "Option");
                  })
                  .join(", ") +
                "</div>"
              : "")));
        var colorImageMap = {},
          swatchEl = document.getElementById("bd-swatches");
        if (swatchEl) {
          try {
            colorImageMap = JSON.parse(swatchEl.textContent) || {};
          } catch {}
          Object.keys(colorImageMap).forEach(function (k) {
            colorImageMap[k] || delete colorImageMap[k];
          });
        }
        for (
          var colorHexMap = {
              Beige: "#D2B48C",
              Black: "#222",
              White: "#FFF",
              Blue: "#3B82F6",
              Navy: "#1E3A5F",
              Pink: "#EC4899",
              Red: "#EF4444",
              Green: "#22C55E",
              Purple: "#A855F7",
              Gray: "#9CA3AF",
              Grey: "#9CA3AF",
              Brown: "#92400E",
              Cream: "#FFFDD0",
              Ivory: "#FFFFF0",
              Nude: "#E3BC9A",
              Wine: "#722F37",
              Burgundy: "#800020",
              Coral: "#FF7F50",
              Lavender: "#E6E6FA",
              Mint: "#98FF98",
              Teal: "#008080",
              Gold: "#D4AF37",
              Silver: "#C0C0C0",
              Khaki: "#C3B091",
              Olive: "#808000",
              Orange: "#F97316",
              Yellow: "#EAB308",
              Champagne: "#F7E7CE",
            },
            activeColorSw = document.querySelector(".color-swatch.is-active"),
            defaultColor = activeColorSw ? activeColorSw.dataset.colorName : "",
            hasFreeGift = bar.gift && bar.gift.enabled,
            r = 0;
          r < qty;
          r++
        ) {
          var bdRowStart = html.length;
          html +=
            '<div class="tier-size-row' +
              (isPair ? " tier-pair-target-row" : "") +
              '" data-item-index="' +
            r +
            '" style="' +
            (r > 0
              ? "margin-top:0.75rem;border-top:1px solid rgba(232,226,217,0.3);padding-top:0.75rem;"
              : "") +
            '">';
          var itemThumbUrl = colorImageMap[defaultColor] || "";
          if (
            ((html +=
              '<div class="bundle-line-item">'),
            itemThumbUrl &&
              (html +=
                '<div class="tier-item-thumb" data-item-row="' +
                r +
                '"' +
                (isPair ? ' data-pairux-zoom title="Tap to enlarge"' : "") +
                ' style="flex-shrink:0;width:3rem;height:3.75rem;border-radius:3px;overflow:hidden;border:1px solid rgba(232,226,217,0.4);background:var(--color-surface,#F0EBE3);' +
                (isPair ? "cursor:zoom-in;" : "") +
                '"><img src="' +
                esc(itemThumbUrl) +
                '" alt="" style="width:100%;height:100%;object-fit:cover;" loading="lazy"></div>'),
            (html += '<div class="bundle-line-item__content">'),
            isPair)
          ) {
            var tgtMeta = pairTargetMeta(),
              tgtFull = bundleState.unitPrice || 0,
              tgtPct = Math.round(parseFloat(bar.priceValue) || 0),
              tgtDisc = allocateShopifyPairBundleLinesCents(
                [tgtFull, pairCompanionCents()],
                tgtPct,
              ).finals[0];
            html +=
              '<div class="bundle-line-item__top"><div><span class="bundle-line-item__label">Your item</span><span data-pairux-qv data-pairux-handle="' +
              esc(tgtMeta.handle) +
              '" role="button" tabindex="0" title="Quick view" class="bundle-line-item__title">' +
              esc(tgtMeta.title || "Item " + (r + 1)) +
              '</span></div><div class="tier-pair-target-price bundle-line-item__price">' +
              pairPriceColHtml(bundleLineStrikeCents(getSelectedBundleVariant(variants), tgtFull), tgtDisc) +
              "</div></div>";
            html +=
              '<div class="bundle-variant-types-label bundle-variant-types-label--pair">' +
              options
                .map(function (option) {
                  return esc(option.name || "Option");
                })
                .join(", ") +
              "</div>";
          } else
            ((tgtMeta = pairTargetMeta()),
            (html +=
              '<div class="bundle-line-item__top"><div><span class="bundle-line-item__label">Item ' +
              (r + 1) +
              '</span><span class="bundle-line-item__title">' +
              esc(tgtMeta.title || "Item " + (r + 1)) +
              '</span></div><div class="tier-item-price bundle-line-item__price">' +
              pairPriceColHtml(bundleLineStrikeCents(getSelectedBundleVariant(variants), bundleState.unitPrice), info.each) +
              "</div></div>"));
          isPair && (html += '<div class="tier-target-opt-picker">');
          (options.forEach(function (opt, optIndex) {
            var optNameDown = String(opt.name || "").toLowerCase(),
              isColor = optNameDown === "color" || optNameDown === "colour",
              selectedValue = isColor ? defaultColor : "",
              fieldClass = isColor ? " is-color" : " is-size";
            html +=
              '<div class="tier-opt-group bundle-variant-field' +
              fieldClass +
              " is-option-" +
              optIndex +
              '" data-opt-name="' +
              esc(opt.name) +
              '" data-opt-index="' +
              optIndex +
              '"><div class="bundle-variant-select"><button type="button" class="bundle-variant-select__trigger" aria-haspopup="listbox" aria-expanded="false">' +
              (isColor && itemThumbUrl
                ? '<img class="bundle-variant-select__trigger-image" data-bundle-selected-image src="' +
                  esc(itemThumbUrl) +
                  '" alt="" loading="lazy">'
                : "") +
              '<span data-bundle-selected-label>' +
              esc(
                selectedValue ||
                  "Select " + String(opt.name || "option").toLowerCase(),
              ) +
              '</span><svg aria-hidden="true" width="10" height="6" viewBox="0 0 10 6"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.2"/></svg></button><div class="bundle-variant-select__menu" role="listbox" hidden>';
            opt.values.forEach(function (val) {
              var isDefault = isColor && val === defaultColor,
                thumbUrl = isColor ? colorImageMap[val] : "",
                available = isColor
                  ? variants.some(function (v) {
                      return v.available && v.options.indexOf(val) !== -1;
                    })
                  : variants.some(function (v) {
                      return (
                        v.available &&
                        v.options.indexOf(val) !== -1 &&
                        (!defaultColor || v.options.indexOf(defaultColor) !== -1)
                      );
                    });
              html +=
                '<button type="button" role="option" class="bundle-variant-select__option ' +
                (isColor ? "tier-color-btn" : "size-btn") +
                (isDefault ? " is-active is-selected" : "") +
                '" ' +
                (isColor ? 'data-color="' : 'data-size="') +
                esc(val) +
                '" aria-selected="' +
                (isDefault ? "true" : "false") +
                '"' +
                (available ? "" : " disabled") +
                ">" +
                (isColor
                  ? thumbUrl
                    ? '<img src="' + esc(thumbUrl) + '" alt="" loading="lazy">'
                    : '<span class="bundle-variant-select__swatch" style="background:' +
                      esc(colorHexMap[val] || "#999") +
                      ';"></span>'
                  : "") +
                '<span>' +
                esc(val) +
                "</span></button>";
            });
            html += "</div></div></div>";
          }),
            isPair && (html += "</div>"),
            (html += "</div></div>"),
            (html += "</div>"));
          // v44 (m2e hook 1): with a skin template the row built above is kept
          // aside and a placeholder takes its place; bdFillTierItemRows moves
          // its nodes into the template right after innerHTML below.
          bdItemTpl &&
            !isPair &&
            ((bdRowsHtml[r] = html.slice(bdRowStart)),
            (html =
              html.slice(0, bdRowStart) +
              '<div data-bd-tpl-row="' +
              r +
              '"></div>'));
        }
        if (isPair) {
          var pvPct = Math.round(parseFloat(bar.priceValue) || 0);
          html +=
            '<div class="tier-pair-companion-wrap" style="margin-top:0.75rem;padding-top:0.75rem;border-top:1px dashed rgba(139,111,71,0.3);"><div style="display:flex;align-items:center;gap:0.375rem;margin-bottom:0.5rem;"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="var(--color-warm,#8B6F47)" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg><span style="font-family:var(--font-body);font-size:8.5px;font-weight:500;color:var(--color-warm,#8B6F47);text-transform:uppercase;letter-spacing:0.1em;">Perfect pair' +
            (pvPct > 0 ? " \xB7 save " + pvPct + "%" : "") +
            '</span></div><div class="tier-pair-companion" data-pair-companion style="display:flex;gap:0.75rem;align-items:flex-start;"><p style="font-family:var(--font-body);font-size:10px;font-weight:300;color:var(--color-accent);margin:0;">Finding your match\u2026</p></div></div>';
        }
        if (0)
          var up,
            upImg,
            upDiscountLabel,
            upDiscountBadge,
            upVariants,
            upBasePrice,
            upPrice,
            upOptNames,
            upOptValues,
            upColorImgMap,
            upDefaultColor,
            upFirstThumb,
            tierUpVarHtml,
            upThumbSrc;
        if (hasFreeGift) {
          var giftImg = bar.gift.productImage || bar.gift.image || "",
            giftTitle = bar.gift.productTitle || "Free Gift";
          html +=
            '<div class="tier-size-row tier-free-gift" data-item-index="' +
            (qty - 1) +
            '" data-is-free="true" style="margin-top:0.75rem;padding-top:0.75rem;border-top:1px solid rgba(232,226,217,0.3);"><div style="display:flex;align-items:center;gap:0.75rem;">' +
            (giftImg
              ? '<div style="flex-shrink:0;width:48px;height:3.75rem;border-radius:3px;overflow:hidden;border:1px dashed rgba(139,111,71,0.3);background:#FAF5EE;"><img src="' +
                esc(giftImg) +
                '" alt="" style="width:100%;height:100%;object-fit:cover;" loading="lazy"></div>'
              : "") +
            '<div style="flex:1;min-width:0;"><div style="display:flex;align-items:center;gap:0.375rem;"><svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="var(--color-warm,#8B6F47)" stroke-width="1.5"><path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg><span style="font-family:var(--font-body);font-size:8.5px;font-weight:500;color:var(--color-warm,#8B6F47);text-transform:uppercase;letter-spacing:0.1em;">Free Gift</span></div><p style="font-family:var(--font-body);font-size:11px;font-weight:400;color:var(--color-primary);margin:0.125rem 0 0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' +
            esc(giftTitle) +
            '</p><p style="font-family:var(--font-body);font-size:9px;font-weight:300;color:var(--color-accent);margin:0.125rem 0 0;">Automatically added to your order</p></div><span style="font-family:var(--font-heading);font-size:11px;font-style:italic;color:var(--color-warm,#8B6F47);flex-shrink:0;">Free</span></div></div>';
        }
        html +=
          '</div><div class="bundle-tier-summary"><div><span>Before bundle</span><strong data-bundle-before>' +
          formatMoney(originalTotal) +
          '</strong></div><div><span>Per item</span><strong data-bundle-per-item>' +
          formatMoney(Math.round(info.total / itemCount)) +
          '</strong></div><div class="bundle-tier-summary__saving"><span>Bundle savings</span><strong data-bundle-savings>' +
          formatMoney(info.savings) +
          '</strong></div><div class="bundle-tier-summary__total"><span>' +
          (isPair ? "Pair total" : "Pack total") +
          '</span><strong data-bundle-pack-total>' +
          formatMoney(info.total) +
          '</strong></div></div><p class="bundle-tier-welcome">Use <strong>WELCOME10</strong> for an extra 10% off at checkout</p>';
        html += "</div></div>";
        var tierEl = document.createElement("div");
        ((tierEl.className =
          "bundle-tier relative" + (isActive ? " is-active" : "")),
          (tierEl.dataset.tier = "tier-" + i),
          (tierEl.dataset.qty = qty),
          !isPair && qty === 1 && (tierEl.dataset.onePack = "1"),
          (tierEl.dataset.bundleKind = isPair
            ? "pair"
            : qty === 1
              ? "single"
              : "quantity"),
          (tierEl.dataset.discount = info.savePct),
          // v46 (§6.7): only when the skin declares data-bd-pcts on the container (black does not).
          bdPctsDeclared && !isPair && (tierEl.dataset.bdTierPct = info.savePct),
          (tierEl.dataset.free = "0"),
          (tierEl.dataset.totalCents = info.total),
          (tierEl.dataset.labelTpl = bar.label || ""),
          isPair &&
            ((tierEl.dataset.pair = "1"),
            (tierEl.dataset.pairTargetQuantity = pairTargetQuantity(bar)),
            (tierEl.dataset.pairCompanionQuantity =
              pairCompanionQuantity(bar)),
            (tierEl.dataset.itemCount = pairTotalQuantity(bar)),
            // Keep the configured percent precise for the shared price summary.
            // info.savePct above is rounded only for customer-facing percent copy.
            (tierEl.dataset.pairPct = pairBarPct(bar)),
            (tierEl.dataset.pairFullCents = info.pairFull)),
          (tierEl.innerHTML = html),
          bdItemTpl && bdFillTierItemRows(tierEl, bdItemTpl, bdRowsHtml),
          (tierEl.style.setProperty("--bundle-card-index", String(i + 1))),
          tiersWrap.appendChild(tierEl));
      }),
      tiersWrap.classList.add("bundle-deal-grid"),
      tiersWrap.style.setProperty("--bundle-card-count", String(bars.length)),
      (bundleState.bars = bars),
      bdPctsDeclared &&
        container.setAttribute(
          "data-bd-pcts",
          JSON.stringify(bdPctMap(bars, bundleState.unitPrice) || {}),
        ),
      (bundleState.variants = variants),
      (bundleState.activeTierIndex = defaultIdx),
      tiersWrap.querySelectorAll(".bundle-tier").forEach(function (t) {
        defaultSelectBundleTier(t);
      }),
      requestAnimationFrame(function () {
        var active = tiersWrap.querySelector(
          ".bundle-tier.is-active .bundle-tier__body",
        );
        active && (active.style.maxHeight = active.scrollHeight + "px");
      }),
      buildUpsellSection(),
      bars.some(isPairBar) && (ensurePairUX(), ensurePairCompanion()),
      (container.dataset.bundleBuilt = "true"),
      container.removeAttribute("data-bundle-pending"),
      container.classList.add("is-ready"),
      !0
    );
  }
  function initBundleTiers() {
    const container = document.querySelector(".bundle-tiers");
    if (!container) return;
    syncBundleDisplaySettings();
    const isDynamic = container.dataset.dynamic === "true";
    var selectedVariant = getSelectedBundleVariant();
    bundleState.unitPrice =
      normalizeCents(selectedVariant ? selectedVariant.price : 0) ||
      getBundleUnitPriceCents(container);
    const tiers = container.querySelectorAll(".bundle-tier");
    if (container.dataset.bundleInitialized === "true") {
      updateBundleTierComparePrices();
      return;
    }
    ((container.dataset.bundleInitialized = "true"),
      tiers.forEach((tier) => {
        if (!isDynamic) {
          const qty = parseInt(tier.dataset.qty || "1"),
            discountPct = parseInt(tier.dataset.discount || "0"),
            free = parseInt(tier.dataset.free || "0"),
            totalEl = tier.querySelector(".bundle-tier__total"),
            perEl = tier.querySelector(".bundle-tier__per"),
            compareEl = ensureTierCompareEl(tier, totalEl),
            saveBadge = tier.querySelector(".bundle-tier__save-badge");
          let total;
          free > 0
            ? (total = (qty - free) * bundleState.unitPrice)
            : (total = Math.round(
                qty * bundleState.unitPrice * (1 - discountPct / 100),
              ));
          const savings = qty * bundleState.unitPrice - total,
            originalTotal = getTierOriginalCents(qty, savings),
            displayPrice = getTierDisplayPriceCents(total, qty),
            displayOriginal = getTierDisplayOriginalCents(originalTotal, qty),
            displaySuffix = getTierDisplaySuffix(qty);
          (totalEl &&
            (totalEl.textContent = formatMoney(displayPrice) + displaySuffix),
            perEl && (perEl.style.display = "none"),
            compareEl &&
              (displayOriginal > displayPrice
                ? ((compareEl.textContent = formatMoney(displayOriginal)),
                  (compareEl.style.display = ""))
                : ((compareEl.textContent = ""),
                  (compareEl.style.display = "none"))),
            saveBadge &&
              savings > 0 &&
              ((saveBadge.textContent = "-" + formatMoney(savings)),
              (saveBadge.style.cssText =
                "font-family:var(--font-body);font-size:8.5px;font-weight:400;letter-spacing:0.04em;color:var(--color-warm);background:rgba(139,111,71,0.08);padding:0.0625rem 0.375rem;border-radius:1px;")));
        }
        tier.addEventListener("click", (e) => {
          if (
            e.target.closest(".size-btn") ||
            e.target.closest(".tier-color-btn") ||
            e.target.closest("[data-tier-upsell-toggle]") ||
            tier.classList.contains("is-active")
          )
            return;
          (tiers.forEach((t) => {
            t.classList.remove("is-active");
            const body2 = t.querySelector(".bundle-tier__body");
            (body2 && (body2.style.maxHeight = "0"),
              // v39 20261010: a size the shopper picked by hand is kept.
              t
                .querySelectorAll(".size-btn")
                .forEach(
                  (b) =>
                    b.closest('.tier-opt-group[data-bundle-manual="1"]') ||
                    b.classList.remove("is-selected"),
                ));
          }),
            tier.classList.add("is-active"));
          const body = tier.querySelector(".bundle-tier__body");
          (body && (body.style.maxHeight = body.scrollHeight + "px"),
            (bundleState.activeTier = tier),
            (bundleState.activeTierIndex = [
              ...tier.parentElement.children,
            ].indexOf(tier)),
            // v39 20261010: slots still following the main selector get its
            // value back before the first-available fallback fills the rest.
            syncBundleRowsFromMain(),
            defaultSelectBundleTier(tier),
            buildUpsellSection(),
            updateGrandTotal(),
            updateATCButton());
        });
      }),
      container.addEventListener("keydown", (e) => {
        handleBundleVariantKeyboard(container, e);
      }),
      container.addEventListener("click", (e) => {
        const selectTrigger = e.target.closest(
          ".bundle-variant-select__trigger",
        );
        if (selectTrigger) {
          e.stopPropagation();
          const select = selectTrigger.closest(".bundle-variant-select"),
            menu = select && select.querySelector(
              ".bundle-variant-select__menu",
            ),
            willOpen = !!(menu && menu.hidden);
          closeBundleVariantMenus(container, menu);
          if (menu) {
            menu.hidden = !willOpen;
            selectTrigger.setAttribute("aria-expanded", String(willOpen));
          }
          return;
        }
        const sizeBtn = e.target.closest(".size-btn[data-size]:not(:disabled)");
        if (sizeBtn) {
          if ((e.stopPropagation(), sizeBtn.closest(".tier-size-row"))) {
            const optGroup = sizeBtn.closest(".tier-opt-group");
            markBundleFieldManual(optGroup);
            (optGroup &&
              optGroup
                .querySelectorAll(".size-btn[data-size]")
                .forEach((b) => b.classList.remove("is-selected")),
              sizeBtn.classList.add("is-selected"));
          }
          closeBundleVariantMenus(sizeBtn.closest(".tier-size-row"));
          syncBundleVariantSelectTriggers(sizeBtn.closest(".tier-size-row"));
          /* v28 20260920: same order as the other 6 call sites */
          (updateGrandTotal(), updateATCButton());
          return;
        }
        const colorBtn = e.target.closest(".tier-color-btn");
        if (colorBtn) {
          e.stopPropagation();
          const itemRow = colorBtn.closest(".tier-size-row");
          if (!itemRow) return;
          const colorGroup = colorBtn.closest(".tier-opt-group");
          markBundleFieldManual(colorGroup);
          colorGroup &&
            (colorGroup.querySelectorAll(".tier-color-btn").forEach((b) => {
              b.classList.remove("is-active", "is-selected");
            }),
            colorBtn.classList.add("is-active", "is-selected"));
          const newColor = colorBtn.dataset.color,
            swatchEl = document.getElementById("bd-swatches");
          if (swatchEl)
            try {
              const cmap = JSON.parse(swatchEl.textContent) || {},
                thumbDiv = itemRow.querySelector(".tier-item-thumb");
              if (thumbDiv && cmap[newColor]) {
                const img = thumbDiv.querySelector("img");
                img && (img.src = cmap[newColor]);
              }
              var galleryMedia = getBundleColorGalleryMedia(newColor);
              activateProductGalleryMedia(
                galleryMedia.mediaId,
                galleryMedia.image || cmap[newColor],
              );
            } catch {}
          const colorLabel = colorGroup
            ? colorGroup.querySelector(".tier-color-label")
            : null;
          colorLabel && (colorLabel.textContent = newColor);
          closeBundleVariantMenus(itemRow);
          const selectedColor = colorBtn.dataset.color,
            variantsEl = document.getElementById("bd-variants");
          if (variantsEl) {
            const vList = JSON.parse(variantsEl.textContent);
            itemRow.querySelectorAll(".size-btn").forEach((sb) => {
              const sz = sb.dataset.size,
                avail = vList.some(
                  (v) =>
                    v.options.indexOf(sz) !== -1 &&
                    v.available &&
                    v.options.indexOf(selectedColor) !== -1,
                );
              ((sb.disabled = !avail),
                avail || sb.classList.remove("is-selected"));
            });
          }
          syncBundleVariantSelectTriggers(itemRow);
          /* v28 20260920: same order as the other 6 call sites */
          (updateGrandTotal(), updateATCButton());
          return;
        }
        const upsellToggle = e.target.closest("[data-tier-upsell-toggle]");
        if (upsellToggle) {
          e.stopPropagation();
          const isOn = upsellToggle.classList.toggle("is-on");
          upsellToggle.style.background = isOn
            ? "var(--color-primary,#2D2D2D)"
            : "var(--color-border,#E8E2D9)";
          const knob = upsellToggle.querySelector(".tier-upsell-toggle__knob");
          knob && (knob.style.left = isOn ? "calc(100% - 19px)" : "3px");
          const card = upsellToggle.closest(".tier-upsell-card");
          if (card) {
            card.dataset.tierUpsellActive = isOn ? "1" : "0";
            const uBody = card.querySelector(".tier-upsell-body");
            if (uBody)
              if (isOn) {
                uBody.style.maxHeight = uBody.scrollHeight + "px";
                const sBtns = uBody.querySelectorAll(
                  ".tier-upsell-size-btn:not(:disabled)",
                );
                sBtns.length === 1 && sBtns[0].classList.add("is-selected");
              } else
                ((uBody.style.maxHeight = "0"),
                  uBody
                    .querySelectorAll(".tier-upsell-size-btn")
                    .forEach(function (b) {
                      b.classList.remove("is-selected");
                    }));
          }
          const tierBody = upsellToggle.closest(".bundle-tier__body");
          if (tierBody) {
            const uBodyH =
              (card && card.querySelector(".tier-upsell-body")?.scrollHeight) ||
              0;
            isOn
              ? (tierBody.style.maxHeight =
                  tierBody.scrollHeight + uBodyH + "px")
              : setTimeout(function () {
                  tierBody.style.maxHeight = tierBody.scrollHeight + "px";
                }, 380);
          }
          (updateGrandTotal(), updateATCButton());
          return;
        }
        const tierUpsellColor = e.target.closest(".tier-upsell-color-btn");
        if (tierUpsellColor) {
          (e.stopPropagation(),
            tierUpsellColor
              .closest("div")
              .querySelectorAll(".tier-upsell-color-btn")
              .forEach(function (b) {
                b.classList.remove("is-active");
              }),
            tierUpsellColor.classList.add("is-active"));
          const label = tierUpsellColor
            .closest(".tier-upsell-card")
            ?.querySelector(".tier-upsell-color-label");
          label && (label.textContent = tierUpsellColor.dataset.color || "");
          const card = tierUpsellColor.closest(".tier-upsell-card"),
            tierIdx = bundleState.activeTierIndex || 0,
            barData = (bundleState.bars || [])[tierIdx];
          if (card && barData && barData.upsell) {
            const selColor = tierUpsellColor.dataset.color;
            card
              .querySelectorAll(".tier-upsell-size-btn")
              .forEach(function (btn) {
                var size = btn.dataset.size,
                  avail = (barData.upsell.variants || []).some(function (v) {
                    var colorMatch = (v.options || []).some(function (o) {
                        return (
                          (o.name.toLowerCase() === "color" ||
                            o.name.toLowerCase() === "colour") &&
                          o.value === selColor
                        );
                      }),
                      sizeMatch = (v.options || []).some(function (o) {
                        return o.value === size;
                      });
                    return colorMatch && sizeMatch && v.available !== !1;
                  });
                ((btn.disabled = !avail),
                  avail || btn.classList.remove("is-selected"));
              });
          }
          updateATCButton();
          return;
        }
        const tierUpsellSize = e.target.closest(".tier-upsell-size-btn");
        if (tierUpsellSize) {
          e.stopPropagation();
          const card = tierUpsellSize.closest(".tier-upsell-card");
          (card &&
            card
              .querySelectorAll(".tier-upsell-size-btn")
              .forEach(function (b) {
                b.classList.remove("is-selected");
              }),
            tierUpsellSize.classList.add("is-selected"),
            updateGrandTotal(),
            updateATCButton());
          const body = tierUpsellSize.closest(".bundle-tier__body");
          body && (body.style.maxHeight = body.scrollHeight + "px");
          return;
        }
      }));
    if (container.dataset.bundleDropdownDismiss !== "1") {
      container.dataset.bundleDropdownDismiss = "1";
      document.addEventListener("click", function (event) {
        event.target.closest(".bundle-variant-select") ||
          closeBundleVariantMenus(container);
      });
      document.addEventListener("keydown", function (event) {
        event.key === "Escape" && closeBundleVariantMenus(container);
      });
    }
    const defaultTier = container.querySelector(".bundle-tier.is-active");
    if (defaultTier) {
      bundleState.activeTier = defaultTier;
      const body = defaultTier.querySelector(".bundle-tier__body");
      (body && (body.style.maxHeight = body.scrollHeight + "px"),
        updateGrandTotal(),
        updateATCButton());
    }
  }
  function getBundleTotal() {
    const tier = bundleState.activeTier;
    if (!tier) return bundleState.unitPrice;
    if (tier.dataset.totalCents) return parseInt(tier.dataset.totalCents);
    const qty = parseInt(tier.dataset.qty || "1"),
      discountPct = parseInt(tier.dataset.discount || "0"),
      free = parseInt(tier.dataset.free || "0"),
      rowPrices = getBundleTierRowPrices(tier, qty);
    return free > 0
      ? sumCents(
          rowPrices
            .slice()
            .sort(function (a, b) {
              return b - a;
            })
            .slice(0, Math.max(0, qty - free)),
        )
      : allocateShopifyPercentageBundleLinesCents(rowPrices, discountPct).total;
  }
  function updateBundleTierComparePrices() {
    document.querySelectorAll(".bundle-tier").forEach(function (tier) {
      if (tier.dataset.pair === "1") {
        updatePairTierDisplay(tier);
        return;
      }
      var totalEl = tier.querySelector(".bundle-tier__total"),
        compareEl = ensureTierCompareEl(tier, totalEl),
        perEl = tier.querySelector(".bundle-tier__per");
      if (!(!compareEl && !totalEl && !perEl)) {
        // v42 20261010 — paid total, strike and Save from bundleTierSaveSummary.
        var save = bundleTierSaveSummary(tier),
          qty = save.itemCount,
          rowPrices = save.rowPrices,
          rowTotal = save.rowTotal,
          total = save.total,
          originalTotal = save.original,
          rowStrikes = save.rowStrikes,
          displayPrice = getTierDisplayPriceCents(total, qty),
          displayOriginal = getTierDisplayOriginalCents(originalTotal, qty),
          displaySuffix = getTierDisplaySuffix(qty);
        var bundleContainer = tier.closest(".bundle-tiers");
        if (
          bundleContainer &&
          bundleContainer.dataset.dn2BundleStyle === "list"
        ) {
          displayPrice = total;
          displayOriginal = originalTotal;
          displaySuffix = "";
        }
        var lineFinals = null;
        try {
          lineFinals = JSON.parse(tier.dataset.lineFinals || "null");
        } catch {}
        if (!Array.isArray(lineFinals) || lineFinals.length !== qty) {
          var cut = allocateProportionalDiscountCents(
            rowPrices,
            Math.max(0, rowTotal - total),
          );
          lineFinals = rowPrices.map(function (price, index) {
            return Math.max(0, price - cut[index]);
          });
        }
        (updateBundleTierSummary(tier, save),
          tier
            .querySelectorAll(".tier-item-price")
            .forEach(function (priceEl, index) {
              priceEl.innerHTML = pairPriceColHtml(
                rowStrikes[index] != null
                  ? rowStrikes[index]
                  : bundleState.unitPrice,
                lineFinals[index] != null
                  ? lineFinals[index]
                  : Math.round(total / qty),
              );
            }),
          perEl && (perEl.style.display = "none"),
          compareEl &&
            (displayOriginal > displayPrice
              ? ((compareEl.textContent = formatMoney(displayOriginal)),
                (compareEl.style.display = ""))
              : ((compareEl.textContent = ""),
                (compareEl.style.display = "none"))));
      }
    });
  }
  function refreshDynamicBundleTierPrices() {
    typeof bundleState.calculateBarPrice === "function" &&
      (document
        .querySelectorAll(".bundle-tier")
        .forEach(function (tier, index) {
          var bar = bundleState.bars[index];
          if (!bar) return;
          var info = bundleState.calculateBarPrice(bar, tier);
          ((tier.dataset.totalCents = String(info.total)),
            (tier.dataset.discount = String(info.savePct)),
            (tier.dataset.originalCents = String(info.originalTotal || 0)),
            (tier.dataset.lineFinals = JSON.stringify(info.lineFinals || [])),
            (tier.dataset.lineOriginals = JSON.stringify(
              info.lineOriginals || [],
            )),
            info.pairFull != null &&
              (tier.dataset.pairFullCents = String(info.pairFull)),
            (tier.dataset.labelTpl = bar.label || ""));
        }),
      updateBundleTierComparePrices());
  }
  function getUpsellTotal() {
    let total = 0;
    document.querySelectorAll(".upsell-card.is-added").forEach((card) => {
      total += parseFloat(card.dataset.upsellPrice || "0") * 100;
    });
    const activeTier = document.querySelector(".bundle-tier.is-active");
    if (activeTier) {
      const tierUpsell = activeTier.querySelector(
        '.tier-upsell-card[data-tier-upsell-active="1"]',
      );
      if (tierUpsell) {
        const toggle = tierUpsell.querySelector("[data-tier-upsell-toggle]");
        if (toggle && toggle.classList.contains("is-on")) {
          const bars = bundleState.bars || [],
            tierIdx = bundleState.activeTierIndex || 0,
            bar = bars[tierIdx];
          if (bar && bar.upsell) {
            var upVariants = bar.upsell.variants || [],
              selColor = tierUpsell.querySelector(
                ".tier-upsell-color-btn.is-active",
              )?.dataset?.color,
              selSize = tierUpsell.querySelector(
                ".tier-upsell-size-btn.is-selected",
              )?.dataset?.size,
              matchedV = upVariants.find(function (v) {
                if (v.available === !1) return !1;
                var opts = (v.options || []).map(function (o) {
                  return o.value;
                });
                return !(
                  (selColor && opts.indexOf(selColor) === -1) ||
                  (selSize && opts.indexOf(selSize) === -1)
                );
              });
            !matchedV && upVariants.length > 0 && (matchedV = upVariants[0]);
            var upBase = (matchedV && parseFloat(matchedV.price)) || 0,
              upPrice = upBase;
            (bar.upsell.discountValue > 0 &&
              (bar.upsell.discountType === "percentage"
                ? (upPrice =
                    upBase -
                    Math.floor(
                      (upBase * 100 * bar.upsell.discountValue) / 100,
                    ) /
                      100)
                : (upPrice = Math.max(0, upBase - bar.upsell.discountValue))),
              (total += Math.round(upPrice * 100)));
          }
        }
      }
    }
    return total;
  }
  function getGiftPrice() {
    if (!document.getElementById("gift-switch")?.classList.contains("is-on"))
      return 0;
    const selected = document.querySelector(".gift-option-card.is-selected");
    return selected ? parseInt(selected.dataset.giftPrice || "0") : 0;
  }
  // Single-pack heading and card share the selected variant's actual compare-at.
  // Bundle quantities, upsells and gifts never contribute to this heading.
  // v40 20261010 — the variant the MAIN selector points at (the form's id,
  // written by syncNativeVariantState). null when it is not in the list, or
  // when the main selector's current values name no variant (e.g. new colour
  // picked, its size not yet): the form's id is then left over from the
  // previous selection and must not be quoted.
  function mainSelectedBundleVariant() {
    var input = document.querySelector('#product-form [name="id"]'),
      id = input ? String(input.value || "") : "",
      variants =
        bundleState.variants && bundleState.variants.length
          ? bundleState.variants
          : readBundleVariants(),
      found = null;
    if (!id) return null;
    for (var i = 0; i < variants.length && !found; i++)
      String(variants[i].id) === id && (found = variants[i]);
    if (!found) return null;
    var selectors = nativeSelectors();
    return selectors.length &&
      !variantMatchesOptions(found, selectedNativeOptions(selectors), !1)
      ? null
      : found;
  }
  // v40 20261010 — the heading quotes the MAIN selection (Edward 2026-10-10:
  // main price / strike follow the variant picked in the main selector). The
  // 1 Pack slot follows the main selector unless the shopper hand-picked it,
  // so normally both name the same variant and the heading keeps reusing the
  // 1 Pack card's numbers. When the shopper hand-picked another variant in
  // 1 Pack, the card keeps that slot's numbers and the heading quotes the
  // main variant's own price / strike.
  function updateSinglePackPriceDisplay() {
    const singleTier = document.querySelector('.bundle-tier[data-one-pack="1"]'),
      price = normalizeCents(singleTier?.dataset.totalCents) || bundleState.unitPrice,
      compare = getTierOriginalCents(1, 0, singleTier),
      hasDiscount = compare > price && price > 0,
      discountText = hasDiscount
        ? "-" + Math.round((compare - price) * 100 / compare) + "%"
        : "",
      mainVariant = mainSelectedBundleVariant(),
      singleSlotVariant = singleTier
        ? resolveBundleRowVariant(getBundleTierRowElements(singleTier)[0])
        : null,
      headingOwn = !!(
        mainVariant &&
        singleSlotVariant &&
        String(mainVariant.id) !== String(singleSlotVariant.id)
      ),
      headPrice = headingOwn ? normalizeCents(mainVariant.price) : price,
      headCompare = headingOwn
        ? Math.max(headPrice, normalizeCents(mainVariant.compare_at_price))
        : compare,
      headHasDiscount = headCompare > headPrice && headPrice > 0,
      headDiscountText = headHasDiscount
        ? "-" + Math.round((headCompare - headPrice) * 100 / headCompare) + "%"
        : "",
      heading = document.getElementById("pdp-grand-total");
    if (heading && headPrice > 0) {
      heading.textContent = formatMoney(headPrice);
      let compareEl = document.getElementById("pdp-compare-price");
      if (!compareEl && headHasDiscount) {
        compareEl = document.createElement("span");
        compareEl.id = "pdp-compare-price";
        compareEl.style.cssText = "font-family:var(--font-body);font-size:13px;font-weight:400;color:#9C968E;text-decoration:line-through;line-height:1;";
        heading.insertAdjacentElement("afterend", compareEl);
      }
      if (compareEl) {
        compareEl.textContent = headHasDiscount ? formatMoney(headCompare) : "";
        compareEl.style.display = headHasDiscount ? "" : "none";
      }
      const badge = document.getElementById("pdp-discount-badge");
      if (badge) {
        badge.textContent = headDiscountText;
        badge.style.display = headHasDiscount ? "" : "none";
      }
    }
    if (singleTier) {
      const column = singleTier.querySelector(".bundle-tier__price-column");
      if (!column) return;
      let badge = column.querySelector(".bundle-tier__single-discount");
      if (!badge && hasDiscount) {
        badge = document.createElement("span");
        badge.className = "bundle-tier__single-discount";
        badge.style.cssText = "display:inline-block;margin-top:4px;padding:3px 6px;background:#2D2D2D;color:#fff;font-family:var(--font-body);font-size:10px;font-weight:700;line-height:1.2;";
        column.appendChild(badge);
      }
      if (badge) {
        badge.textContent = discountText;
        badge.style.display = hasDiscount ? "inline-block" : "none";
      }
    }
  }
  function updateGrandTotal() {
    // v28 20260920 — was `syncBundleUnitPrice() && refresh…`, which skipped the
    // recompute whenever slot 1 had not changed, leaving stale totals when only
    // slot 2/3 switched to a differently-priced variant.
    recalcBundleTierPrices();
    const bundleTotal = getBundleTotal(),
      upsellTotal = getUpsellTotal(),
      giftPrice = getGiftPrice(),
      grandTotal = bundleTotal + upsellTotal + giftPrice;
    if (grandTotal <= 0 && bundleState.unitPrice > 0) return;
    // Heading stays at the server-rendered 1-pack price; retain bundle writes for rollback.
    //     const totalEl = document.getElementById("pdp-grand-total");
    //     totalEl && (totalEl.textContent = formatMoney(grandTotal));
    // v42 20261010 — Edward 2026-10-10 17:10 EDT asked that the floating bar and the two places under the button also compare against the strike-through price:
    // #floating-tier-info and #savings-nudge quote the active tier card's own
    // Save (bundleTierSaveSummary), no second formula.
    // v41 (regular-price basis), kept for rollback:
    //   savings = isPairTier
    //     ? Math.max(0, (parseInt(tier.dataset.pairFullCents || "0") || bundleTotal) - bundleTotal)
    //     : Math.max(0, sumCents(getBundleTierRowPrices(tier, qty)) - bundleTotal);
    const tier = bundleState.activeTier,
      isPairTier = !!(tier && tier.dataset.pair === "1"),
      qty = parseInt(tier?.dataset.qty || "1"),
      savings = tier ? bundleTierSaveSummary(tier).savings : 0;
    updateBundleTierComparePrices();
    updateSinglePackPriceDisplay();
    // Heading stays at the server-rendered 1-pack price; retain bundle writes for rollback.
    //     const savingsEl = document.getElementById("pdp-savings");
    //     savingsEl &&
    //       (savings > 0
    //         ? ((savingsEl.textContent = "Save " + formatMoney(savings)),
    //           (savingsEl.style.display = ""))
    //         : (savingsEl.style.display = "none"));
    //     const compareEl = document.getElementById("pdp-compare-price"),
    //       originalGrandTotal =
    //         (isPairTier
    //           ? parseInt(tier.dataset.pairFullCents || "0") || bundleTotal
    //           : getTierOriginalCents(qty, savings)) +
    //         upsellTotal +
    //         giftPrice;
    //     compareEl && originalGrandTotal > grandTotal
    //       ? ((compareEl.textContent = formatMoney(originalGrandTotal)),
    //         (compareEl.style.display = ""))
    //       : compareEl && (compareEl.style.display = "none");
    //     const discountBadgeEl = document.getElementById("pdp-discount-badge");
    //     discountBadgeEl &&
    //       (originalGrandTotal > grandTotal && originalGrandTotal > 0
    //         ? ((discountBadgeEl.textContent =
    //             "-" +
    //             Math.round(
    //               ((originalGrandTotal - grandTotal) / originalGrandTotal) * 100,
    //             ) +
    //             "%"),
    //           (discountBadgeEl.style.display = ""))
    //         : (discountBadgeEl.style.display = "none"));
    //     const perPieceEl = document.getElementById("pdp-per-piece");
    //     perPieceEl && qty > 1 && bundleState.showPricesPerItem
    //       ? ((perPieceEl.textContent =
    //           formatMoney(Math.round(bundleTotal / qty)) +
    //           getBundlePerItemSuffix() +
    //           " - " +
    //           qty +
    //           " pieces"),
    //         (perPieceEl.style.display = ""))
    //       : perPieceEl && (perPieceEl.style.display = "none");
    const nudge = document.getElementById("savings-nudge");
    nudge &&
      (savings > 0 && allSizesSelected()
        ? ((nudge.textContent =
            "You're saving " +
            formatMoney(savings) +
            " with this bundle" +
            (upsellTotal > 0 ? " \xB7 Total " + formatMoney(grandTotal) : "")),
          (nudge.style.display = ""))
        : (nudge.style.display = "none"));
    const floatingInfo = document.getElementById("floating-tier-info");
    if (floatingInfo && tier) {
      const label =
        tier.querySelector(".bundle-tier__radio + div span")?.textContent || "";
      floatingInfo.textContent =
        label + (savings > 0 ? " \xB7 Save " + formatMoney(savings) : "");
    }
  }
  function allSizesSelected() {
    const tier = bundleState.activeTier;
    if (!tier) return !1;
    const allTierSizes = [
      ...tier.querySelectorAll(".tier-size-row:not(.tier-upsell-row)"),
    ].every(
      (row) =>
        row.dataset.isFree === "true" ||
        row.querySelector(".size-btn[data-size].is-selected"),
    );
    let allUpsellSizes = !0;
    document.querySelectorAll(".upsell-card.is-added").forEach((card) => {
      card.querySelector(".upsell-size-btn.is-selected") ||
        (allUpsellSizes = !1);
    });
    let allTierUpsellSizes = !0;
    const tierUpsell = tier.querySelector(
      '.tier-upsell-card[data-tier-upsell-active="1"]',
    );
    return (
      tierUpsell &&
        tierUpsell.querySelectorAll(".tier-upsell-size-btn").length > 0 &&
        !tierUpsell.querySelector(".tier-upsell-size-btn.is-selected") &&
        (allTierUpsellSizes = !1),
      allTierSizes && allUpsellSizes && allTierUpsellSizes
    );
  }
  function shouldDisableDynamicCheckout() {
    const tier =
      bundleState.activeTier ||
      document.querySelector(".bundle-tier.is-active");
    if (!tier) return !1;
    const bar = (bundleState.bars || [])[bundleState.activeTierIndex || 0],
      qty = parseInt(tier.dataset.qty || "1", 10),
      free = parseInt(tier.dataset.free || "0", 10);
    return !!(
      tier.dataset.pair === "1" ||
      (typeof isPairBar === "function" && isPairBar(bar)) ||
      qty > 1 ||
      free > 0 ||
      tier.querySelectorAll(".tier-size-row:not(.tier-upsell-row)").length >
        1 ||
      document.querySelector(".upsell-card.is-added") ||
      tier.querySelector('.tier-upsell-card[data-tier-upsell-active="1"]') ||
      document.getElementById("gift-switch")?.classList.contains("is-on") ||
      activeSlotDiffersFromMain(tier)
    );
  }
  // v40 20261010 — the dynamic checkout button buys the form's variant (the
  // main selector). When the shopper hand-picked another variant in the
  // single slot of the active tier, that button would buy something the slot
  // does not say, so it is hidden like the multi-item cases above.
  function activeSlotDiffersFromMain(tier) {
    var row = getBundleTierRowElements(tier)[0],
      slotVariant = row ? resolveBundleRowVariant(row) : null,
      mainVariant = mainSelectedBundleVariant();
    return !!(
      slotVariant &&
      mainVariant &&
      String(slotVariant.id) !== String(mainVariant.id)
    );
  }
  // v44 20261018 (099 wave 2 m2e, hook 2) — a skin can put data-label-tpl on
  // #atc-text and/or #floating-atc-text for the "ready to add" state only.
  // {count} = items in the active tier, {total} = formatMoney(grand total),
  // the same number the built-in label shows. Written with textContent.
  // No attribute = the built-in label (black skin). Sold out / select a size /
  // loading / added states are not templated.
  function bdLabelFromTpl(el, count, totalCents, fallback) {
    var tpl = el && el.getAttribute("data-label-tpl");
    return tpl
      ? tpl
          .split("{count}")
          .join(String(count))
          .split("{total}")
          .join(formatMoney(totalCents))
      : fallback;
  }
  function updateATCButton() {
    const atcText = document.getElementById("atc-text"),
      btn = document.getElementById("main-atc"),
      floatingText = document.getElementById("floating-atc-text");
    if (!atcText) return;
    // v28 20260920 — recompute first so the button can never quote a total the
    // tier header has already moved past (Edward 20260920 point 7).
    recalcBundleTierPrices();
    const paymentBtn = document.querySelector(".shopify-payment-button");
    const selectedTier =
      bundleState.activeTier || document.querySelector(".bundle-tier.is-active");
    if (
      selectedTier?.dataset.pair === "1" &&
      (!pairState.available || !pairState.variantId)
    ) {
      const pairLabel = pairState.fetched ? "PAIR UNAVAILABLE" : "LOADING PAIR…";
      atcText.textContent = pairLabel;
      floatingText && (floatingText.textContent = pairLabel);
      btn && (btn.disabled = !0);
      paymentBtn &&
        ((paymentBtn.style.display = "none"),
        (paymentBtn.style.pointerEvents = "none"),
        (paymentBtn.style.opacity = "0"));
      return;
    }
    if (allSizesSelected()) {
      const grandTotal = getBundleTotal() + getUpsellTotal() + getGiftPrice();
      const activeTier = bundleState.activeTier,
        itemCount = activeTier
          ? activeTier.dataset.pair === "1"
            ? parseInt(
                activeTier.dataset.itemCount || activeTier.dataset.qty || "1",
                10,
              )
            : parseInt(activeTier.dataset.qty || "1", 10)
          : 1;
      // v44 (m2e hook 2): data-label-tpl on either element replaces only this
      // "ready to add" label; without it the built-in wording stays.
      ((atcText.textContent = bdLabelFromTpl(
        atcText,
        itemCount,
        grandTotal,
        "ADD " +
          itemCount +
          (itemCount === 1 ? " ITEM" : " ITEMS") +
          " \u2014 " +
          formatMoney(grandTotal),
      )),
        floatingText &&
          (floatingText.textContent = bdLabelFromTpl(
            floatingText,
            itemCount,
            grandTotal,
            "ADD TO CART",
          )),
        btn && (btn.disabled = !1),
        paymentBtn &&
          (shouldDisableDynamicCheckout()
            ? ((paymentBtn.style.display = "none"),
              (paymentBtn.style.pointerEvents = "none"),
              (paymentBtn.style.opacity = "0"))
            : ((paymentBtn.style.display = ""),
              (paymentBtn.style.pointerEvents = ""),
              (paymentBtn.style.opacity = ""))));
    } else {
      const tier = bundleState.activeTier,
        qty = parseInt(tier?.dataset.qty || "1");
      /* 20260727: when every size of the selected colour is sold out in the current tier, asking the shopper to "select a size" contradicts itself (none can be picked).   That case shows SOLD OUT. Only the wording changes; the disabled state is exactly as before. */ var dnTierSizeBtns =
          tier
            ? Array.prototype.slice.call(
                tier.querySelectorAll(".size-btn[data-size]"),
              )
            : [],
        dnTierSoldOut =
          dnTierSizeBtns.length > 0 &&
          dnTierSizeBtns.every(function (b) {
            return b.disabled;
          });
      ((atcText.textContent = dnTierSoldOut
        ? "SOLD OUT"
        : qty > 1
          ? "SELECT ALL SIZES"
          : "SELECT A SIZE"),
        floatingText &&
          (floatingText.textContent = dnTierSoldOut
            ? "SOLD OUT"
            : "SELECT A SIZE"),
        btn && (btn.disabled = !0),
        paymentBtn &&
          ((paymentBtn.style.display = shouldDisableDynamicCheckout()
            ? "none"
            : ""),
          (paymentBtn.style.pointerEvents = "none"),
          (paymentBtn.style.opacity = shouldDisableDynamicCheckout()
            ? "0"
            : "0.4")));
    }
    var fSwatch = document.getElementById("floating-color-swatch"),
      fSize = document.getElementById("floating-size-info"),
      fBtn = document.querySelector("[data-floating-atc]"),
      fIcon = document.getElementById("floating-atc-icon");
    if (fSize && fBtn) {
      var atier = bundleState.activeTier,
        mainRows = atier
          ? [].slice.call(
              atier.querySelectorAll(".tier-size-row:not(.tier-upsell-row)"),
            )
          : [],
        mainSizesDone =
          mainRows.length > 0 &&
          mainRows.every(function (row) {
            return (
              row.dataset.isFree === "true" ||
              row.querySelector(".size-btn[data-size].is-selected")
            );
          });
      if (mainSizesDone) {
        let dotHtml = function (it) {
            return it.hex
              ? '<span style="' + DOT + "background:" + it.hex + ';"></span>'
              : it.img
                ? '<span style="' +
                  DOT +
                  "background:center/cover url('" +
                  it.img +
                  `');"></span>`
                : "";
          },
          pair = function (it) {
            return (
              '<span style="display:inline-flex;align-items:center;gap:4px;">' +
              dotHtml(it) +
              "<span>" +
              it.size +
              "</span></span>"
            );
          };
        var hexMap = window.__bdSwatchColors;
        if (hexMap === void 0) {
          try {
            hexMap = JSON.parse(
              (document.getElementById("bd-swatch-colors") || {}).textContent ||
                "{}",
            );
          } catch {
            hexMap = {};
          }
          window.__bdSwatchColors = hexMap;
        }
        fSwatch && (fSwatch.style.display = "none");
        var items = mainRows.map(function (row) {
            var sb = row.querySelector(".size-btn[data-size].is-selected"),
              cb = row.querySelector(".tier-color-btn.is-active"),
              cname =
                (cb && (cb.dataset.color || cb.getAttribute("title"))) || "",
              img =
                cb && cb.querySelector("img")
                  ? cb.querySelector("img").src
                  : "";
            return {
              size: sb ? sb.dataset.size : "",
              color: cname,
              hex: hexMap[cname],
              img,
            };
          }),
          DOT =
            "display:inline-block;width:10px;height:10px;border-radius:50%;border:1px solid var(--color-border);vertical-align:middle;flex-shrink:0;",
          allSame =
            items.length > 1 &&
            items.every(function (it) {
              return it.size === items[0].size && it.color === items[0].color;
            });
        (allSame
          ? (fSize.innerHTML =
              pair(items[0]) +
              '<span style="opacity:0.55;margin-left:5px;">\xD7' +
              items.length +
              "</span>")
          : (fSize.innerHTML = items
              .map(pair)
              .join('<span style="opacity:0.4;margin:0 3px;">\xB7</span>')),
          (fSize.style.fontStyle = "normal"),
          (fSize.style.color = "var(--color-muted)"),
          (fSize.style.textTransform = "uppercase"),
          (fSize.style.letterSpacing = "0.08em"),
          (fSize.style.fontWeight = "400"));
      } else
        (fSwatch && (fSwatch.style.display = "none"),
          (fSize.textContent = "No size selected"),
          (fSize.style.fontStyle = "italic"),
          (fSize.style.color = "var(--color-accent)"),
          (fSize.style.textTransform = "none"),
          (fSize.style.letterSpacing = ""),
          (fSize.style.fontWeight = "300"));
      allSizesSelected()
        ? ((fBtn.style.background = ""),
          (fBtn.style.color = ""),
          (fBtn.style.border = ""),
          fIcon &&
            (fIcon.innerHTML =
              '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>'))
        : ((fBtn.style.background = "transparent"),
          (fBtn.style.color = "var(--color-primary)"),
          (fBtn.style.border = "1px solid var(--color-primary)"),
          fIcon &&
            (fIcon.innerHTML =
              '<line x1="12" y1="19" x2="12" y2="5"/><polyline points="5 12 12 5 19 12"/>'));
    }
  }
  function initUpsellToggles() {
    (document.querySelectorAll("[data-upsell-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.stopPropagation();
        const card = toggle.closest(".upsell-card");
        if (card?.classList.contains("is-added")) {
          (card.classList.remove("is-added"), toggle.classList.remove("is-on"));
          const body = card.querySelector(".upsell-card__body");
          body && (body.style.maxHeight = "0");
        } else {
          (card?.classList.add("is-added"), toggle.classList.add("is-on"));
          const body = card?.querySelector(".upsell-card__body");
          if (
            (body && (body.style.maxHeight = body.scrollHeight + "px"),
            card && !card.querySelector(".upsell-size-btn.is-selected"))
          ) {
            const sizeBtns = card.querySelectorAll(
              ".upsell-size-btn:not(:disabled)",
            );
            sizeBtns.length && sizeBtns[0].classList.add("is-selected");
          }
        }
        (updateGrandTotal(), updateATCButton());
      });
    }),
      document.querySelectorAll(".upsell-size-btn").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          (e.stopPropagation(),
            btn
              .closest(".upsell-card")
              ?.querySelectorAll(".upsell-size-btn")
              .forEach((b) => b.classList.remove("is-selected")),
            btn.classList.add("is-selected"),
            updateATCButton());
        });
      }),
      document
        .querySelectorAll("#upsell-section .upsell-color-btn")
        .forEach((btn) => {
          btn.addEventListener("click", (e) => {
            e.stopPropagation();
            const optGroup = btn.closest(".tier-opt-group");
            if (!optGroup) return;
            (optGroup.querySelectorAll(".upsell-color-btn").forEach((b) => {
              b.classList.remove("is-active", "is-selected");
            }),
              btn.classList.add("is-active", "is-selected"));
            const label = optGroup?.querySelector(".upsell-color-label");
            label && (label.textContent = btn.dataset.color || "");
            const card = btn.closest(".upsell-card");
            card && updateUpsellSizesForColor(card);
          });
        }));
  }
  function initGiftSection() {
    const toggleBtn = document.getElementById("gift-toggle"),
      giftSwitch = document.getElementById("gift-switch"),
      giftBody = document.getElementById("gift-body"),
      giftMessage = document.getElementById("gift-message"),
      charCount = document.getElementById("gift-char-count");
    if (!toggleBtn || !giftSwitch || !giftBody) return;
    let isOn = !1;
    (toggleBtn.addEventListener("click", () => {
      ((isOn = !isOn),
        giftSwitch.classList.toggle("is-on", isOn),
        toggleBtn.classList.toggle("is-on", isOn),
        isOn
          ? ((giftBody.style.maxHeight = giftBody.scrollHeight + "px"),
            giftMessage && (giftMessage.disabled = !1))
          : ((giftBody.style.maxHeight = "0"),
            giftMessage &&
              ((giftMessage.disabled = !0), (giftMessage.value = "")),
            charCount && (charCount.textContent = "0/200")));
      const sub = toggleBtn.querySelector(".gift-toggle-sub");
      if (sub)
        if (isOn) {
          const selected = document.querySelector(
              ".gift-option-card.is-selected",
            ),
            title = selected?.querySelector("p")?.textContent || "Gift Wrap",
            price = parseInt(selected?.dataset.giftPrice || "0");
          sub.textContent =
            title + (price > 0 ? " \xB7 +" + formatMoney(price) : " \xB7 Free");
        } else sub.textContent = "Gift wrapping & a personal note";
      (updateGrandTotal(), updateATCButton());
    }),
      document.querySelectorAll(".gift-option-card").forEach((card) => {
        card.addEventListener("click", () => {
          (document.querySelectorAll(".gift-option-card").forEach((c) => {
            c.classList.remove("is-selected");
            const check2 = c.querySelector(".gift-option-check");
            check2 && (check2.style.display = "none");
          }),
            card.classList.add("is-selected"));
          const check = card.querySelector(".gift-option-check");
          check && (check.style.display = "flex");
          const sub = toggleBtn.querySelector(".gift-toggle-sub");
          if (sub && isOn) {
            const title = card.querySelector("p")?.textContent || "Gift Wrap",
              price = parseInt(card.dataset.giftPrice || "0");
            sub.textContent =
              title +
              (price > 0 ? " \xB7 +" + formatMoney(price) : " \xB7 Free");
          }
          (updateGrandTotal(), updateATCButton());
        });
      }));
    const initialSelected = document.querySelector(
      ".gift-option-card.is-selected .gift-option-check",
    );
    giftMessage &&
      charCount &&
      giftMessage.addEventListener("input", () => {
        charCount.textContent = giftMessage.value.length + "/200";
      });
  }
  function buildUpsellSection() {
    var section = document.getElementById("upsell-section");
    if (section) {
      if (section.dataset.pairWithHidden === "true") {
        section.style.display = "none";
        return;
      }
      var bars = bundleState.bars;
      if (!bars || !bars.length) {
        section.style.display = "none";
        return;
      }
      if (!section.querySelector(".upsell-card")) {
        var upsellMap = {};
        bars.forEach(function (bar) {
          if (bar.upsell && bar.upsell.enabled && bar.upsell.productTitle) {
            var key = bar.upsell.productId || bar.upsell.productTitle;
            upsellMap[key] || (upsellMap[key] = bar.upsell);
          }
        });
        var upsells = Object.values(upsellMap);
        if (upsells.length === 0) {
          section.style.display = "none";
          return;
        }
        section.style.display = "";
        var html =
          '<div class="flex items-center gap-2 mb-4"><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" stroke-width="1.2"><path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/></svg><p style="font-family:var(--font-body);font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:0.15em;color:var(--color-primary);">Pair with</p></div><div class="space-y-2.5">';
        (upsells.forEach(function (up, idx) {
          var discountLabel = "";
          up.discountValue > 0 &&
            (discountLabel =
              up.discountType === "percentage"
                ? up.discountValue + "% off when bundled"
                : "-" + formatMoney(up.discountValue * 100) + " when bundled");
          var variants = up.variants || [],
            optNames = up.optionNames || [],
            optionValues = {};
          (optNames.forEach(function (n) {
            optionValues[n] = [];
          }),
            variants.forEach(function (v) {
              (v.options || []).forEach(function (o) {
                optionValues[o.name] &&
                  optionValues[o.name].indexOf(o.value) === -1 &&
                  optionValues[o.name].push(o.value);
              });
            }));
          var upsellColorImgMap = {};
          variants.forEach(function (vr) {
            if (vr.image || vr.featuredImage) {
              var colorOp = (vr.options || []).find(function (o) {
                return (
                  o.name.toLowerCase() === "color" ||
                  o.name.toLowerCase() === "colour"
                );
              });
              colorOp &&
                !upsellColorImgMap[colorOp.value] &&
                (upsellColorImgMap[colorOp.value] =
                  vr.image || vr.featuredImage);
            }
          });
          var pwDefaultColor = "",
            pwFirstThumb = "";
          optNames.forEach(function (n) {
            var isC =
              n.toLowerCase() === "color" || n.toLowerCase() === "colour";
            isC &&
              (optionValues[n] || []).length > 0 &&
              ((pwDefaultColor = optionValues[n][0]),
              (pwFirstThumb = upsellColorImgMap[pwDefaultColor] || ""));
          });
          var variantsHtml = '<div class="upsell-var-row" data-item-index="0">';
          (optNames.forEach(function (optName) {
            var values = optionValues[optName] || [],
              isColor =
                optName.toLowerCase() === "color" ||
                optName.toLowerCase() === "colour";
            isColor && values.length > 1
              ? ((variantsHtml +=
                  '<div class="tier-opt-group upsell-opt-block" data-opt-name="' +
                  escHtml(optName) +
                  '" style="display:grid;grid-template-columns:3.75rem minmax(0,1fr);align-items:center;column-gap:0.5rem;margin-top:0.375rem;"><div style="min-width:0;font-family:var(--font-body);font-size:9px;line-height:1.15;color:var(--color-muted);"><span style="display:block;font-weight:500;">' +
                  escHtml(optName) +
                  '</span><span class="upsell-color-label" style="display:block;margin-top:0.125rem;font-weight:300;color:var(--color-accent);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' +
                  escHtml(values[0]) +
                  '</span></div><div style="display:flex;align-items:center;gap:0.375rem;flex-wrap:wrap;">'),
                values.forEach(function (v, vi) {
                  var uImg = upsellColorImgMap[v] || "",
                    inner = uImg
                      ? '<img src="' +
                        escHtml(uImg) +
                        '" alt="' +
                        escHtml(v) +
                        '" loading="lazy">'
                      : "",
                    bg = uImg ? "" : "background:" + colorToHex(v) + ";";
                  variantsHtml +=
                    '<button type="button" class="upsell-color-btn' +
                    (vi === 0 ? " is-active is-selected" : "") +
                    '" data-color="' +
                    escHtml(v) +
                    '" data-opt-name="' +
                    escHtml(optName) +
                    '" title="' +
                    escHtml(v) +
                    '" style="' +
                    bg +
                    '">' +
                    inner +
                    "</button>";
                }),
                (variantsHtml += "</div></div>"))
              : values.length > 0 &&
                !isColor &&
                ((variantsHtml +=
                  '<div class="tier-opt-group upsell-opt-block" data-opt-name="' +
                  escHtml(optName) +
                  '" style="display:grid;grid-template-columns:3.75rem minmax(0,1fr);align-items:center;column-gap:0.5rem;margin-top:0.375rem;"><div style="min-width:0;font-family:var(--font-body);font-size:9px;font-weight:500;line-height:1.15;color:var(--color-muted);">' +
                  escHtml(optName) +
                  '</div><div style="display:flex;align-items:center;gap:0.375rem;flex-wrap:wrap;">'),
                values.forEach(function (v) {
                  variantsHtml +=
                    '<button type="button" class="upsell-size-btn" data-size="' +
                    escHtml(v) +
                    '" data-opt-name="' +
                    escHtml(optName) +
                    '">' +
                    escHtml(v) +
                    "</button>";
                }),
                (variantsHtml += "</div></div>"));
          }),
            (variantsHtml += "</div>"));
          var basePrice = 0;
          variants.length > 0 &&
            variants[0].price &&
            (basePrice = parseFloat(variants[0].price));
          var upsellPrice = basePrice;
          up.discountValue > 0 &&
            (up.discountType === "percentage"
              ? (upsellPrice = basePrice * (1 - up.discountValue / 100))
              : (upsellPrice = Math.max(0, basePrice - up.discountValue)));
          var upFullCents = Math.round(basePrice * 100),
            upDiscCents = Math.round(upsellPrice * 100),
            upImgMain =
              up.productImage || (variants[0] && variants[0].image) || "";
          html +=
            '<div class="upsell-card" data-upsell-idx="' +
            idx +
            '" data-upsell-price="' +
            upsellPrice.toFixed(2) +
            '"><div class="upsell-card__row" style="display:flex;gap:0.75rem;align-items:flex-start;padding:0.875rem 1rem;"><div class="upsell-pair-thumb" data-pairux-zoom data-pairux-img="' +
            escHtml(upImgMain) +
            '" title="Tap to enlarge" style="flex-shrink:0;width:3rem;height:3.75rem;border-radius:3px;overflow:hidden;border:1px solid rgba(232,226,217,0.4);background:var(--color-surface,#F0EBE3);cursor:zoom-in;">' +
            (upImgMain
              ? '<img src="' +
                escHtml(upImgMain) +
                '" alt="" style="width:100%;height:100%;object-fit:cover;pointer-events:none;" loading="lazy">'
              : "") +
            '</div><div style="flex:1;min-width:0;"><div style="display:flex;align-items:flex-start;justify-content:space-between;gap:0.5rem;"><p class="upsell-card__name" data-upsell-qv role="button" tabindex="0" title="Quick view" style="flex:1;min-width:0;font-family:var(--font-body);font-size:11px;font-weight:500;color:var(--color-primary);margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;cursor:pointer;text-decoration:underline;text-decoration-color:rgba(139,111,71,0.4);text-underline-offset:2px;">' +
            escHtml(up.productTitle) +
            '</p><div style="flex-shrink:0;display:flex;align-items:flex-start;gap:0.5rem;"><div class="upsell-pair-price" style="text-align:right;">' +
            pairPriceColHtml(upFullCents, upDiscCents) +
            '</div><div class="upsell-toggle" data-upsell-toggle><div class="upsell-toggle__knob"></div></div></div></div>' +
            (discountLabel
              ? '<p class="upsell-card__sub" style="font-family:var(--font-body);font-size:9px;font-weight:300;color:var(--color-warm);margin:0.25rem 0 0;">' +
                escHtml(discountLabel) +
                "</p>"
              : "") +
            '<div class="upsell-controls" style="margin-top:0.375rem;">' +
            variantsHtml +
            "</div></div></div></div>";
        }),
          (html += "</div>"),
          (section.innerHTML = html),
          ensurePairUX(),
          upsells.forEach(function (up, idx) {
            var card = section.querySelector(
              '.upsell-card[data-upsell-idx="' + idx + '"]',
            );
            if (card) {
              ((card._upsellData = up),
                card
                  .querySelectorAll(".upsell-color-btn")
                  .forEach(function (btn) {
                    btn.addEventListener("click", function (e) {
                      e.stopPropagation();
                      var optGroup = btn.closest(".tier-opt-group");
                      if (optGroup) {
                        (optGroup
                          .querySelectorAll(".upsell-color-btn")
                          .forEach(function (b) {
                            b.classList.remove("is-active", "is-selected");
                          }),
                          btn.classList.add("is-active", "is-selected"));
                        var label = optGroup.querySelector(
                          ".upsell-color-label",
                        );
                        label && (label.textContent = btn.dataset.color || "");
                        var thumbDiv = card.querySelector(".upsell-item-thumb");
                        if (thumbDiv && up.variants) {
                          var selC = btn.dataset.color,
                            matchV = up.variants.find(function (v) {
                              return (
                                (v.image || v.featuredImage) &&
                                (v.options || []).some(function (o) {
                                  return o.value === selC;
                                })
                              );
                            });
                          if (matchV) {
                            var tImg = thumbDiv.querySelector("img");
                            tImg &&
                              (tImg.src = matchV.image || matchV.featuredImage);
                          }
                        }
                        updateUpsellSizesForColor(card);
                      }
                    });
                  }),
                card
                  .querySelectorAll(".upsell-size-btn")
                  .forEach(function (btn) {
                    btn.addEventListener("click", function (e) {
                      (e.stopPropagation(),
                        card
                          .querySelectorAll(".upsell-size-btn")
                          .forEach(function (b) {
                            b.classList.remove("is-selected");
                          }),
                        btn.classList.add("is-selected"),
                        updateATCButton(),
                        updateGrandTotal());
                    });
                  }));
              var titleEl = card.querySelector("[data-upsell-qv]");
              (titleEl &&
                titleEl.addEventListener("click", function (e) {
                  e.stopPropagation();
                  var u = card._upsellData || {},
                    imgs = [];
                  (u.productImage && imgs.push(u.productImage),
                    (u.variants || []).forEach(function (v) {
                      v.image &&
                        imgs.indexOf(v.image) === -1 &&
                        imgs.push(v.image);
                    }));
                  var base =
                    u.variants && u.variants[0] && u.variants[0].price
                      ? Math.round(parseFloat(u.variants[0].price) * 100)
                      : 0;
                  pairUXOpenModalData({
                    title: u.productTitle || "",
                    images: imgs.slice(0, 8),
                    featured_image: u.productImage || imgs[0] || "",
                    price: base,
                    compare_at_price: 0,
                    description: "",
                  });
                }),
                updateUpsellSizesForColor(card));
              var firstSize = card.querySelector(
                ".upsell-size-btn:not(:disabled)",
              );
              firstSize && firstSize.classList.add("is-selected");
            }
          }));
      }
    }
  }
  function updateUpsellSizesForColor(card) {
    var up = card._upsellData;
    if (!(!up || !up.variants)) {
      var selColor = card.querySelector(".upsell-color-btn.is-active")?.dataset
        .color;
      if (selColor) {
        card.querySelectorAll(".upsell-size-btn").forEach(function (btn) {
          var size = btn.dataset.size,
            optName = btn.dataset.optName,
            isAvail = up.variants.some(function (v) {
              var colorMatch = (v.options || []).some(function (o) {
                  return (
                    (o.name.toLowerCase() === "color" ||
                      o.name.toLowerCase() === "colour") &&
                    o.value === selColor
                  );
                }),
                sizeMatch = (v.options || []).some(function (o) {
                  return o.name === optName && o.value === size;
                });
              return colorMatch && sizeMatch;
            });
          ((btn.disabled = !isAvail), btn.classList.remove("is-selected"));
        });
        var firstAvail = card.querySelector(".upsell-size-btn:not(:disabled)");
        (firstAvail && firstAvail.classList.add("is-selected"),
          updateATCButton(),
          updateGrandTotal());
      }
    }
  }
  function updateBundleSizesForColor(color) {
    var variantsEl = document.getElementById("bd-variants");
    if (variantsEl) {
      var variants;
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch {
        return;
      }
      // v39 20261010 — same per-slot writer as the native path
      // (syncBundleRowsFromMain): skips slots picked by hand, refreshes labels.
      bundleSlotRows().forEach(function (row) {
        var group = row
          .querySelector(".tier-color-btn:not(.tier-upsell-color-btn)")
          ?.closest(".tier-opt-group");
        if (!group || isBundleFieldManual(group)) return;
        (syncBundleRowColor(row, color), syncBundleVariantSelectTriggers(row));
      });
      var firstAvail = variants.find(function (v) {
        return v.available && (!color || v.options.indexOf(color) !== -1);
      });
      if (firstAvail) {
        var variantInput = document.querySelector('#product-form [name="id"]');
        variantInput && (variantInput.value = firstAvail.id);
      }
      (updateGrandTotal(), updateATCButton());
    }
  }
  function readBundleVariants() {
    var variantsEl = document.getElementById("bd-variants");
    if (!variantsEl) return [];
    try {
      var parsed = JSON.parse(variantsEl.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  function closeBundleVariantMenus(scope, except) {
    (scope || document)
      .querySelectorAll(".bundle-variant-select__menu")
      .forEach(function (menu) {
        if (menu === except) return;
        menu.hidden = !0;
        var trigger = menu.parentElement.querySelector(
          ".bundle-variant-select__trigger",
        );
        trigger && trigger.setAttribute("aria-expanded", "false");
      });
  }
  function handleBundleVariantKeyboard(scope, event) {
    var trigger = event.target.closest(".bundle-variant-select__trigger"),
      option = event.target.closest(".bundle-variant-select__option"),
      key = event.key;
    if (trigger) {
      if (key === "Escape") {
        event.preventDefault();
        closeBundleVariantMenus(scope);
        trigger.focus();
        return !0;
      }
      if (
        key !== "ArrowDown" &&
        key !== "ArrowUp" &&
        key !== "Enter" &&
        key !== " "
      )
        return !1;
      event.preventDefault();
      var select = trigger.closest(".bundle-variant-select"),
        menu = select && select.querySelector(".bundle-variant-select__menu"),
        options = menu
          ? Array.from(
              menu.querySelectorAll(
                ".bundle-variant-select__option:not(:disabled)",
              ),
            )
          : [];
      if (!menu || !options.length) return !0;
      if (menu.hidden) trigger.click();
      requestAnimationFrame(function () {
        var selectedIndex = options.findIndex(function (item) {
            return item.getAttribute("aria-selected") === "true";
          }),
          focusIndex =
            key === "ArrowUp"
              ? selectedIndex > 0
                ? selectedIndex - 1
                : options.length - 1
              : selectedIndex >= 0
                ? selectedIndex
                : 0;
        options[focusIndex].focus();
      });
      return !0;
    }
    if (!option) return !1;
    var menu = option.closest(".bundle-variant-select__menu"),
      select = option.closest(".bundle-variant-select"),
      trigger = select && select.querySelector(".bundle-variant-select__trigger"),
      options = menu
        ? Array.from(
            menu.querySelectorAll(
              ".bundle-variant-select__option:not(:disabled)",
            ),
          )
        : [],
      current = options.indexOf(option),
      next = current;
    if (key === "ArrowDown") next = (current + 1) % options.length;
    else if (key === "ArrowUp")
      next = (current - 1 + options.length) % options.length;
    else if (key === "Home") next = 0;
    else if (key === "End") next = options.length - 1;
    else if (key === "Enter" || key === " ") {
      event.preventDefault();
      var focusRoot =
          option.closest("[data-pair-companion]") ||
          option.closest(".tier-size-row") ||
          scope,
        triggerIndex = focusRoot
          ? Array.from(
              focusRoot.querySelectorAll(
                ".bundle-variant-select__trigger",
              ),
            ).indexOf(trigger)
          : -1;
      option.click();
      requestAnimationFrame(function () {
        var currentTriggers = focusRoot
            ? focusRoot.querySelectorAll(".bundle-variant-select__trigger")
            : [],
          currentTrigger =
            (triggerIndex >= 0 && currentTriggers[triggerIndex]) || trigger;
        currentTrigger && currentTrigger.focus();
      });
      return !0;
    } else if (key === "Escape") {
      event.preventDefault();
      closeBundleVariantMenus(scope);
      trigger && trigger.focus();
      return !0;
    } else if (key === "Tab") {
      closeBundleVariantMenus(scope);
      return !1;
    } else return !1;
    event.preventDefault();
    options[next] && options[next].focus();
    return !0;
  }
  function syncBundleVariantSelectTriggers(scope) {
    (scope || document)
      .querySelectorAll(".bundle-variant-field")
      .forEach(function (field) {
        var selected = field.querySelector(
            ".tier-color-btn.is-active, .size-btn.is-selected, .pc-color-btn.is-active, .pc-size-btn.is-selected",
          ),
          label = field.querySelector("[data-bundle-selected-label]");
        if (selected && label) {
          label.textContent =
            selected.dataset.color ||
            selected.dataset.size ||
            selected.dataset.pcVal ||
            selected.textContent.trim();
          var triggerImage = field.querySelector(
              "[data-bundle-selected-image]",
            ),
            selectedImage = selected.querySelector("img");
          if (triggerImage && selectedImage) triggerImage.src = selectedImage.src;
          field
            .querySelectorAll('[role="option"]')
            .forEach(function (option) {
              option.setAttribute(
                "aria-selected",
                String(option === selected),
              );
            });
        } else if (label) {
          label.textContent =
            "Select " +
            String(field.dataset.optName || "option").toLowerCase();
        }
      });
  }
  function getBundlePrimaryRow() {
    var activeTier =
        bundleState.activeTier && document.body.contains(bundleState.activeTier)
          ? bundleState.activeTier
          : document.querySelector(".bundle-tier.is-active"),
      tier = activeTier || document.querySelector(".bundle-tier");
    return tier
      ? tier.querySelector(
          ".tier-size-row:not(.tier-upsell-row):not(.tier-free-gift)",
        )
      : null;
  }
  function updateBundleRowSizesForColor(row, color) {
    if (row) {
      var variants = readBundleVariants();
      variants.length &&
        row
          .querySelectorAll(".size-btn[data-size]:not(.tier-upsell-size-btn)")
          .forEach(function (btn) {
            var size = btn.dataset.size,
              available = variants.some(function (v) {
                return (
                  v.options.indexOf(size) !== -1 &&
                  v.available &&
                  (!color || v.options.indexOf(color) !== -1)
                );
              });
            ((btn.disabled = !available),
              available || btn.classList.remove("is-selected"));
          });
    }
  }
  function defaultSelectBundleTier(tier) {
    if (tier) {
      var rows = tier.querySelectorAll(
        ".tier-size-row:not(.tier-upsell-row):not(.tier-free-gift)",
      );
      rows.forEach(function (row) {
        var colorBtns = row.querySelectorAll(
          ".tier-color-btn:not(.tier-upsell-color-btn)",
        );
        colorBtns.length &&
          !row.querySelector(".tier-color-btn.is-active") &&
          colorBtns[0].classList.add("is-active", "is-selected");
        var activeColor = row.querySelector(".tier-color-btn.is-active");
        (updateBundleRowSizesForColor(
          row,
          activeColor ? activeColor.dataset.color : null,
        ),
          row.querySelectorAll(".tier-opt-group").forEach(function (grp) {
            var sizeBtns = grp.querySelectorAll(
              ".size-btn[data-size]:not(.tier-upsell-size-btn)",
            );
            if (
              sizeBtns.length &&
              !grp.querySelector(".size-btn[data-size].is-selected")
            ) {
              var pick = null;
              (sizeBtns.forEach(function (b) {
                !pick && !b.disabled && (pick = b);
              }),
                pick || (pick = sizeBtns[0]),
                pick && pick.classList.add("is-selected"));
            }
          }));
      });
      syncBundleVariantSelectTriggers(tier);
    }
  }
  function syncBundleRowColor(row, color) {
    if (!row || !color) return !1;
    var match = null;
    if (
      (row
        .querySelectorAll(".tier-color-btn:not(.tier-upsell-color-btn)")
        .forEach(function (btn) {
          (btn.dataset.color || "") === color && (match = btn);
        }),
      !match)
    )
      return !1;
    var colorGroup = match.closest(".tier-opt-group") || row;
    colorGroup
      .querySelectorAll(".tier-color-btn:not(.tier-upsell-color-btn)")
      .forEach(function (btn) {
        var isMatch = btn === match;
        (btn.classList.toggle("is-active", isMatch),
          btn.classList.toggle("is-selected", isMatch),
          (btn.style.borderColor = isMatch
            ? "var(--color-primary)"
            : "var(--color-border)"));
      });
    var colorLabel = colorGroup.querySelector(".tier-color-label");
    colorLabel && (colorLabel.textContent = color);
    var swatchEl = document.getElementById("bd-swatches");
    if (swatchEl)
      try {
        var cmap = JSON.parse(swatchEl.textContent) || {},
          thumbDiv = row.querySelector(".tier-item-thumb"),
          img = thumbDiv ? thumbDiv.querySelector("img") : null;
        img && cmap[color] && (img.src = cmap[color]);
      } catch {}
    return (updateBundleRowSizesForColor(row, color), !0);
  }
  function syncBundleRowOption(row, optionName, value) {
    if (!row || !value) return !1;
    var name = String(optionName || "").toLowerCase();
    if (name === "color" || name === "colour")
      return syncBundleRowColor(row, value);
    // v39 20261010: exact option-name match first (3-option products used to
    // land on the first non-colour group whatever its name).
    var group = bundleRowOptionGroup(row, optionName);
    if (
      !group &&
      (row.querySelectorAll(".tier-opt-group").forEach(function (candidate) {
        var candidateName = String(
          candidate.dataset.optName || "",
        ).toLowerCase();
        !group &&
          (candidateName === name ||
            candidate.querySelector(".size-btn[data-size]")) &&
          (group = candidate);
      }),
      !group)
    )
      return !1;
    var match = null;
    return (
      group
        .querySelectorAll(".size-btn[data-size]:not(.tier-upsell-size-btn)")
        .forEach(function (btn) {
          (btn.dataset.size || "") === value && (match = btn);
        }),
      !match || match.disabled
        ? !1
        : (group
            .querySelectorAll(".size-btn[data-size]:not(.tier-upsell-size-btn)")
            .forEach(function (btn) {
              btn.classList.toggle("is-selected", btn === match);
            }),
          !0)
    );
  }
  // ── DUNIII v39 20261010 · main selector → every Bundle slot ─────────────
  // Bug (Edward 2026-10-10): switching the main colour only rewrote slot #1 of
  // the ACTIVE tier (old getBundlePrimaryRow path) and never refreshed the
  // dropdown labels, so 1 Pack / the other slots / 3 Pack / Perfect Pair kept
  // the old variant: heading price stayed, cart got the old colour.
  // A slot's variant has ONE truth: its own option buttons
  // (.tier-color-btn.is-active / .size-btn.is-selected). resolveBundleRowVariant
  // reads them for price, strike and add-to-cart; syncBundleVariantSelectTriggers
  // derives the dropdown label from them. This block only writes those buttons.
  // A slot field the shopper picked by hand (data-bundle-manual="1") keeps it;
  // every other field of every tier follows the main selector.
  // v40 20261010: this includes 1 Pack. A 1 Pack pick still moves the main
  // selector (product-main.liquid data-dn-bundle-to-native-sync, unchanged),
  // but the picked field stays hand-picked: a later main switch leaves it.
  function bundleSlotRows(scope) {
    var root = scope || document.querySelector(".bundle-tiers");
    return root
      ? Array.prototype.slice.call(
          root.querySelectorAll(
            ".tier-size-row:not(.tier-upsell-row):not(.tier-free-gift)",
          ),
        )
      : [];
  }
  function isBundleFieldManual(group) {
    return !!(group && group.dataset.bundleManual === "1");
  }
  function markBundleFieldManual(group) {
    group &&
      group.closest(".tier-size-row:not(.tier-upsell-row):not(.tier-free-gift)") &&
      (group.dataset.bundleManual = "1");
  }
  function bundleRowOptionGroup(row, optionName) {
    var name = String(optionName || "").toLowerCase(),
      found = null;
    return (
      row &&
        row.querySelectorAll(".tier-opt-group").forEach(function (group) {
          !found &&
            String(group.dataset.optName || "").toLowerCase() === name &&
            (found = group);
        }),
      found
    );
  }
  function mainSelectorValues() {
    var list = [];
    return (
      nativeSelectors().forEach(function (selector) {
        var active = selector.querySelector(
          ".color-swatch.is-active, .size-btn.is-selected, [data-native-option-value].is-selected",
        );
        if (!active) return;
        var name = String(selector.dataset.optionName || ""),
          lower = name.toLowerCase();
        list.push({
          name: name,
          isColor: lower === "color" || lower === "colour",
          value:
            active.dataset.nativeOptionValue ||
            active.dataset.colorName ||
            active.dataset.size ||
            active.textContent.trim(),
        });
      }),
      // colour first: it decides which sizes the slot can still offer
      list.sort(function (a, b) {
        return (b.isColor ? 1 : 0) - (a.isColor ? 1 : 0);
      })
    );
  }
  function syncBundleRowsFromMain(scope) {
    var values = mainSelectorValues(),
      changed = !1;
    return values.length
      ? (bundleSlotRows(scope).forEach(function (row) {
          (values.forEach(function (o) {
            var group = bundleRowOptionGroup(row, o.name);
            isBundleFieldManual(group) ||
              (changed = syncBundleRowOption(row, o.name, o.value) || changed);
          }),
            syncBundleVariantSelectTriggers(row));
        }),
        changed)
      : !1;
  }
  function syncBundleFromNativeVariantState() {
    if (!bundleSlotRows().length) return !1;
    var changed = syncBundleRowsFromMain();
    // v40 20261010 — always re-render: the heading quotes the main selection
    // even when every slot was hand-picked (nothing changed), and
    // syncNativeVariantState has just overwritten the ATC button with its
    // single-variant text.
    return (updateGrandTotal(), updateATCButton(), changed);
  }
  function initFloatingATC() {
    const bar = document.querySelector(".floating-atc"),
      anchor = document.getElementById("atc-anchor");
    if (!bar || !anchor) return;
    (new IntersectionObserver(
      ([entry]) => {
        var showBar = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        (bar.classList.toggle("is-visible", showBar),
          document.body.classList.toggle("atc-bar-visible", showBar));
      },
      { threshold: 0, rootMargin: "-80px 0px 0px 0px" },
    ).observe(anchor),
      bar
        .querySelector("[data-floating-atc]")
        ?.addEventListener("click", (event) => {
          if (event.currentTarget.hasAttribute("data-dn5-scroll-bundle")) {
            anchor.scrollIntoView({ behavior: "smooth", block: "start" });
            return;
          }
          allSizesSelected()
            ? document.getElementById("product-form")?.requestSubmit()
            : anchor.scrollIntoView({ behavior: "smooth", block: "center" });
        }));
  }
  function initSizeSelector() {
    (document.querySelectorAll(".size-selector").forEach((selector) => {
      (selector.hasAttribute("data-native-option-selector")
        ? selector.querySelectorAll(".size-btn")
        : selector.querySelectorAll(".size-btn:not(:disabled)")
      ).forEach((btn) => {
        if (selector.hasAttribute("data-native-option-selector")) {
          if (btn.dataset.nativeBound === "1") return;
          ((btn.dataset.nativeBound = "1"),
            btn.addEventListener("click", (e) => {
              (e.stopPropagation(),
                selector
                  .querySelectorAll(".size-btn")
                  .forEach((b) => b.classList.remove("is-selected")),
                btn.classList.add("is-selected"),
                syncNativeVariantState(),
                syncBundleFromNativeVariantState());
            }));
          return;
        }
        btn.addEventListener("click", (e) => {
          (e.stopPropagation(),
            selector
              .querySelectorAll(".size-btn")
              .forEach((b) => b.classList.remove("is-selected")),
            btn.classList.add("is-selected"));
          const variantInput = selector
            .closest("form")
            ?.querySelector('[name="id"]');
          (variantInput &&
            btn.dataset.variantId &&
            (variantInput.value = btn.dataset.variantId),
            updateATCButton());
        });
      });
    }),
      syncNativeVariantState(),
      syncBundleFromNativeVariantState());
  }
  function readNativeVariants() {
    const el = document.getElementById("pdp-variants");
    if (!el) return [];
    try {
      const parsed = JSON.parse(el.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  function nativeSelectors() {
    return Array.from(
      document.querySelectorAll("[data-native-option-selector]"),
    );
  }
  function selectedNativeOptions(selectors) {
    const selected = [];
    return (
      selectors.forEach(function (selector) {
        const idx = parseInt(selector.dataset.optionIndex || "0", 10),
          active = selector.querySelector(
            ".color-swatch.is-active, .size-btn.is-selected, [data-native-option-value].is-selected",
          );
        active &&
          (selected[idx] =
            active.dataset.nativeOptionValue ||
            active.dataset.colorName ||
            active.dataset.size ||
            active.textContent.trim());
      }),
      selected
    );
  }
  function variantMatchesOptions(variant, selected, partial) {
    const opts =
      variant && Array.isArray(variant.options) ? variant.options : [];
    for (let i = 0; i < opts.length; i++)
      if (
        (selected[i] && opts[i] !== selected[i]) ||
        (!partial && !selected[i])
      )
        return !1;
    return !0;
  }
  function syncNativeVariantState() {
    const variants = readNativeVariants();
    if (!variants.length) return !1;
    const selectors = nativeSelectors();
    if (!selectors.length) return !1;
    const selected = selectedNativeOptions(selectors);
    selectors.forEach(function (selector) {
      const idx = parseInt(selector.dataset.optionIndex || "0", 10);
      /* 20260727 option 2: colour swatches are never disabled. The old code hard-disabled colours of sold-out combinations, but the theme has no   .color-swatch:disabled style — the swatch looked normal (opacity 1, cursor pointer) yet did nothing, and after picking a   size even colours in stock in other sizes went dead (drs0007 with XXL: 14 of 25 colours disabled, 10 of them buyable).   Now: colours are always clickable; out-of-stock is shown by greyed size buttons + SOLD OUT on the ATC. The size buttons keep their disabling logic. */ var dnIsSwatch =
        selector.classList.contains("color-swatches") ||
        !!selector.querySelector(".color-swatch");
      selector
        .querySelectorAll("[data-native-option-value]")
        .forEach(function (btn2) {
          if (dnIsSwatch) {
            btn2.disabled = !1;
            btn2.removeAttribute("aria-disabled");
            return;
          }
          const val = btn2.dataset.nativeOptionValue || btn2.textContent.trim(),
            probe = selected.slice();
          probe[idx] = val;
          const available = variants.some(function (v) {
            return v.available !== !1 && variantMatchesOptions(v, probe, !0);
          });
          btn2.disabled = !available;
        });
    });
    const missingSelector = selectors.find(function (selector) {
        return !selector.querySelector(
          ".color-swatch.is-active, .size-btn.is-selected, [data-native-option-value].is-selected",
        );
      }),
      allSelected = !missingSelector,
      matched = allSelected
        ? variants.find(function (v) {
            return v.available !== !1 && variantMatchesOptions(v, selected, !1);
          })
        : null,
      fallback =
        !matched && allSelected
          ? variants.find(function (v) {
              return variantMatchesOptions(v, selected, !1);
            })
          : null,
      current = matched || fallback,
      variantInput = document
        .getElementById("product-form")
        ?.querySelector('[name="id"]');
    variantInput && current?.id && (variantInput.value = current.id);
    if (current && !getBundlePrimaryRow()) {
      var nativePrice = normalizeCents(current.price),
        nativeCompare = normalizeCents(current.compare_at_price),
        nativeTotal = document.getElementById("pdp-grand-total");
      if (nativeTotal && nativePrice > 0) {
        ((nativeTotal.textContent = formatMoney(nativePrice)),
          (nativeTotal.dataset.originalPrice = String(nativePrice)),
          (nativeTotal.dataset.compareAtPrice = String(nativeCompare || 0)));
        var nativeCompareEl = document.getElementById("pdp-compare-price"),
          nativeBadge = document.getElementById("pdp-discount-badge"),
          nativeSavings = document.getElementById("pdp-savings"),
          nativeHasDiscount = nativeCompare > nativePrice;
        (nativeCompareEl &&
          (nativeHasDiscount
            ? ((nativeCompareEl.textContent = formatMoney(nativeCompare)),
              (nativeCompareEl.style.display = ""))
            : ((nativeCompareEl.textContent = ""),
              (nativeCompareEl.style.display = "none"))),
          nativeBadge &&
            (nativeHasDiscount
              ? ((nativeBadge.textContent =
                  "-" +
                  Math.round(
                    ((nativeCompare - nativePrice) / nativeCompare) * 100,
                  ) +
                  "%"),
                (nativeBadge.style.display = ""))
              : ((nativeBadge.textContent = "-0%"),
                (nativeBadge.style.display = "none"))),
          nativeSavings &&
            (nativeHasDiscount
              ? ((nativeSavings.textContent =
                  "Save " + formatMoney(nativeCompare - nativePrice)),
                (nativeSavings.style.display = ""))
              : ((nativeSavings.textContent = ""),
                (nativeSavings.style.display = "none"))),
          document
            .querySelectorAll(".dn3-float-price,[data-dn-atc-price]")
            .forEach(function (el) {
              el.textContent = formatMoney(nativePrice);
            }));
      }
    }
    const btn = document.getElementById("main-atc"),
      atcText = document.getElementById("atc-text"),
      paymentBtn = document.querySelector(".shopify-payment-button");
    if (btn && atcText)
      if (allSelected)
        matched
          ? ((atcText.textContent = "ADD TO CART"),
            (btn.disabled = !1),
            paymentBtn &&
              (shouldDisableDynamicCheckout()
                ? ((paymentBtn.style.display = "none"),
                  (paymentBtn.style.pointerEvents = "none"),
                  (paymentBtn.style.opacity = "0"))
                : ((paymentBtn.style.display = ""),
                  (paymentBtn.style.pointerEvents = ""),
                  (paymentBtn.style.opacity = ""))))
          : ((atcText.textContent = "SOLD OUT"),
            (btn.disabled = !0),
            paymentBtn &&
              ((paymentBtn.style.display = shouldDisableDynamicCheckout()
                ? "none"
                : ""),
              (paymentBtn.style.pointerEvents = "none"),
              (paymentBtn.style.opacity = shouldDisableDynamicCheckout()
                ? "0"
                : "0.4")));
      else {
        /* 20260727: when the selected colour is sold out in every size the whole size row is disabled, so "SELECT A SIZE" would contradict itself (none can be picked).   That case shows SOLD OUT; while something is still selectable the original SELECT A xxx prompt stays. */ const dnMissBtns =
            missingSelector
              ? Array.prototype.slice.call(
                  missingSelector.querySelectorAll(
                    "[data-native-option-value]",
                  ),
                )
              : [],
          dnNoneLeft =
            dnMissBtns.length > 0 &&
            dnMissBtns.every(function (b) {
              return b.disabled;
            });
        const missingName = (
          missingSelector?.dataset.optionName || "option"
        ).toUpperCase();
        ((atcText.textContent = dnNoneLeft
          ? "SOLD OUT"
          : "SELECT A " + missingName),
          (btn.disabled = !0),
          paymentBtn &&
            ((paymentBtn.style.display = shouldDisableDynamicCheckout()
              ? "none"
              : ""),
            (paymentBtn.style.pointerEvents = "none"),
            (paymentBtn.style.opacity = shouldDisableDynamicCheckout()
              ? "0"
              : "0.4")));
      }
    return !0;
  }
  function initMagneticButtons() {
    canHover &&
      document.querySelectorAll("[data-magnetic]").forEach((btn) => {
        const strength = parseFloat(btn.dataset.magnetic || "0.3");
        (btn.addEventListener("mousemove", (e) => {
          const rect = btn.getBoundingClientRect(),
            cx = rect.left + rect.width / 2,
            cy = rect.top + rect.height / 2,
            dx = (e.clientX - cx) * strength,
            dy = (e.clientY - cy) * strength;
          btn.style.transform = `translate(${dx}px, ${dy}px)`;
        }),
          btn.addEventListener("mouseleave", () => {
            ((btn.style.transform = ""),
              (btn.style.transition =
                "transform 0.5s cubic-bezier(0.22,1,0.36,1)"),
              setTimeout(() => {
                btn.style.transition = "";
              }, 500));
          }));
      });
  }
  function initColorSwatches() {
    (document.querySelectorAll(".color-swatches").forEach((container) => {
      const swatches = container.querySelectorAll(".color-swatch"),
        label = container.querySelector(".color-swatch-label");
      swatches.forEach((sw) => {
        sw.dataset.nativeColorBound !== "1" &&
          ((sw.dataset.nativeColorBound = "1"),
          sw.addEventListener("click", () => {
            (swatches.forEach((s) => {
              (s.classList.remove("is-active"),
                (s.style.borderColor = "var(--color-border)"));
            }),
              sw.classList.add("is-active"),
              (sw.style.borderColor = "var(--color-primary)"),
              label &&
                (label.textContent = "\u2014 " + (sw.dataset.colorName || "")));
            var imgUrl = sw.dataset.image;
            (imgUrl || sw.dataset.mediaId) &&
              activateProductGalleryMedia(sw.dataset.mediaId, imgUrl);
            const nativeSynced = syncNativeVariantState();
            (syncBundleFromNativeVariantState(),
              nativeSynced || updateBundleSizesForColor(sw.dataset.colorName));
          }));
      });
    }),
      syncNativeVariantState(),
      syncBundleFromNativeVariantState());
  }
  function initContextualGreeting() {
    const el = document.querySelector(".hero__greeting");
    if (!el) return;
    const h = new Date().getHours();
    let greetings;
    h >= 5 && h < 7
      ? (greetings = [
          { t: "You're up early.", s: "We have something soft for that." },
        ])
      : h >= 7 && h < 12
        ? (greetings = [
            { t: "Good morning.", s: "Ready for your coffee run?" },
            { t: "Morning.", s: "Let's find you something effortless." },
          ])
        : h >= 12 && h < 17
          ? (greetings = [
              { t: "Afternoon.", s: "The perfect time to treat yourself." },
            ])
          : h >= 17 && h < 21
            ? (greetings = [
                {
                  t: "Good evening.",
                  s: "Let's get you into something comfortable.",
                },
              ])
            : (greetings = [
                {
                  t: "Can't sleep?",
                  s: "Neither can we. Let's browse together.",
                },
              ]);
    const g = greetings[Math.floor(Math.random() * greetings.length)],
      textEl = el.querySelector(".hero__greeting-text"),
      subEl = el.querySelector(".hero__greeting-sub");
    (textEl && (textEl.textContent = g.t),
      subEl && (subEl.textContent = g.s),
      setTimeout(() => {
        ((el.style.opacity = "1"), (el.style.transform = "translateY(0)"));
      }, 1200));
  }
  function initCollectionFilters() {
    const filterBtns = document.querySelectorAll("[data-filter]"),
      sortSelect = document.querySelector("[data-sort]");
    (filterBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const filter = btn.dataset.filter,
          url = new URL(window.location);
        (filter === "all"
          ? url.searchParams.delete("filter")
          : url.searchParams.set("filter", filter),
          (window.location = url));
      });
    }),
      sortSelect?.addEventListener("change", () => {
        const url = new URL(window.location);
        (url.searchParams.set("sort_by", sortSelect.value),
          (window.location = url));
      }));
  }
  function initCollectionFreshLinks() {
    try {
      const current = new URL(window.location.href),
        targetPath = {
          "/collections": "/collections",
          "/collections/dresses": "/collections/dresses",
          "/collections/tops": "/collections/tops",
        }[current.pathname],
        sortBy = current.searchParams.get("sort_by"),
        page = current.searchParams.get("page");
      if (false) {
        ((current.pathname = targetPath),
          current.searchParams.set("sort_by", "created-descending"),
          page || current.searchParams.set("page", "1"),
          window.location.replace(current.toString()));
        return;
      }
    } catch {}
    document.addEventListener(
      "click",
      function (e) {
        if (
          e.defaultPrevented ||
          e.button !== 0 ||
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          e.altKey
        )
          return;
        const link =
          e.target && e.target.closest ? e.target.closest("a[href]") : null;
        if (!link || link.target || link.hasAttribute("download")) return;
        const rawHref = link.getAttribute("href") || "";
        if (!rawHref || !rawHref.includes("/collections")) return;
        let url;
        try {
          url = new URL(rawHref, window.location.origin);
        } catch {
          return;
        }
        if (
          url.origin !== window.location.origin ||
          (url.pathname !== "/collections" &&
            !url.pathname.startsWith("/collections/"))
        )
          return;
        const linkSort = url.searchParams.get("sort_by"),
          needsSort = !1;
        !needsSort ||
          (needsSort && url.searchParams.set("sort_by", "created-descending"),
          url.searchParams.get("page") || url.searchParams.set("page", "1"),
          e.preventDefault(),
          (window.location.href = url.toString()));
      },
      !0,
    );
  }
  function repairStaleCollectionCache() {
    try {
      (document.documentElement.classList.remove("dn-cards-settling"),
        document.documentElement.classList.add("dn-hover-ready"),
        document.documentElement.removeAttribute("data-dn-card-entry-guard"));
      const normalizeCollectionHref = function (raw, fallback) {
        let url;
        try {
          url = new URL(
            raw || fallback || "/collections",
            window.location.origin,
          );
        } catch {
          return fallback || "/collections?sort_by=created-descending&page=1";
        }
        return url.origin !== window.location.origin ||
          (url.pathname !== "/collections" &&
            !url.pathname.startsWith("/collections/"))
          ? raw || fallback || ""
          : (url.searchParams.delete("view"),
            void 0,
            url.pathname + url.search + url.hash);
      };
      (document
        .querySelectorAll('a[href*="/collections"]')
        .forEach(function (link) {
          const normalized = normalizeCollectionHref(link.getAttribute("href"));
          normalized && link.setAttribute("href", normalized);
        }),
        document
          .querySelectorAll(
            ".site-header__nav .site-header__nav-item.has-children > button.site-header__nav-link",
          )
          .forEach(function (button) {
            const anchor = document.createElement("a");
            for (
              anchor.className = button.className
                .replace(/\bsite-header__nav-trigger\b/g, "")
                .replace(/\s+/g, " ")
                .trim(),
                anchor.setAttribute(
                  "href",
                  normalizeCollectionHref("", "/collections"),
                ),
                anchor.setAttribute(
                  "aria-haspopup",
                  button.getAttribute("aria-haspopup") || "true",
                ),
                anchor.setAttribute("aria-expanded", "false");
              button.firstChild;

            )
              anchor.appendChild(button.firstChild);
            button.replaceWith(anchor);
          }));
    } catch {}
  }
  function hydrateCollectionPinned() {
    const coll = document.querySelector(
      ".coll[data-section-id][data-collection-handle]",
    );
    if (
      !coll ||
      coll.querySelector("[data-pinned-products]") ||
      !window.location.pathname.includes("/collections/")
    )
      return;
    const sectionId = coll.dataset.sectionId,
      bar = coll.querySelector(".coll__bar");
    if (!sectionId || !bar || !window.fetch || !window.DOMParser) return;
    const url =
      window.location.pathname +
      "?section_id=" +
      encodeURIComponent(sectionId) +
      "&_pinned=" +
      Date.now();
    fetch(url, { credentials: "same-origin" })
      .then((res) => (res.ok ? res.text() : ""))
      .then((html) => {
        if (!html || html.indexOf("data-pinned-products") === -1) return;
        const pinned = new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector("[data-pinned-products]");
        if (!pinned || coll.querySelector("[data-pinned-products]")) return;
        const pinnedHandles = new Set();
        (pinned.querySelectorAll('a[href*="' + PRODUCT_PATH_SEG + '"]').forEach((link) => {
          const handle = (link.getAttribute("href") || "")
            .split(PRODUCT_PATH_SEG)[1]
            ?.split(/[?#]/)[0];
          handle && pinnedHandles.add(handle);
        }),
          pinned.classList.add("is-visible"),
          pinned.querySelectorAll(".reveal").forEach((el) => {
            (el.classList.add("is-visible"),
              el.classList.remove("reveal-pending"));
          }),
          bar.parentNode.insertBefore(pinned, bar),
          pinnedHandles.size &&
            coll
              .querySelectorAll('.coll__grid-wrap a[href*="' + PRODUCT_PATH_SEG + '"]')
              .forEach((link) => {
                const handle = (link.getAttribute("href") || "")
                  .split(PRODUCT_PATH_SEG)[1]
                  ?.split(/[?#]/)[0];
                if (!handle || !pinnedHandles.has(handle)) return;
                const cardWrap =
                  link.closest("[data-product-tags]") ||
                  link.closest(".reveal") ||
                  link.parentElement;
                cardWrap && cardWrap.remove();
              }));
      })
      .catch(() => {});
  }
  function initUGCLightbox() {
    const lightbox = document.getElementById("ugc-lightbox");
    if (!lightbox) return;
    const openBtns = document.querySelectorAll("[data-ugc-open]"),
      closeBtns = lightbox.querySelectorAll("[data-ugc-close]"),
      navThumbs = lightbox.querySelectorAll("[data-ugc-nav]"),
      slides = lightbox.querySelectorAll("[data-ugc-slide]"),
      progressDots = lightbox.querySelectorAll("[data-ugc-progress]"),
      reviewerAvatar = lightbox.querySelector("[data-ugc-reviewer-avatar]"),
      reviewerName = lightbox.querySelector("[data-ugc-reviewer-name]"),
      reviewerStars = lightbox.querySelector("[data-ugc-reviewer-stars]"),
      tapPrev = lightbox.querySelector("[data-ugc-prev]"),
      tapNext = lightbox.querySelector("[data-ugc-next]");
    let current = 0;
    function open() {
      (lightbox.classList.add("is-open"),
        document.body.classList.add("no-scroll"),
        goTo(0));
    }
    function close() {
      (lightbox.classList.remove("is-open"),
        document.body.classList.remove("no-scroll"),
        lightbox.querySelectorAll("video").forEach((v) => v.pause()));
    }
    function goTo(index) {
      if (index < 0 || index >= slides.length) return;
      (slides[current]?.querySelector("video")?.pause(),
        (current = index),
        slides.forEach((s, i) =>
          s.classList.toggle("is-active", i === current),
        ),
        navThumbs.forEach((t, i) =>
          t.classList.toggle("is-active", i === current),
        ),
        progressDots.forEach((dot, i) => {
          const fill = dot.querySelector(".ugc-lightbox__progress-fill");
          fill && (fill.style.width = i <= current ? "100%" : "0%");
        }));
      const activeSlide = slides[current],
        name = activeSlide?.dataset.reviewerName || "",
        rating = parseInt(activeSlide?.dataset.reviewerRating || "5");
      if (
        (reviewerName && (reviewerName.textContent = name),
        reviewerAvatar &&
          (reviewerAvatar.textContent = name
            .split(" ")
            .map((w) => w[0])
            .join("")
            .toUpperCase()),
        reviewerStars)
      ) {
        reviewerStars.innerHTML = "";
        for (let i = 1; i <= 5; i++) {
          const svg = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "svg",
          );
          (svg.setAttribute("width", "8"),
            svg.setAttribute("height", "8"),
            svg.setAttribute("viewBox", "0 0 24 24"),
            svg.setAttribute(
              "fill",
              i <= rating ? "rgba(255,255,255,0.9)" : "rgba(255,255,255,0.25)",
            ),
            svg.setAttribute("stroke", "none"),
            (svg.innerHTML =
              '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>'),
            reviewerStars.appendChild(svg));
        }
      }
    }
    (openBtns.forEach((btn) => btn.addEventListener("click", open)),
      closeBtns.forEach((btn) => btn.addEventListener("click", close)),
      navThumbs.forEach((thumb) => {
        thumb.addEventListener("click", () =>
          goTo(parseInt(thumb.dataset.ugcNav)),
        );
      }),
      tapPrev?.addEventListener("click", () => goTo(current - 1)),
      tapNext?.addEventListener("click", () => goTo(current + 1)),
      document.addEventListener("keydown", (e) => {
        lightbox.classList.contains("is-open") &&
          (e.key === "Escape" && close(),
          e.key === "ArrowLeft" && goTo(current - 1),
          e.key === "ArrowRight" && goTo(current + 1));
      }));
    const media = lightbox.querySelector(".ugc-lightbox__media");
    let swipeX = 0;
    (media?.addEventListener(
      "touchstart",
      (e) => {
        swipeX = e.touches[0].clientX;
      },
      { passive: !0 },
    ),
      media?.addEventListener(
        "touchend",
        (e) => {
          const diff = swipeX - e.changedTouches[0].clientX;
          Math.abs(diff) > 60 &&
            (diff > 0 ? goTo(current + 1) : goTo(current - 1));
        },
        { passive: !0 },
      ));
  }
  function initUGCFromReviews() {
    var block = document.querySelector("[data-ugc-block]");
    if (block) {
      var handle = block.dataset.productHandle;
      if (handle) {
        var thumbsContainer = block.querySelector("[data-ugc-thumbs]"),
          starsContainer = block.querySelector("[data-ugc-stars]"),
          metaEl = block.querySelector("[data-ugc-meta]");
        thumbsContainer &&
          fetch(
            "/apps/reviews/product-reviews?handle=" +
              encodeURIComponent(handle) +
              (block.dataset.productId
                ? "&product_id=" + encodeURIComponent(block.dataset.productId)
                : ""),
          )
            .then(function (r) {
              return r.ok ? r.json() : null;
            })
            .then(function (data) {
              if (!data) return;
              Array.isArray(data) && (data = { reviews: data });
              var reviews = data.reviews || [],
                videos = [];
              function isDurableVideoUrl(url) {
                try {
                  var host = new URL(url, window.location.origin).hostname;
                  return (
                    host === window.location.hostname ||
                    host.indexOf("supabase.co") !== -1 ||
                    host.indexOf("cdn.shopify.com") !== -1
                  );
                } catch {
                  return !1;
                }
              }
              var totalRating = 0,
                ratingCount = 0;
              (reviews.forEach(function (r) {
                ((totalRating += r.rating || 5), ratingCount++);
              }),
                (data.standalone_videos || []).forEach(function (v) {
                  v.url &&
                    videos.push({
                      type: "video",
                      url: v.url,
                      thumb: v.poster || "",
                      name: v.title || "",
                      rating: 5,
                      durable: isDurableVideoUrl(v.url),
                    });
                }));
              var durableVideos = videos.filter(function (v) {
                  return v.durable;
                }),
                media = durableVideos.length ? durableVideos : videos;
              if (media.length) {
                block.style.display = "";
                var requestedLimit = Number(block.dataset.previewLimit),
                  maxThumbs = Number.isInteger(requestedLimit) && requestedLimit > 0 && requestedLimit <= 4
                    ? requestedLimit : 4,
                  showing = media.slice(0, maxThumbs),
                  overflow = media.length - maxThumbs;
                if (
                  ((thumbsContainer.innerHTML = ""),
                  showing.forEach(function (m, i) {
                    var el = document.createElement("div");
                    ((el.className = "ugc-block__thumb"),
                      (el.dataset.ugcIndex = String(i)),
                      m.type === "photo"
                        ? (el.innerHTML =
                            '<img src="' +
                            m.url +
                            '" alt="Customer photo" loading="lazy">')
                        : m.thumb
                          ? (el.innerHTML =
                              '<img src="' +
                              m.thumb +
                              '" alt="Customer video" loading="lazy"><div class="ugc-block__play"><svg width="12" height="12" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div>')
                          : (el.innerHTML =
                              '<video src="' +
                              m.url +
                              '" preload="metadata" muted playsinline style="width:100%;height:100%;object-fit:cover;pointer-events:none;"></video><div class="ugc-block__play"><svg width="12" height="12" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div>'),
                      m.name &&
                        (function () {
                          var ini = String(m.name)
                            .trim()
                            .split(/\s+/)
                            .map(function (w) {
                              var c = w.match(/[A-Za-z]/);
                              return c ? c[0].toUpperCase() : "";
                            })
                            .join("")
                            .slice(0, 2);
                          ini &&
                            (el.innerHTML +=
                              '<span class="dn2-ugc-ini">' + ini + "</span>");
                        })(),
                      thumbsContainer.appendChild(el));
                  }),
                  overflow > 0)
                ) {
                  var moreEl = document.createElement("div");
                  ((moreEl.className = "ugc-block__more"),
                    (moreEl.dataset.ugcIndex = String(maxThumbs)));
                  if (block.hasAttribute("data-preview-limit")) {
                    var number = document.createElement("b"),
                      label = document.createElement("span");
                    number.textContent = "+" + overflow;
                    label.textContent = block.dataset.watchLabel || "WATCH";
                    moreEl.append(number, label);
                  } else {
                    moreEl.textContent = "+" + overflow;
                  }
                  thumbsContainer.appendChild(moreEl);
                }
                var apiAvg = data.average_rating,
                  roundedAvg =
                    apiAvg != null
                      ? Math.round(apiAvg)
                      : ratingCount > 0
                        ? Math.round(totalRating / ratingCount)
                        : 5;
                if (starsContainer && (ratingCount > 0 || apiAvg != null)) {
                  for (var starsHtml = "", i = 1; i <= 5; i++) {
                    var fill =
                      i <= roundedAvg
                        ? "var(--color-primary)"
                        : "var(--color-border)";
                    starsHtml +=
                      '<svg width="11" height="11" viewBox="0 0 24 24" fill="' +
                      fill +
                      '" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
                  }
                  starsContainer.innerHTML = starsHtml;
                }
                (metaEl &&
                  (metaEl.textContent =
                    media.length +
                    " " +
                    (media.length === 1 ? "video" : "videos")),
                  (block._ugcMedia = media),
                  (block._ugcProduct = {
                    title: block.dataset.productTitle || "",
                    price: block.dataset.productPrice || "",
                    compare_at: block.dataset.productCompareAt || "",
                    url: block.dataset.productUrl || "",
                    image: block.dataset.productImage || "",
                    images: (function () {
                      try {
                        return JSON.parse(block.dataset.productImages || "[]");
                      } catch {
                        return [];
                      }
                    })(),
                    colors: (function () {
                      try {
                        return JSON.parse(block.dataset.productColors || "[]");
                      } catch {
                        return [];
                      }
                    })(),
                    sizes: (function () {
                      try {
                        return JSON.parse(block.dataset.productSizes || "[]");
                      } catch {
                        return [];
                      }
                    })(),
                    selectedColor: block.dataset.selectedColor || "",
                  }));
                var openTrigger = block.querySelector("[data-ugc-open]");
                openTrigger &&
                  openTrigger.addEventListener("click", function () {
                    var activeColorSwatch = document.querySelector(
                      ".color-swatch.is-active",
                    );
                    activeColorSwatch &&
                      (block._ugcProduct.selectedColor =
                        activeColorSwatch.dataset.colorName || "");
                    var activeTier = document.querySelector(
                      ".bundle-tier.is-active",
                    );
                    if (activeTier) {
                      var selectedSizeBtn = activeTier.querySelector(
                        '.tier-size-row[data-item-index="0"] .size-btn.is-selected',
                      );
                      block._ugcProduct.selectedSize = selectedSizeBtn
                        ? selectedSizeBtn.dataset.size
                        : "";
                    }
                    try {
                      var varEl = document.getElementById("bd-variants");
                      varEl &&
                        (block._ugcProduct.variants = JSON.parse(
                          varEl.textContent,
                        ));
                    } catch {}
                    openUGCLightbox(media, block._ugcProduct);
                  });
              }
            })
            .catch(function () {});
      }
    }
  }
  function openUGCLightbox(media, productInfo) {
    var lightbox = document.getElementById("ugc-lightbox");
    if (!lightbox || !media.length) return;
    var mediaContainer = lightbox.querySelector("[data-ugc-lightbox-media]"),
      sidebar = lightbox.querySelector("[data-ugc-sidebar]"),
      progressBar = lightbox.querySelector("[data-ugc-progress]"),
      reviewer = lightbox.querySelector("[data-ugc-reviewer]"),
      avatarEl = lightbox.querySelector("[data-ugc-avatar]"),
      reviewerName = lightbox.querySelector("[data-ugc-reviewer-name]"),
      ratingOverlay = lightbox.querySelector("[data-ugc-rating-overlay]"),
      productImages = lightbox.querySelector("[data-ugc-product-images]"),
      productDetail = lightbox.querySelector("[data-ugc-product-detail]"),
      productMini = lightbox.querySelector("[data-ugc-product-mini]"),
      viewBtn = lightbox.querySelector("[data-ugc-view-btn]");
    if (!mediaContainer) return;
    productInfo = productInfo || {};
    var current = 0,
      slidesHtml = "";
    media.forEach(function (m, i) {
      var cls = "ugc-lightbox__slide" + (i === 0 ? " is-active" : "");
      if (m.type === "photo")
        slidesHtml +=
          '<div class="' +
          cls +
          '" data-slide="' +
          i +
          '"><img src="' +
          m.url +
          '" alt="Customer photo by ' +
          m.name +
          '" draggable="false"></div>';
      else {
        var posterAttr = m.thumb ? ' poster="' + m.thumb + '"' : "";
        slidesHtml +=
          '<div class="' +
          cls +
          '" data-slide="' +
          i +
          '"><div class="ugc-lightbox__video-wrap"><video src="' +
          m.url +
          '"' +
          posterAttr +
          ' playsinline webkit-playsinline preload="metadata"></video></div><div class="ugc-lightbox__video-play" data-video-play><div class="ugc-lightbox__video-play-btn"><svg width="24" height="24" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div></div></div>';
      }
    });
    var tapPrev = mediaContainer.querySelector("[data-ugc-prev]"),
      tapNext = mediaContainer.querySelector("[data-ugc-next]");
    if (
      ((mediaContainer.innerHTML = slidesHtml),
      tapPrev && mediaContainer.appendChild(tapPrev),
      tapNext && mediaContainer.appendChild(tapNext),
      sidebar)
    ) {
      var sidebarHtml = "";
      (media.forEach(function (m, i) {
        var active = i === 0 ? " is-active" : "",
          thumbUrl = m.thumb || m.url;
        m.type === "photo"
          ? (sidebarHtml +=
              '<div class="ugc-lightbox__nav-thumb' +
              active +
              '" data-ugc-nav="' +
              i +
              '"><img src="' +
              (m.thumb || m.url) +
              '" alt="" loading="lazy"></div>')
          : m.thumb
            ? (sidebarHtml +=
                '<div class="ugc-lightbox__nav-thumb' +
                active +
                '" data-ugc-nav="' +
                i +
                '"><img src="' +
                m.thumb +
                '" alt="" loading="lazy"><div class="ugc-lightbox__nav-play"><svg width="8" height="8" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div></div>')
            : (sidebarHtml +=
                '<div class="ugc-lightbox__nav-thumb' +
                active +
                '" data-ugc-nav="' +
                i +
                '"><video src="' +
                m.url +
                '" preload="metadata" muted style="width:100%;height:100%;object-fit:cover;pointer-events:none;"></video><div class="ugc-lightbox__nav-play"><svg width="8" height="8" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div></div>');
      }),
        (sidebar.innerHTML = sidebarHtml),
        sidebar.addEventListener("click", function (e) {
          var thumb = e.target.closest("[data-ugc-nav]");
          thumb && goTo(parseInt(thumb.dataset.ugcNav, 10));
        }));
    }
    if (progressBar) {
      var progressHtml = "";
      (media.forEach(function (m, i) {
        progressHtml +=
          '<div class="ugc-lightbox__progress-dot"><div class="ugc-lightbox__progress-fill" style="width:' +
          (i === 0 ? "100" : "0") +
          '%"></div></div>';
      }),
        (progressBar.innerHTML = progressHtml));
    }
    function updateRatingOverlay(m) {
      if (ratingOverlay) {
        for (
          var stars = '<div style="display:flex;gap:2px;">', s = 1;
          s <= 5;
          s++
        ) {
          var fill = s <= m.rating ? "#fff" : "rgba(255,255,255,0.3)";
          stars +=
            '<svg width="10" height="10" viewBox="0 0 24 24" fill="' +
            fill +
            '" stroke="none"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
        }
        ((stars += "</div>"),
          (ratingOverlay.innerHTML =
            stars +
            '<span style="font-family:var(--font-body);font-size:10px;color:rgba(255,255,255,0.7);margin-left:0.5rem;">&mdash; ' +
            (m.name || "Customer") +
            "</span>"));
      }
    }
    function updateReviewer(m) {
      (avatarEl &&
        (avatarEl.textContent = (m.name || "C").charAt(0).toUpperCase()),
        reviewerName && (reviewerName.textContent = m.name || "Customer"));
    }
    if (productImages && productInfo.images && productInfo.images.length) {
      var piHtml = "";
      (productInfo.images.slice(0, 2).forEach(function (src) {
        piHtml +=
          '<div class="ugc-lightbox__product-img"><img src="' +
          src +
          '" alt="' +
          (productInfo.title || "") +
          '" loading="lazy"></div>';
      }),
        (productImages.innerHTML = piHtml));
    }
    if (productDetail) {
      var detailHtml =
          '<div class="ugc-lightbox__detail-row"><div class="ugc-lightbox__detail-text"><h3 style="font-family:var(--font-heading);font-size:1rem;font-weight:400;color:var(--color-primary);margin-bottom:0.25rem;">' +
          (productInfo.title || "") +
          '</h3><p style="font-family:var(--font-body);font-size:0.85rem;color:var(--color-primary);margin-bottom:0;">' +
          (productInfo.price || "") +
          '</p></div><button type="button" class="ugc-lightbox__sheet-toggle" data-ugc-sheet-toggle>View</button></div>',
        hasColors = productInfo.colors && productInfo.colors.length > 0,
        hasSizes = productInfo.sizes && productInfo.sizes.length > 0;
      if (hasColors || hasSizes) {
        if (
          ((detailHtml +=
            '<div class="ugc-lightbox__sheet-body" style="border-top:1px solid rgba(232,226,217,0.5);padding-top:1rem;">'),
          hasColors &&
            ((detailHtml +=
              '<div style="margin-bottom:1rem;"><p style="font-family:var(--font-body);font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:0.12em;color:var(--color-primary);margin-bottom:0.5rem;">Color</p><div class="ugc-option-group" data-option="color" style="display:flex;gap:0.5rem;flex-wrap:wrap;">'),
            productInfo.colors.forEach(function (c) {
              var isSelected = c === productInfo.selectedColor;
              detailHtml +=
                '<span class="ugc-option-pill' +
                (isSelected ? " is-active" : "") +
                '" data-value="' +
                c +
                '" style="font-family:var(--font-body);font-size:0.72rem;padding:0.25rem 0.625rem;border-radius:4px;cursor:pointer;transition:all 0.2s ease;">' +
                c +
                "</span>";
            }),
            (detailHtml += "</div></div>")),
          hasSizes)
        ) {
          var activeSize =
            productInfo.selectedSize || productInfo.sizes[0] || "";
          ((detailHtml +=
            '<div><p style="font-family:var(--font-body);font-size:10px;font-weight:500;text-transform:uppercase;letter-spacing:0.12em;color:var(--color-primary);margin-bottom:0.5rem;">Size</p><div class="ugc-option-group" data-option="size" style="display:flex;gap:0.5rem;flex-wrap:wrap;">'),
            productInfo.sizes.forEach(function (s) {
              var isSel = s === activeSize;
              detailHtml +=
                '<span class="ugc-option-pill' +
                (isSel ? " is-active" : "") +
                '" data-value="' +
                s +
                '" style="font-family:var(--font-body);font-size:0.72rem;padding:0.25rem 0.625rem;border-radius:4px;cursor:pointer;transition:all 0.2s ease;">' +
                s +
                "</span>";
            }),
            (detailHtml += "</div></div>"));
        }
        detailHtml += "</div>";
      }
      ((productDetail.innerHTML = detailHtml),
        productDetail
          .querySelectorAll(".ugc-option-group")
          .forEach(function (group) {
            group.addEventListener("click", function (e) {
              var pill = e.target.closest(".ugc-option-pill");
              pill &&
                (group
                  .querySelectorAll(".ugc-option-pill")
                  .forEach(function (p) {
                    p.classList.remove("is-active");
                  }),
                pill.classList.add("is-active"));
            });
          }));
    }
    if (
      (productMini &&
        productInfo.image &&
        ((productMini.innerHTML =
          '<img src="' +
          productInfo.image +
          '" alt="' +
          (productInfo.title || "") +
          '">'),
        (productMini.style.display = "")),
      viewBtn)
    ) {
      ((viewBtn.href = productInfo.url || "#"),
        (viewBtn.onclick = function (e) {
          (e.preventDefault(), close());
        }));
      var _ugcAtcDisabled = function (e) {
        e.preventDefault();
        var variants = productInfo.variants || [];
        if (!variants.length) {
          window.location.href = productInfo.url || "/";
          return;
        }
        var selColor = "",
          selSize = "",
          colorPill = productDetail?.querySelector(
            '.ugc-option-group[data-option="color"] .ugc-option-pill.is-active',
          ),
          sizePill = productDetail?.querySelector(
            '.ugc-option-group[data-option="size"] .ugc-option-pill.is-active',
          );
        (colorPill && (selColor = colorPill.dataset.value || ""),
          sizePill && (selSize = sizePill.dataset.value || ""));
        for (var matchedVariant = null, vi = 0; vi < variants.length; vi++) {
          var v = variants[vi],
            opts = v.options || [],
            colorMatch = !selColor || opts.indexOf(selColor) !== -1,
            sizeMatch = !selSize || opts.indexOf(selSize) !== -1;
          if (colorMatch && sizeMatch && v.available) {
            matchedVariant = v;
            break;
          }
        }
        if (!matchedVariant) {
          for (var vi2 = 0; vi2 < variants.length; vi2++)
            if (variants[vi2].available) {
              matchedVariant = variants[vi2];
              break;
            }
        }
        if (!matchedVariant) {
          viewBtn.textContent = "SOLD OUT";
          return;
        }
        ((viewBtn.style.pointerEvents = "none"),
          (viewBtn.innerHTML = "ADDING..."),
          fetch(route("cart/add.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [{ id: matchedVariant.id, quantity: 1 }],
            }),
          })
            .then(function (r) {
              return r.json();
            })
            .then(function () {
              ((viewBtn.innerHTML = "ADDED \u2713"),
                (viewBtn.style.pointerEvents = ""),
                CartDrawer.open(),
                setTimeout(function () {
                  viewBtn.innerHTML =
                    'ADD TO BAG <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
                }, 1500));
            })
            .catch(function () {
              ((viewBtn.innerHTML = "ERROR \u2014 TRY AGAIN"),
                (viewBtn.style.pointerEvents = ""));
            }));
      };
    }
    lightbox && lightbox.classList.remove("is-sheet-open");
    var sheetToggle =
      lightbox && lightbox.querySelector("[data-ugc-sheet-toggle]");
    sheetToggle &&
      (sheetToggle.onclick = function () {
        lightbox.classList.toggle("is-sheet-open");
      });
    function goTo(index) {
      if (!(index < 0 || index >= media.length)) {
        var oldSlide = mediaContainer.querySelector(
          ".ugc-lightbox__slide.is-active",
        );
        if (oldSlide) {
          var oldVideo = oldSlide.querySelector("video");
          (oldVideo && oldVideo.pause(),
            oldSlide.classList.remove("is-active"));
        }
        current = index;
        var newSlide = mediaContainer.querySelector(
          '[data-slide="' + current + '"]',
        );
        if (newSlide) {
          newSlide.classList.add("is-active");
          var playOverlay = newSlide.querySelector("[data-video-play]");
          playOverlay && (playOverlay.style.display = "");
          var newVideo = newSlide.querySelector("video");
          if (newVideo) {
            try {
              newVideo.currentTime = 0;
            } catch {}
            var _pp = newVideo.play();
            _pp &&
              _pp.then &&
              _pp
                .then(function () {
                  playOverlay && (playOverlay.style.display = "none");
                })
                .catch(function () {
                  playOverlay && (playOverlay.style.display = "");
                });
          }
        }
        if (sidebar) {
          sidebar
            .querySelectorAll(".ugc-lightbox__nav-thumb")
            .forEach(function (t, i) {
              t.classList.toggle("is-active", i === current);
            });
          var activeThumb = sidebar.querySelector(".is-active");
          activeThumb &&
            activeThumb.scrollIntoView({
              block: "nearest",
              behavior: "smooth",
            });
        }
        progressBar &&
          progressBar
            .querySelectorAll(".ugc-lightbox__progress-fill")
            .forEach(function (fill, i) {
              fill.style.width = i <= current ? "100%" : "0";
            });
        var arrowPrevEl = mediaContainer.querySelector("[data-ugc-arrow-prev]"),
          arrowNextEl = mediaContainer.querySelector("[data-ugc-arrow-next]");
        (arrowPrevEl && (arrowPrevEl.style.display = current > 0 ? "" : "none"),
          arrowNextEl &&
            (arrowNextEl.style.display =
              current < media.length - 1 ? "" : "none"),
          updateRatingOverlay(media[current]),
          updateReviewer(media[current]));
      }
    }
    (goTo(0), (lightbox.style.display = ""), lightbox.classList.add("is-open"));
    var _ugcScrollY = window.scrollY || window.pageYOffset || 0;
    (document.body.classList.add("no-scroll"),
      (document.body.style.position = "fixed"),
      (document.body.style.top = -_ugcScrollY + "px"),
      (document.body.style.left = "0"),
      (document.body.style.right = "0"),
      (document.body.style.width = "100%"));
    function close() {
      var activeVideo = mediaContainer.querySelector(
        ".ugc-lightbox__slide.is-active video",
      );
      (activeVideo && activeVideo.pause(),
        lightbox.classList.remove("is-open"),
        document.body.classList.remove("no-scroll"),
        (document.body.style.position = ""),
        (document.body.style.top = ""),
        (document.body.style.left = ""),
        (document.body.style.right = ""),
        (document.body.style.width = ""),
        window.scrollTo(0, _ugcScrollY),
        setTimeout(function () {
          lightbox.style.display = "none";
        }, 400),
        document.removeEventListener("keydown", keyHandler));
    }
    function keyHandler(e) {
      (e.key === "Escape" && close(),
        e.key === "ArrowLeft" && goTo(current - 1),
        e.key === "ArrowRight" && goTo(current + 1));
    }
    (document.addEventListener("keydown", keyHandler),
      lightbox.querySelectorAll("[data-ugc-close]").forEach(function (btn) {
        btn.onclick = close;
      }));
    var prevZone = mediaContainer.querySelector("[data-ugc-prev]"),
      nextZone = mediaContainer.querySelector("[data-ugc-next]");
    (prevZone &&
      (prevZone.onclick = function () {
        goTo(current - 1);
      }),
      nextZone &&
        (nextZone.onclick = function () {
          goTo(current + 1);
        }));
    var arrowPrev = mediaContainer.querySelector("[data-ugc-arrow-prev]"),
      arrowNext = mediaContainer.querySelector("[data-ugc-arrow-next]");
    (arrowPrev &&
      (arrowPrev.onclick = function (e) {
        (e.stopPropagation(), goTo(current - 1));
      }),
      arrowNext &&
        (arrowNext.onclick = function (e) {
          (e.stopPropagation(), goTo(current + 1));
        }),
      mediaContainer.addEventListener("click", function (e) {
        var playBtn = e.target.closest("[data-video-play]");
        if (playBtn) {
          var slide = playBtn.closest(".ugc-lightbox__slide");
          if (slide) {
            var video = slide.querySelector("video");
            if (video) {
              video.controls = !0;
              try {
                video.currentTime = 0;
              } catch {}
              var playPromise = video.play();
              playPromise && playPromise.then
                ? playPromise
                    .then(function () {
                      playBtn.style.display = "none";
                    })
                    .catch(function () {
                      playBtn.style.display = "";
                    })
                : (playBtn.style.display = "none");
            }
          }
        }
      }));
    var swipeX = 0;
    (mediaContainer.addEventListener(
      "touchstart",
      function (e) {
        swipeX = e.touches[0].clientX;
      },
      { passive: !0 },
    ),
      mediaContainer.addEventListener(
        "touchend",
        function (e) {
          var diff = swipeX - e.changedTouches[0].clientX;
          Math.abs(diff) > 60 &&
            (diff > 0 ? goTo(current + 1) : goTo(current - 1));
        },
        { passive: !0 },
      ));
  }
  function initProductReviews() {
    const section = document.querySelector(
      ".reviews-section[data-product-handle]",
    );
    if (!section) return;
    const handle = section.dataset.productHandle;
    if (!handle) return;
    var allReviews = [],
      currentFilter = "most-recent",
      visibleCount = 4;
    fetch(
      "/apps/reviews/product-reviews?handle=" +
        encodeURIComponent(handle) +
        (section.dataset.productId
          ? "&product_id=" + encodeURIComponent(section.dataset.productId)
          : ""),
    )
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (data) {
        if (data) {
          Array.isArray(data) && (data = { reviews: data });
          var reviews = (data.reviews || []).filter(function (r) {
            return !r.video_url;
          });
          reviews.length &&
            ((allReviews = reviews),
            updateHeader(reviews),
            renderReviews(reviews));
        }
      })
      .catch(function () {});
    function esc(s) {
      var d = document.createElement("div");
      return ((d.textContent = s || ""), d.innerHTML);
    }
    function starsSvg(rating, size) {
      for (var html = "", i = 1; i <= 5; i++)
        html +=
          '<svg width="' +
          size +
          '" height="' +
          size +
          '" viewBox="0 0 24 24" fill="' +
          (i <= rating ? "var(--color-primary)" : "var(--color-border)") +
          '" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
      return html;
    }
    function updateHeader(reviews, apiAvg, apiTotal, ratingDist) {
      var total = apiTotal ?? reviews.length,
        avg =
          apiAvg != null
            ? parseFloat(apiAvg).toFixed(1)
            : total > 0
              ? (
                  reviews.reduce(function (a, r) {
                    return a + (r.rating || 5);
                  }, 0) / total
                ).toFixed(1)
              : "5.0",
        roundedAvg = Math.round(parseFloat(avg)),
        avgEl = document.getElementById("reviews-avg-rating"),
        countEl = document.getElementById("reviews-count-text"),
        starsEl = document.getElementById("reviews-stars");
      (avgEl && (avgEl.textContent = avg),
        countEl && (countEl.textContent = total + " reviews"),
        starsEl && (starsEl.innerHTML = starsSvg(roundedAvg, 13)));
      var distEl = document.getElementById("reviews-distribution");
      if (distEl && total > 0) {
        var dist = ratingDist;
        dist ||
          ((dist = [0, 0, 0, 0, 0]),
          reviews.forEach(function (r) {
            var s2 = Math.min(5, Math.max(1, r.rating || 5));
            dist[s2 - 1]++;
          }));
        for (var distHtml = "", s = 5; s >= 1; s--) {
          var count = dist[s - 1] || 0,
            pct = total > 0 ? Math.round((count / total) * 100) : 0;
          distHtml +=
            '<div class="reviews-dist-row"><span class="reviews-dist-label">' +
            s +
            '</span><svg width="9" height="9" viewBox="0 0 24 24" fill="var(--color-accent)" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg><div class="reviews-dist-bar"><div class="reviews-dist-fill" style="width:' +
            pct +
            '%"></div></div><span class="reviews-dist-pct">' +
            pct +
            "%</span></div>";
        }
        distEl.innerHTML = distHtml;
      }
      var pdpStarsEl = document.getElementById("pdp-stars"),
        pdpTextEl = document.getElementById("pdp-rating-text"),
        pdpBtn = pdpStarsEl ? pdpStarsEl.closest("button") : null;
      pdpTextEl &&
        (!pdpTextEl.textContent.trim() ||
          pdpTextEl.textContent.trim() === "(0 Reviews)") &&
        (pdpStarsEl && (pdpStarsEl.innerHTML = starsSvg(roundedAvg, 12)),
        (pdpTextEl.textContent = avg + " · " + total + " reviews"),
        pdpBtn && total > 0 && (pdpBtn.style.display = ""));
    }
    function reviewFooterHtml(r, isHero) {
      var initials = (r.name || "A")
          .split(" ")
          .map(function (w) {
            return w.charAt(0).toUpperCase();
          })
          .join(""),
        checkSize = isHero ? 9 : 8,
        heartSize = isHero ? 13 : 12,
        html = '<div class="review-card-v2__footer">';
      ((html +=
        '<div class="review-card-v2__avatar">' + esc(initials) + "</div>"),
        (html += '<div style="min-width:0;">'),
        (html += '<div style="display:flex;align-items:center;gap:0.375rem;">'),
        (html +=
          '<span class="review-card-v2__name">' +
          esc(r.name || "Customer") +
          "</span>"),
        r.verified &&
          (html +=
            '<span class="review-card-v2__verified"><svg width="' +
            checkSize +
            '" height="' +
            checkSize +
            '" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg>Verified</span>'),
        (html += "</div>"));
      var metaParts = [];
      return (
        r.location && metaParts.push(esc(r.location)),
        r.date && metaParts.push(esc(r.date)),
        metaParts.length &&
          (html +=
            '<span class="review-card-v2__meta">' +
            metaParts.join(" &middot; ") +
            "</span>"),
        (html += "</div>"),
        (html +=
          '<span class="review-card-v2__helpful"><svg width="' +
          heartSize +
          '" height="' +
          heartSize +
          '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'),
        r.helpful_count && (html += esc("" + r.helpful_count)),
        (html += "</span>"),
        (html += "</div>"),
        html
      );
    }
    function renderReviews(reviews) {
      var contentEl = document.getElementById("reviews-content");
      if (contentEl) {
        var filtered =
          currentFilter === "with-photos"
            ? reviews.filter(function (r) {
                return (r.photos && r.photos.length > 0) || r.video_url;
              })
            : currentFilter === "most-helpful"
              ? reviews.slice().sort(function (a, b) {
                  return (b.helpful_count || 0) - (a.helpful_count || 0);
                })
              : reviews;
        filtered = filtered.slice().sort(function (a, b) {
          var aScore =
              a.video_url || (a.videos && a.videos.length)
                ? 2
                : a.photos && a.photos.length
                  ? 1
                  : 0,
            bScore =
              b.video_url || (b.videos && b.videos.length)
                ? 2
                : b.photos && b.photos.length
                  ? 1
                  : 0;
          return bScore - aScore;
        });
        for (var html = "", heroIdx = -1, h = 0; h < filtered.length; h++)
          if (
            (filtered[h].photos && filtered[h].photos.length) ||
            filtered[h].video_url
          ) {
            heroIdx = h;
            break;
          }
        if (heroIdx >= 0) {
          var hero = filtered[heroIdx],
            heroInitials = (hero.name || "A")
              .split(" ")
              .map(function (w) {
                return w.charAt(0).toUpperCase();
              })
              .join("");
          ((html += '<div class="review-hero-v2">'),
            (html += '<div class="review-hero-v2__img">'),
            hero.video_url
              ? (html +=
                  '<div style="position:relative;width:100%;height:100%;"><video src="' +
                  esc(hero.video_url) +
                  `" preload="metadata" style="width:100%;height:100%;object-fit:cover;" playsinline muted></video><div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.15);cursor:pointer;" onclick="var v=this.previousElementSibling;if(v.paused){v.muted=false;v.play();this.style.opacity='0'}else{v.pause();this.style.opacity='1'}"><svg width="36" height="36" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div></div>`)
              : (html +=
                  '<img src="' +
                  esc(hero.photos[0]) +
                  '" alt="Review photo" loading="lazy">'),
            (html +=
              '<div style="position:absolute;bottom:0.75rem;right:0.75rem;width:1.75rem;height:1.75rem;border-radius:50%;background:rgba(255,255,255,0.7);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#2D2D2D" stroke-width="1.5"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg></div>'),
            (html += "</div>"),
            (html += '<div class="review-hero-v2__body">'),
            (html +=
              '<div class="review-card-v2__quote" style="font-size:4rem;line-height:0.8;margin-bottom:0.5rem;">&ldquo;</div>'),
            (html +=
              '<p style="font-family:var(--font-heading);font-size:clamp(0.95rem,1.6vw,1.15rem);font-weight:400;color:var(--color-primary);line-height:1.8;margin-bottom:1.5rem;">' +
              esc(hero.text || hero.title || "") +
              "</p>"),
            (html +=
              '<div style="display:flex;gap:0.125rem;margin-bottom:1rem;">' +
              starsSvg(hero.rating || 5, 12) +
              "</div>"),
            (html += reviewFooterHtml(hero, !0)),
            (html += "</div>"),
            (html += "</div>"));
        }
        html +=
          '<div style="display:flex;align-items:center;gap:0.25rem;margin-bottom:2rem;overflow-x:auto;padding-bottom:0.25rem;">';
        var filterDefs = [
          { key: "most-recent", label: "Most Recent" },
          { key: "most-helpful", label: "Most Helpful" },
          { key: "with-photos", label: "With Photos" },
        ];
        (filterDefs.forEach(function (f) {
          var isActive = currentFilter === f.key;
          html +=
            '<button class="review-filter-pill' +
            (isActive ? " is-active" : "") +
            '" data-review-filter="' +
            f.key +
            '">' +
            f.label +
            "</button>";
        }),
          (html += "</div>"));
        var gridItems = filtered.filter(function (_, i) {
            return i !== heroIdx;
          }),
          showing = gridItems.slice(0, visibleCount);
        ((html += '<div class="review-grid">'),
          showing.forEach(function (r) {
            var hasPhoto = r.photos && r.photos.length > 0,
              hasVideo = r.video_url || (r.videos && r.videos.length);
            if (hasPhoto || hasVideo) {
              if (
                ((html += '<div class="review-card-v2 review-card-v2--photo">'),
                (html += '<div class="review-card-v2__img">'),
                hasVideo)
              ) {
                var vidUrl = r.video_url || (r.videos && r.videos[0]) || "";
                html +=
                  '<div style="position:relative;width:100%;height:100%;"><video src="' +
                  esc(vidUrl) +
                  `" preload="metadata" style="width:100%;height:100%;object-fit:cover;" playsinline muted></video><div style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.15);cursor:pointer;" onclick="var v=this.previousElementSibling;if(v.paused){v.muted=false;v.play();this.style.opacity='0'}else{v.pause();this.style.opacity='1'}"><svg width="28" height="28" viewBox="0 0 24 24" fill="rgba(255,255,255,0.9)" stroke="none"><polygon points="5 3 19 12 5 21 5 3"/></svg></div></div>`;
              } else
                html +=
                  '<img src="' +
                  esc(r.photos[0]) +
                  '" alt="Review photo" loading="lazy">';
              ((html += "</div>"),
                (html += '<div class="review-card-v2__body">'));
            } else
              ((html += '<div class="review-card-v2">'),
                (html += '<div class="review-card-v2__body">'),
                (html += '<div class="review-card-v2__quote">&ldquo;</div>'));
            ((html +=
              '<div style="display:flex;gap:0.125rem;margin-bottom:0.625rem;">' +
              starsSvg(r.rating || 5, 11) +
              "</div>"),
              (html +=
                '<p class="review-card-v2__text">&ldquo;' +
                esc(r.text || r.title || "") +
                "&rdquo;</p>"),
              (html += reviewFooterHtml(r)),
              (html += "</div>"),
              (html += "</div>"));
          }),
          (html += "</div>"));
        var hasMore = gridItems.length > visibleCount;
        ((html +=
          '<div class="review-ctas-wrap" style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1rem;margin-top:2.5rem;">'),
          hasMore &&
            (html +=
              '<button id="reviews-load-more" class="review-cta-outlined">LOAD MORE REVIEWS</button>'),
          (html +=
            '<button id="reviews-write" class="review-cta-filled">WRITE A REVIEW</button>'),
          (html += "</div>"),
          (contentEl.innerHTML = html),
          bindFilters(),
          bindLoadMore(),
          bindWriteReview());
      }
    }
    function bindFilters() {
      document.querySelectorAll(".review-filter-pill").forEach(function (btn) {
        btn.addEventListener("click", function () {
          (document
            .querySelectorAll(".review-filter-pill")
            .forEach(function (b) {
              b.classList.remove("is-active");
            }),
            btn.classList.add("is-active"),
            (currentFilter = btn.dataset.reviewFilter || "most-recent"),
            (visibleCount = 4),
            renderReviews(allReviews));
        });
      });
    }
    function bindLoadMore() {
      var btn = document.getElementById("reviews-load-more");
      btn &&
        btn.addEventListener("click", function () {
          ((visibleCount += 2), renderReviews(allReviews));
        });
    }
    function bindWriteReview() {
      var btn = document.getElementById("reviews-write");
      btn &&
        btn.addEventListener("click", function () {
          openWriteReviewModal();
        });
    }
    function openWriteReviewModal() {
      var modal = document.getElementById("write-review-modal");
      modal &&
        (modal.setAttribute("aria-hidden", "false"),
        (document.body.style.overflow = "hidden"),
        initWriteReviewModal());
    }
    window.openWriteReviewModal = openWriteReviewModal;
    function closeWriteReviewModal() {
      var modal = document.getElementById("write-review-modal");
      modal &&
        (modal.setAttribute("aria-hidden", "true"),
        (document.body.style.overflow = ""),
        setTimeout(function () {
          var success = document.getElementById("wr-success"),
            header = document.getElementById("wr-header"),
            body = document.getElementById("wr-body"),
            footer = document.getElementById("wr-footer");
          (success && (success.style.display = "none"),
            header && (header.style.display = ""),
            body && (body.style.display = ""),
            footer && (footer.style.display = ""));
          var form = document.getElementById("wr-form");
          (form && form.reset(),
            document
              .querySelectorAll("#wr-stars .wr-star svg")
              .forEach(function (svg) {
                (svg.setAttribute("fill", "none"),
                  svg.setAttribute("stroke", "#E8E2D9"));
              }));
          var ratingLabel = document.getElementById("wr-rating-label");
          ratingLabel && (ratingLabel.textContent = "");
          var charCount = document.getElementById("wr-char-count");
          charCount && (charCount.textContent = "0/1000");
          var photosWrap = document.getElementById("wr-photos-wrap");
          if (photosWrap) {
            photosWrap
              .querySelectorAll(".wr-photo-preview")
              .forEach(function (p) {
                p.remove();
              });
            var addBtn = document.getElementById("wr-add-photo");
            addBtn && (addBtn.style.display = "");
          }
          var fitDot = document.getElementById("wr-fit-dot");
          (fitDot && (fitDot.style.left = "50%"),
            document.querySelectorAll(".wr-fit-btn").forEach(function (b, i) {
              b.classList.toggle("wr-fit-btn--active", i === 1);
            }),
            document.querySelectorAll(".wr-size-btn").forEach(function (b) {
              b.classList.remove("wr-size-btn--active");
            }),
            document
              .querySelectorAll(".wr-recommend-btn")
              .forEach(function (b) {
                b.classList.toggle(
                  "wr-recommend-btn--active",
                  b.dataset.recommend === "yes",
                );
              }));
          var error = document.getElementById("wr-error");
          error && ((error.style.display = "none"), (error.textContent = ""));
          var submit = document.getElementById("wr-submit");
          submit &&
            ((submit.disabled = !1), (submit.textContent = "SUBMIT REVIEW"));
        }, 300));
    }
    var _wrModalInitialized = !1;
    function initWriteReviewModal() {
      if (_wrModalInitialized) return;
      _wrModalInitialized = !0;
      var modal = document.getElementById("write-review-modal");
      if (!modal) return;
      var currentRating = 0,
        currentFit = 1,
        currentSize = "",
        currentRecommend = "yes",
        photos = [],
        RATING_LABELS = ["", "Poor", "Fair", "Good", "Great", "Excellent"],
        FIT_POSITIONS = [8, 50, 92];
      (modal
        .querySelector(".wr-modal__backdrop")
        .addEventListener("click", closeWriteReviewModal),
        modal.querySelectorAll("[data-wr-close]").forEach(function (btn) {
          btn.addEventListener("click", closeWriteReviewModal);
        }),
        document.addEventListener("keydown", function (e) {
          e.key === "Escape" &&
            modal.getAttribute("aria-hidden") === "false" &&
            closeWriteReviewModal();
        }));
      var starBtns = modal.querySelectorAll("#wr-stars .wr-star"),
        ratingLabel = document.getElementById("wr-rating-label");
      function updateStars(rating, isHover) {
        (starBtns.forEach(function (btn, idx) {
          var svg = btn.querySelector("svg"),
            i = idx + 1;
          i <= rating
            ? (svg.setAttribute(
                "fill",
                i <= currentRating && !isHover ? "#2D2D2D" : "#C4B5A0",
              ),
              svg.setAttribute(
                "stroke",
                i <= currentRating && !isHover ? "#2D2D2D" : "#C4B5A0",
              ))
            : (svg.setAttribute("fill", "none"),
              svg.setAttribute("stroke", "#E8E2D9"));
        }),
          ratingLabel &&
            (ratingLabel.textContent =
              rating > 0 ? RATING_LABELS[rating] : ""));
      }
      starBtns.forEach(function (btn) {
        (btn.addEventListener("mouseenter", function () {
          updateStars(parseInt(btn.dataset.star), !0);
        }),
          btn.addEventListener("mouseleave", function () {
            updateStars(currentRating, !1);
          }),
          btn.addEventListener("click", function () {
            ((currentRating = parseInt(btn.dataset.star)),
              updateStars(currentRating, !1));
          }));
      });
      var textArea = document.getElementById("wr-text"),
        charCount = document.getElementById("wr-char-count");
      textArea &&
        charCount &&
        textArea.addEventListener("input", function () {
          charCount.textContent = textArea.value.length + "/1000";
        });
      var fileInput = document.getElementById("wr-file-input"),
        addPhotoBtn = document.getElementById("wr-add-photo"),
        photosWrap = document.getElementById("wr-photos-wrap");
      addPhotoBtn &&
        fileInput &&
        (addPhotoBtn.addEventListener("click", function () {
          fileInput.click();
        }),
        fileInput.addEventListener("change", function () {
          var files = Array.from(fileInput.files || []);
          (files.forEach(function (file) {
            if (photos.length >= 3) return;
            var isImage = file.type.startsWith("image/"),
              isVideo = file.type.startsWith("video/");
            if (
              (!isImage && !isVideo) ||
              (isImage && file.size > 5 * 1024 * 1024) ||
              (isVideo && file.size > 50 * 1024 * 1024)
            )
              return;
            function addPreview(previewHtml) {
              if (!(photos.length >= 3)) {
                photos.push(file);
                var preview = document.createElement("div");
                ((preview.className = "wr-photo-preview"),
                  (preview.innerHTML =
                    previewHtml +
                    '<button type="button" class="wr-photo-remove" aria-label="Remove">&times;</button>'),
                  preview
                    .querySelector(".wr-photo-remove")
                    .addEventListener("click", function () {
                      var idx = Array.from(
                        photosWrap.querySelectorAll(".wr-photo-preview"),
                      ).indexOf(preview);
                      (idx >= 0 && photos.splice(idx, 1),
                        preview.remove(),
                        photos.length < 3 &&
                          addPhotoBtn &&
                          (addPhotoBtn.style.display = ""));
                    }),
                  photosWrap.insertBefore(preview, addPhotoBtn),
                  photos.length >= 3 &&
                    addPhotoBtn &&
                    (addPhotoBtn.style.display = "none"));
              }
            }
            if (isVideo) {
              var vidUrl = URL.createObjectURL(file);
              addPreview(
                '<video src="' +
                  vidUrl +
                  '" style="width:100%;height:100%;object-fit:cover;" muted playsinline></video>',
              );
            } else {
              var reader = new FileReader();
              ((reader.onload = function (ev) {
                addPreview('<img src="' + ev.target.result + '" alt="">');
              }),
                reader.readAsDataURL(file));
            }
          }),
            (fileInput.value = ""));
        }));
      var fitDot = document.getElementById("wr-fit-dot");
      (modal.querySelectorAll(".wr-fit-btn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          ((currentFit = parseInt(btn.dataset.fit)),
            fitDot && (fitDot.style.left = FIT_POSITIONS[currentFit] + "%"),
            modal.querySelectorAll(".wr-fit-btn").forEach(function (b) {
              b.classList.toggle(
                "wr-fit-btn--active",
                parseInt(b.dataset.fit) === currentFit,
              );
            }));
        });
      }),
        modal.querySelectorAll(".wr-size-btn").forEach(function (btn) {
          btn.addEventListener("click", function () {
            ((currentSize = btn.dataset.size),
              modal.querySelectorAll(".wr-size-btn").forEach(function (b) {
                b.classList.toggle(
                  "wr-size-btn--active",
                  b.dataset.size === currentSize,
                );
              }));
          });
        }),
        modal.querySelectorAll(".wr-recommend-btn").forEach(function (btn) {
          btn.addEventListener("click", function () {
            ((currentRecommend = btn.dataset.recommend),
              modal.querySelectorAll(".wr-recommend-btn").forEach(function (b) {
                b.classList.toggle(
                  "wr-recommend-btn--active",
                  b.dataset.recommend === currentRecommend,
                );
              }));
          });
        }));
      var form = document.getElementById("wr-form"),
        errorEl = document.getElementById("wr-error"),
        submitBtn = document.getElementById("wr-submit");
      form.addEventListener("submit", function (e) {
        (e.preventDefault(),
          errorEl &&
            ((errorEl.style.display = "none"), (errorEl.textContent = "")));
        var title = document.getElementById("wr-title").value.trim(),
          text = document.getElementById("wr-text").value.trim(),
          name = document.getElementById("wr-name").value.trim(),
          location = document.getElementById("wr-location").value.trim(),
          email = document.getElementById("wr-email").value.trim();
        if (!currentRating) {
          showError("Please select a star rating.");
          return;
        }
        if (!text) {
          showError("Please write your review.");
          return;
        }
        if (!name) {
          showError("Please enter your name.");
          return;
        }
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showError("Please enter a valid email address.");
          return;
        }
        submitBtn &&
          ((submitBtn.disabled = !0), (submitBtn.textContent = "UPLOADING..."));
        var reviewSection = document.querySelector(
            ".reviews-section[data-product-handle]",
          ),
          productHandle = reviewSection
            ? reviewSection.dataset.productHandle
            : "";
        function stageUpload(file) {
          var params =
            "filename=" +
            encodeURIComponent(file.name) +
            "&type=" +
            encodeURIComponent(file.type) +
            "&size=" +
            file.size;
          return fetch("/apps/reviews/upload-url?" + params)
            .then(function (r) {
              return r.json();
            })
            .then(function (data) {
              if (data.error) throw new Error(data.error);
              var fd = new FormData();
              return (
                (data.parameters || []).forEach(function (p) {
                  fd.append(p.name, p.value);
                }),
                fd.append("file", file),
                fetch(data.url, { method: "POST", body: fd }).then(function () {
                  return data.resourceUrl;
                })
              );
            });
        }
        var photoFiles = photos.filter(function (f) {
            return f.type && f.type.startsWith("image/");
          }),
          videoFile = photos.find(function (f) {
            return f.type && f.type.startsWith("video/");
          }),
          uploadPromises = photoFiles.map(function (f) {
            return stageUpload(f);
          }),
          videoPromise = videoFile
            ? stageUpload(videoFile)
            : Promise.resolve("");
        Promise.all([Promise.all(uploadPromises), videoPromise])
          .then(function (results) {
            var photoUrls = results[0],
              videoUrl = results[1];
            submitBtn && (submitBtn.textContent = "SUBMITTING...");
            var payload = {
              rating: currentRating,
              title,
              body: text,
              name,
              email,
              location,
              product_handle: productHandle,
              fit: ["small", "true_to_size", "large"][currentFit],
              size: currentSize,
              recommend: currentRecommend,
              photos: photoUrls,
              video_url: videoUrl,
            };
            return fetch("/apps/reviews/submit", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(payload),
            }).then(function (r) {
              return r.json();
            });
          })
          .then(function (data) {
            if (data && data.error) {
              (showError(data.error),
                submitBtn &&
                  ((submitBtn.disabled = !1),
                  (submitBtn.textContent = "SUBMIT REVIEW")));
              return;
            }
            showSuccess();
          })
          .catch(function (err) {
            (showError(
              err.message || "Something went wrong. Please try again.",
            ),
              submitBtn &&
                ((submitBtn.disabled = !1),
                (submitBtn.textContent = "SUBMIT REVIEW")));
          });
      });
      function showError(msg) {
        errorEl &&
          ((errorEl.textContent = msg), (errorEl.style.display = "block"));
      }
      function showSuccess() {
        var success = document.getElementById("wr-success"),
          header = document.getElementById("wr-header"),
          body = document.getElementById("wr-body"),
          footer = document.getElementById("wr-footer");
        (success && (success.style.display = ""),
          header && (header.style.display = "none"),
          body && (body.style.display = "none"),
          footer && (footer.style.display = "none"));
      }
    }
  }
  function formatMoney(cents) {
    return formatThemeMoney(cents);
  }
  function initQuickAdd() {
    (document.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-quick-add]");
      if (
        btn &&
        (e.preventDefault(),
        e.stopPropagation(),
        !btn.classList.contains("is-loading"))
      ) {
        if (btn.dataset.hasOptions === "1" && btn.dataset.productHandle) {
          var quickShop = window.DN2 && window.DN2.quickShop;
          if (quickShop && quickShop.open) {
            quickShop.open(btn.dataset.productHandle, [btn.dataset.productHandle], 0, {
              variantId: btn.dataset.quickAdd,
            });
          } else {
            window.location.href =
              route("products/" + encodeURIComponent(btn.dataset.productHandle));
          }
          return;
        }
        var variantId = btn.dataset.quickAdd;
        variantId &&
          (btn.classList.add("is-loading"),
          (function rty(n) {
            return fetch(route("cart/add.js"), {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }),
            })
              .then(function (r) {
                if (!r.ok) throw r;
                return r.json();
              })
              ["catch"](function (e) {
                if (n > 0)
                  return new Promise(function (res) {
                    setTimeout(res, 400);
                  }).then(function () {
                    return rty(n - 1);
                  });
                throw e;
              });
          })(2)
            .then(function () {
              (btn.classList.remove("is-loading"),
                btn.classList.add("is-added"),
                (btn.innerHTML =
                  '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg> Added'),
                document.dispatchEvent(new CustomEvent("cart:refresh")),
                setTimeout(function () {
                  (btn.classList.remove("is-added"),
                    (btn.innerHTML =
                      '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> Quick Add'));
                }, 2e3));
            })
            .catch(function () {
              btn.classList.remove("is-loading");
            }));
      }
    }));
  }
  function initProductCritical() {
    initProductGallery();
    const dynamicBundle = document.querySelector(
      '.bundle-tiers[data-dynamic="true"]',
    );
    if (dynamicBundle) {
      let built = !1;
      try {
        built = buildDynamicBundleTiers();
      } catch {
        built = !1;
      }
      (built || dynamicBundle.removeAttribute("data-dynamic"),
        dynamicBundle.removeAttribute("data-bundle-pending"),
        dynamicBundle.classList.add("is-ready"));
    }
    const bundleContainer = document.querySelector(".bundle-tiers");
    (bundleContainer &&
      (bundleContainer.removeAttribute("data-bundle-pending"),
      bundleContainer.classList.add("is-ready")),
      initBundleTiers());
  }
  function initHomeMotion() {
    (initHeroCarousel(), initHeroParallax(), initMarquee());
    if (window.__DN_HOME_MOTION_EVENTS__) return;
    window.__DN_HOME_MOTION_EVENTS__ = !0;
    (document.addEventListener("shopify:section:load", function () {
      (initHeroCarousel(), initHeroParallax(), initMarquee());
    }),
      document.addEventListener("shopify:section:select", function () {
        (initHeroCarousel(), initHeroParallax(), initMarquee());
      }),
      document.addEventListener("shopify:section:unload", function (event) {
        const root = event.target;
        if (!root || !root.querySelectorAll) return;
        const hero =
          root.matches && root.matches(".hero")
            ? root
            : root.querySelector(".hero");
        if (hero) {
          hero.__dnHeroLifecycle && hero.__dnHeroLifecycle.destroy();
          hero.__dnHeroParallax && hero.__dnHeroParallax.destroy();
        }
        root.querySelectorAll(".marquee__track").forEach(function (track) {
          track.__dnMarqueeLifecycle && track.__dnMarqueeLifecycle.destroy();
        });
      }));
  }
  function initAll() {
    (initProductCritical(),
      initScrollReveal(),
      initScrollHoverGuard(),
      initStickyHeader(),
      initHeaderMenuFallback(),
      initNavOverlay(),
      initPageScrollbar(),
      initHomeMotion(),
      initAccordions(),
      initLookbookHotspots(),
      initLookbookEditor(),
      CartDrawer.init(),
      initAddToCart(),
      initDayNightSlider(),
      initUpsellToggles(),
      initGiftSection(),
      initSizeSelector(),
      initFloatingATC(),
      initMagneticButtons(),
      initColorSwatches(),
      initContextualGreeting(),
      repairStaleCollectionCache(),
      initCollectionFreshLinks(),
      hydrateCollectionPinned(),
      initCollectionFilters(),
      initQuickAdd(),
      initUGCLightbox(),
      initUGCFromReviews(),
      initProductReviews());
  }
  function initProductSection() {
    (initProductCritical(),
      initScrollReveal(),
      initAccordions(),
      initAddToCart(),
      initDayNightSlider(),
      initUpsellToggles(),
      initGiftSection(),
      initSizeSelector(),
      initFloatingATC(),
      initColorSwatches(),
      initUGCLightbox(),
      initUGCFromReviews(),
      initProductReviews(),
      initMagneticButtons());
  }
  (initProductCritical(),
    bdPctFill(document),
    repairStaleCollectionCache(),
    document.addEventListener("DOMContentLoaded", initAll),
    document.addEventListener("DOMContentLoaded", function () {
      bdPctFill(document);
    }),
    document.addEventListener("shopify:section:load", function (e) {
      bdPctFill(e.target || document);
    }),
    document.addEventListener("shopify:section:load", function (e) {
      (initProductSection(),
        e.target &&
          e.target.querySelector &&
          e.target.querySelector(".lookbook") &&
          (initLookbookHotspots(), initLookbookEditor()));
    }),
    document.addEventListener("shopify:section:select", function (e) {
      initProductSection();
    }),
    document.addEventListener("shopify:block:select", function (e) {
      var el = e.target;
      el && el.scrollIntoView({ behavior: "smooth", block: "center" });
    }));
})(); //# sourceMappingURL=/cdn/shop/t/6/assets/theme.collection-pins-20260620.js.map?v=202606291700
/* Shared motion truth for Hero, marquee, announcement, and popup coverage. */
(function () {
  "use strict";
  if (window.DNMotionLifecycle) {
    window.DNMotionLifecycle.refresh();
    return;
  }
  var subscribers = new Set();
  var reduceQuery = window.matchMedia
    ? window.matchMedia("(prefers-reduced-motion: reduce)")
    : null;
  var popup = null;
  var popupObserver = null;
  var state = null;
  var diagnostics = {
    listenerInstalls: 1,
    popupObserverInstalls: 0,
    activePopupObservers: 0,
    updates: 0,
  };

  function popupCovered() {
    return !!(popup && !popup.hidden && popup.classList.contains("is-open"));
  }

  function snapshot() {
    var visible = document.visibilityState === "visible";
    var reduced = !!(reduceQuery && reduceQuery.matches);
    var covered = popupCovered();
    return {
      visible: visible,
      reduced: reduced,
      popupCovered: covered,
      active: visible && !reduced && !covered,
    };
  }

  function same(a, b) {
    return (
      !!a &&
      a.visible === b.visible &&
      a.reduced === b.reduced &&
      a.popupCovered === b.popupCovered &&
      a.active === b.active
    );
  }

  function publish(force) {
    var next = snapshot();
    document.documentElement.classList.toggle(
      "dn-motion-page-hidden",
      !next.visible,
    );
    document.documentElement.classList.toggle(
      "dn-motion-reduced",
      next.reduced,
    );
    document.documentElement.classList.toggle(
      "dn-motion-popup-covered",
      next.popupCovered,
    );
    if (!force && same(state, next)) return;
    state = next;
    diagnostics.updates += 1;
    subscribers.forEach(function (subscriber) {
      try {
        subscriber(state);
      } catch (error) {}
    });
    try {
      document.dispatchEvent(
        new CustomEvent("dn:motionchange", { detail: state }),
      );
    } catch (error) {}
  }

  function observePopup() {
    var nextPopup = document.querySelector("[data-dn-pop]");
    if (nextPopup === popup) return;
    if (popupObserver) popupObserver.disconnect();
    popupObserver = null;
    popup = nextPopup;
    diagnostics.activePopupObservers = 0;
    if (popup && window.MutationObserver) {
      popupObserver = new MutationObserver(function () {
        publish(false);
      });
      popupObserver.observe(popup, {
        attributes: true,
        attributeFilter: ["class", "hidden"],
      });
      diagnostics.popupObserverInstalls += 1;
      diagnostics.activePopupObservers = 1;
    }
    publish(true);
  }

  function subscribe(subscriber) {
    subscribers.add(subscriber);
    subscriber(state || snapshot());
    return function () {
      subscribers.delete(subscriber);
    };
  }

  document.addEventListener("visibilitychange", function () {
    publish(false);
  });
  document.addEventListener("shopify:section:load", function () {
    observePopup();
  });
  document.addEventListener("shopify:section:unload", function () {
    observePopup();
  });
  if (reduceQuery) {
    if (reduceQuery.addEventListener)
      reduceQuery.addEventListener("change", function () {
        publish(false);
      });
    else if (reduceQuery.addListener)
      reduceQuery.addListener(function () {
        publish(false);
      });
  }

  window.DNMotionLifecycle = {
    snapshot: function () {
      return Object.assign({}, state || snapshot());
    },
    subscribe: subscribe,
    refresh: function () {
      observePopup();
      publish(true);
    },
    diagnostics: function () {
      return Object.assign({}, diagnostics, {
        subscriberCount: subscribers.size,
      });
    },
  };
  observePopup();
})();
